/**
 * LUXVONO MULTILINGUAL TRANSLATION SYSTEM
 * High-End Luxury Sovereign Translation Engine supporting 14 global languages and dialects.
 */

export const SUPPORTED_LANGUAGES = [
    { code: 'ar', name: 'العربية', nativeName: 'العربية', flag: '🇸🇦', isRTL: true },
    { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧', isRTL: false },
    { code: 'so', name: 'Somali', nativeName: 'Af-Soomaali', flag: '🇸🇴', isRTL: false },
    { code: 'am', name: 'Amharic', nativeName: 'አማርኛ (Ethiopia)', flag: '🇪🇹', isRTL: false },
    { code: 'gdq', name: 'Mehri', nativeName: 'اللسان المهري', flag: '🇴🇲', isRTL: true },
    { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', isRTL: false },
    { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', isRTL: false },
    { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', isRTL: false },
    { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', isRTL: false },
    { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', isRTL: false },
    { code: 'zh', name: 'Chinese', nativeName: '简体中文', flag: '🇨🇳', isRTL: false },
    { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', isRTL: false },
    { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷', isRTL: false },
    { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', isRTL: false }
];

export const translations = {
    "en": {
        "HOME": "HOME",
        "COLLECTIONS": "COLLECTIONS",
        "VIDEO_COMMERCE": "VIDEO THEATER",
        "NAV_VIP": "VIP LOUNGE",
        "NAV_LIVE": "LIVE SHOWCASE",
        "NAV_MAGAZINE": "THE CHRONICLE",
        "NAV_SOURCING": "BESPOKE SOURCING",
        "SEARCH_PLACEHOLDER": "Search our luxury collections...",
        "CART": "CART",
        "ORDERS": "ACQUISITIONS",
        "LIVE_AUDIO": "LIVE AUDIO",
        "CONTACT": "CONTACT CONCIERGE",
        "SECURE_CHECKOUT": "Secured Checkout",
        "LOGOUT": "Logout",
        "SIGN_IN": "Sign In",
        "LOGIN": "Sign In",
        "REGISTER": "Create Account",
        "WELCOME_GUEST": "Welcome, Guest",
        "WELCOME": "Welcome",
        "REGIONAL_SETTINGS": "Regional Preferences",
        "SHIP_TO": "Destination (Auto)",
        "LANGUAGE": "Language",
        "CURRENCY": "Currency",
        "REDEFINING": "REDEFINING EXCELLENCE",
        "EXPLORE_COLLECTION": "Discover the Collection",
        "AUTHENTIC_BRANDS": "Guaranteed Authentic Icons",
        "ENCRYPTED_CHECKOUT": "Secured Encryption Protocols",
        "CONCIERGE_SUPPORT": "24/7 Dedicated Concierge Support",
        "ADD_TO_CART": "Add to Bag",
        "ADD_TO_CART_BTN": "ADD TO BAG",
        "BUY_NOW": "Acquire Now",
        "NEW_ARRIVALS": "New Creations",
        "NEW_ARRIVALS_SUB": "Just dropped — fresh luxury additions to our collection",
        "NEW_PRODUCTS": "New Arrivals",
        "NEW": "NEW",
        "TRENDING": "Highly Coveted",
        "POPULAR": "Popular",
        "URGENCY": "Golden Opportunity",
        "FLASH_SALE": "Flash Deals & Offers",
        "FLASH_SALE_SUB": "Limited-time deals — grab them before they are gone!",
        "BEST_SELLERS": "Best Sellers",
        "BEST_SELLERS_SUB": "Most coveted creations based on client acquisitions",
        "HOME_CURATED": "Trending Luxury",
        "HOME_TRENDING_TITLE": "Trending Luxury",
        "HOME_TRENDING_DESC": "Discover the most coveted luxury creations curated globally",
        "HOME_TRENDING_SUB": "Handpicked favorites our discerning clients love",
        "HOME_FLASH_TITLE": "Flash Deals & Offers",
        "HOME_FLASH_DESC": "Exclusive limited-time reductions on handpicked luxury items",
        "HOME_FREE_SHIP_TITLE": "Complimentary Global Shipping",
        "HOME_FREE_SHIP_DESC": "Insured express delivery worldwide on all signature orders",
        "SHOP_NOW": "Explore Now",
        "EXPLORE": "Discover",
        "RECOMMENDED": "CURATED FOR YOU",
        "VIEW_ALL": "View Exhibition",
        "BACK": "Return",
        "GIFT_WRAPPING": "Signature complimentary gift wrapping",
        "FREE_SHIPPING": "Complimentary priority global transit",
        "WARRANTY": "Two-year signature Luxvono warranty",
        "TRACKED_SHIPPING": "Insured Priority Tracking",
        "EASY_RETURNS": "The Seamless Return Privilege",
        "YOUR_CART": "YOUR SELECTIONS",
        "CART_EMPTY": "Your collection is currently empty.",
        "CONTINUE_SHOPPING": "Return to Gallery",
        "ORDER_SUMMARY": "Acquisition Summary",
        "SUBTOTAL": "Subtotal",
        "SHIPPING": "Priority Transit",
        "COMPLIMENTARY": "With Our Compliments",
        "TOTAL": "Total",
        "PROCEED_CHECKOUT": "PROCEED TO ACQUISITION",
        "CHECKOUT": "Acquisition",
        "EMPTY_CART": "Your private collection is waiting to be curated.",
        "MY_ACCOUNT": "Portfolio",
        "MY_ORDERS": "Acquisitions",
        "OFFERS": "Private Offerings",
        "SUPPORT": "Concierge",
        "AI_ASSISTANT_TITLE": "Digital Advisor",
        "SUPPORT_CHAT": "VIP Concierge Office",
        "AI_WELCOME": "Welcome to LUXVONO. I am your Sovereign AI Advisor. How may I assist you today?",
        "AI_TYPING": "Digital Advisor is analyzing your request...",
        "SUPPORT_TYPING": "VIP Concierge is typing...",
        "LOGIN_VIEW_ORDERS": "Sign In to View Orders",
        "TYPE_TO_SUPPORT": "Message your dedicated concierge...",
        "ASK_ABOUT_PRODUCTS": "Inquire about horology, jewelry, or order status...",
        "SAVE": "Save Preferences",
        "CANCEL": "Cancel",
        "ALL_CATEGORIES": "All Categories",
        "BESPOKE_SOURCING": "Bespoke Sourcing",
        "VIP_LOUNGE": "VIP Lounge",
        "GUARANTEED_QUALITY": "100% Guaranteed Quality",
        "PREMIER_GLOBAL_PLATFORM": "Premier Global Sourcing & Luxury Platform",
        "WELCOME_TO_LUXVONO": "Welcome to LUXVONO",
        "JOIN_NOW": "Join Now",
        "LOGIN": "Log In",
        "SELL_WITH_US": "Sell with Us",
        "VENDOR_PORTAL": "Vendor Portal",
        "VENDOR_DASHBOARD": "Vendor Dashboard",
        "APPLY_NOW": "Apply Now",
        "SIGN_IN_ACCESS": "Sign in to access your luxury account",
        "SEARCH_PROMPT": "Search products, brands, categories...",
        "FULL_NAME_REQUIRED": "Full Legal Name *",
        "PHONE_REQUIRED": "Primary Contact Number *",
        "BACKUP_PHONE": "Alternative Contact Number (Optional)",
        "FULL_ADDRESS": "Detailed Address (Street, District, Building) *",
        "CITY": "City *",
        "COUNTRY": "Country *",
        "STREET": "Street & Building",
        "POSTAL_CODE": "Postal Code",
        "PAYMENT_METHOD": "Payment Method",
        "CREDIT_DEBIT_CARD": "Credit / Debit Card / Apple Pay",
        "PAY_CARD_DESC": "Instant and secure payment via direct payment gateway",
        "CASH_ON_DELIVERY": "Cash on Delivery",
        "PAY_CASH_DESC": "Direct payment upon personal white-glove delivery.",
        "MOBILE_WALLET": "Digital Wallets (STC Pay / Urpay)",
        "PAY_WALLET_DESC": "Instant transfer via approved digital wallets.",
        "BANK_TRANSFER": "Direct Bank Transfer",
        "PAY_BANK_DESC": "Direct Wire Transfer to official corporate bank accounts.",
        "UPLOAD_RECEIPT": "Attach Bank Transfer Receipt (Optional)",
        "PROCESSING_ORDER": "Processing your acquisition...",
        "PLACE_ORDER": "Confirm & Place Order",
        "TAX": "Estimated Tax / VAT",
        "QTY": "Quantity",
        "FOR_YOU": "Curated for You",
        "BACK_TO_FEED": "← Return to Gallery",
        "NO_CONTENT_FOUND": "No exclusive content found at this moment.",
        "PRIORITY_GLOBAL_DELIVERY": "Priority Global Delivery",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Fast & insured international transit",
        "SECURE_CHECKOUT_TITLE": "100% Secure Checkout",
        "SECURE_CHECKOUT_DESC": "Encrypted transactions & buyer shield",
        "CURATED_AUTHENTICITY": "Curated Authenticity",
        "CURATED_AUTHENTICITY_DESC": "Certified quality & rigorous vetting",
        "DEDICATED_CONCIERGE": "24/7 Dedicated Concierge",
        "DEDICATED_CONCIERGE_DESC": "Round-the-clock priority assistance",
        "CUSTOMER_CARE": "Customer Care",
        "TRACK_ORDER": "Track Order",
        "VIP_CLUB": "VIP Concierge Club",
        "HELP_SUPPORT": "Help & Support",
        "ABOUT_LUXVONO": "About LUXVONO",
        "ABOUT_US_VISION": "About Us & Vision",
        "SUPPLIER_PORTAL": "Supplier Portal",
        "LUXVONO_MAGAZINE": "LUXVONO Magazine",
        "TERMS_CONDITIONS": "Terms & Conditions",
        "PRIVACY_POLICY": "Privacy Policy",
        "SECURE_PAYMENTS": "Secure Payments",
        "CONTACT_CONCIERGE_BTN": "Contact VIP Concierge ✦",
        "DIRECT_VIP_PHONE": "Direct VIP Phone",
        "OFFICIAL_SUPPORT_EMAIL": "Official Support Email",
        "GLOBAL_STANDARDS": "Global Standards of Luxury Commerce",
        "CONNECT_WITH_US": "CONNECT WITH LUXVONO:",
        "EMAIL_ADDRESS": "Email Address",
        "PASSWORD": "Password",
        "FORGOT_PASSWORD": "Forgot password?",
        "AUTHENTICATING": "Authenticating...",
        "OR_CONTINUE_WITH": "Or continue with",
        "NEW_TO_LUXVONO": "New to LuxVono?",
        "CREATE_ACCOUNT_DESC": "Create an exclusive account today for priority pricing, fast shipping and tailored luxury service.",
        "CREATE_ACCOUNT_BTN": "Create an Account ✦",
        "JOIN_LUXVONO": "Join LUXVONO",
        "ENTER_EMAIL_START": "Enter your email address to get started with your private account.",
        "COMPLETE_SETUP": "Complete Account Setup",
        "VERIFY_EMAIL": "Verify Your Email",
        "ENTER_6DIGIT_CODE": "Enter the 6-digit code to activate your account",
        "SECURE_ACCOUNT": "Secure your luxury portfolio with standard encryption",
        "SENDING_CODE": "Sending code...",
        "CONTINUE": "Continue",
        "CODE_SENT_TO": "Enter the 6-digit code sent to:",
        "DIDNT_RECEIVE_CODE": "Didn't receive code? Resend in",
        "RESEND_VERIFICATION_CODE": "↻ Resend verification code",
        "VERIFY_CODE": "Verify Code",
        "VERIFYING": "Verifying...",
        "CHANGE_EMAIL": "Change Email Address",
        "FIRST_NAME": "First Name",
        "LAST_NAME": "Last Name",
        "PHONE_OPTIONAL": "Phone Number (Optional)",
        "PASSWORD_REQUIREMENTS": "Password must be at least 8 characters with letters & numbers.",
        "CREATING_ACCOUNT": "Creating account...",
        "CREATE_ACCOUNT_SIGN_IN": "Create Account & Sign In",
        "ALREADY_HAVE_ACCOUNT": "Already have an account?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Sign in to access your orders, track shipments and view your personalized wishlist.",
        "SIGN_IN_TO_ACCOUNT": "Sign in to Account →",
        "RESET_PASSWORD": "Reset Password",
        "FORGOT_PASSWORD_SUBTITLE": "Enter your email to receive a password reset verification code.",
        "NEW_PASSWORD": "New Password",
        "ENTER_NEW_PASSWORD": "Enter your new strong password below.",
        "SEND_RESET_LINK": "Send Verification Code",
        "REMEMBER_PASSWORD": "Remember Password?",
        "REMEMBER_PASSWORD_DESC": "You can return to the sign in page and continue shopping directly.",
        "BACK_TO_SIGN_IN": "Back to Sign In →",
        "STORE_RATING": "Store Rating",
        "ON_TIME_DELIVERY": "On-Time Del.",
        "RESPONSE_TIME": "Response Time",
        "CUSTOM_LOGO": "✓ Custom Logo",
        "CUSTOM_PACKAGING": "✓ Custom Packaging",
        "CUSTOMER_REVIEWS": "Customer Reviews & Feedback",
        "VIEW_REVIEWS": "View Reviews ✦",
        "WHOLESALE_ACTIVE": "Wholesale Tier Active",
        "LOWEST_PRICE_GUARANTEE": "🔥 Lowest Price Guarantee",
        "ALWAYS_AVAILABLE": "Always Available",
        "OUT_OF_STOCK": "Out of Stock",
        "ONLY_1_LEFT": "Only 1 item left!",
        "ONLY_FEW_LEFT": "Only few items left!",
        "LIMITED_QUANTITY": "Limited Quantities",
        "REMAINING_STOCK": "Remaining in Stock",
        "WHOLESALE_AVAILABLE": "💎 Wholesale Available",
        "ESTIMATED_DELIVERY": "Estimated Delivery",
        "PRODUCT_VIDEO_INCLUDED": "Product video included",
        "SCENT_SIGNATURE": "Scent Signature & Pyramid",
        "SCENT_FAMILY": "Scent Family:",
        "TOP_NOTES": "Top Notes",
        "HEART_NOTES": "Heart Notes",
        "BASE_NOTES": "Base Notes",
        "INGREDIENTS": "Ingredients:",
        "VEHICLE_SPECS": "Vehicle Performance Specs",
        "MODEL": "Model",
        "YEAR": "Year",
        "MILEAGE": "Mileage",
        "ENGINE": "Engine",
        "TRANSMISSION": "Transmission",
        "SHOWROOM_LOCATION": "VIP Collection Showroom",
        "UNMUTE": "Unmute 🔊",
        "MUTE": "Mute 🔇",
        "ZOOM_IN": "Zoom In",
        "ZOOM_OUT": "Zoom Out"
    },
    "ar": {
        "HOME": "الرئيسية",
        "COLLECTIONS": "المقتنيات الفاخرة",
        "VIDEO_COMMERCE": "سينما المقتنيات",
        "NAV_VIP": "صالون VIP",
        "NAV_LIVE": "البث الحي المباشر",
        "NAV_MAGAZINE": "المجلة الملكية",
        "NAV_SOURCING": "التوريد الحصري",
        "SEARCH_PLACEHOLDER": "ابحث في مقتنياتنا الملكية...",
        "CART": "الحقيبة",
        "ORDERS": "المقتنيات",
        "LIVE_AUDIO": "المجلس الصوتي",
        "CONTACT": "تواصل مع الكونسيرج",
        "SECURE_CHECKOUT": "دفع مشفر وآمن",
        "LOGOUT": "تسجيل الخروج",
        "SIGN_IN": "تسجيل الدخول",
        "LOGIN": "تسجيل الدخول",
        "REGISTER": "إنشاء حساب",
        "WELCOME_GUEST": "أهلاً بك يا ضيفنا الكريم",
        "WELCOME": "مرحباً بك",
        "REGIONAL_SETTINGS": "إعدادات الدولة واللغة",
        "SHIP_TO": "دولة الشحن والتوصيل",
        "LANGUAGE": "لغة العرض",
        "CURRENCY": "العملة المفضلة",
        "REDEFINING": "إعادة صياغة الفخامة المطلقة",
        "EXPLORE_COLLECTION": "استكشف التشكيلة",
        "AUTHENTIC_BRANDS": "أصالة موثقة بنسبة 100%",
        "ENCRYPTED_CHECKOUT": "دفع آمن ومعتمد بنكياً",
        "CONCIERGE_SUPPORT": "خدمة كونسيرج خاصة 24/7",
        "ADD_TO_CART": "إضافة إلى الحقيبة",
        "ADD_TO_CART_BTN": "إضافة إلى الحقيبة",
        "BUY_NOW": "اقتناء فوري",
        "NEW_ARRIVALS": "أحدث الإبداعات",
        "NEW_ARRIVALS_SUB": "أحدث التشكيلات والمنتجات الفاخرة المضافة حديثاً للمعرض",
        "NEW_PRODUCTS": "وصل حديثاً",
        "NEW": "جديد",
        "TRENDING": "الأكثر طلباً",
        "POPULAR": "الأكثر طلباً",
        "URGENCY": "فرصة ذهبية",
        "FLASH_SALE": "عروض حصرية خاطفة",
        "FLASH_SALE_SUB": "عروض وتخفيضات استثنائية لفترة محدودة — اغتنم الفرصة الآن",
        "BEST_SELLERS": "الأكثر مبيعاً",
        "BEST_SELLERS_SUB": "أرقى المقتنيات الأكثر اقتناءً من قبل كبار العملاء",
        "HOME_CURATED": "المقتنيات الأكثر رواجاً",
        "HOME_TRENDING_TITLE": "المقتنيات الأكثر رواجاً",
        "HOME_TRENDING_DESC": "اكتشف أحدث التشكيلات الفاخرة التي تم انتقاؤها بعناية",
        "HOME_TRENDING_SUB": "تشكيلات حصرية تحظى بإقبال كبار العملاء",
        "HOME_FLASH_TITLE": "عروض حصرية خاطفة",
        "HOME_FLASH_DESC": "خصومات استثنائية لفترة محدودة على سلع وماركات مختارة",
        "HOME_FREE_SHIP_TITLE": "شحن دولي مؤمن ومجاني",
        "HOME_FREE_SHIP_DESC": "خدمة التوصيل السريع لجميع أنحاء العالم مع ضمان الأصالة",
        "SHOP_NOW": "تسوق الآن",
        "EXPLORE": "استكشف الآن",
        "RECOMMENDED": "مختارات خاصة لك",
        "VIEW_ALL": "عرض المعرض بالكامل",
        "BACK": "رجوع",
        "GIFT_WRAPPING": "تغليف هدايا ملكي مجاني",
        "FREE_SHIPPING": "شحن عالمي مؤمن وأولوية مجاناً",
        "WARRANTY": "ضمان دولي معتمد من الدار",
        "TRACKED_SHIPPING": "تتبع لحظي مؤمن للشحنة",
        "EASY_RETURNS": "ميزة الإرجاع المرن السلس",
        "YOUR_CART": "حقيبة مقتنياتك",
        "CART_EMPTY": "حقيبتك فارغة حالياً.",
        "CONTINUE_SHOPPING": "العودة للمعرض",
        "ORDER_SUMMARY": "ملخص الاقتناء",
        "SUBTOTAL": "المجموع الفرعي",
        "SHIPPING": "الشحن والنقل",
        "COMPLIMENTARY": "مُهدى من الدار",
        "TOTAL": "الإجمالي",
        "PROCEED_CHECKOUT": "متابعة لإتمام الاقتناء",
        "CHECKOUT": "إتمام الاقتناء",
        "EMPTY_CART": "حقيبتك بانتظار تشكيلاتك الفاخرة.",
        "MY_ACCOUNT": "المحفظة الخاصة",
        "MY_ORDERS": "مقتنياتي",
        "OFFERS": "العروض الخاصة",
        "SUPPORT": "مكتب الكونسيرج",
        "AI_ASSISTANT_TITLE": "المستشار الرقمي",
        "SUPPORT_CHAT": "مكتب الكونسيرج الفاخر",
        "AI_WELCOME": "مرحباً بك في LUXVONO. أنا مستشارك الرقمي الخاص، كيف يمكنني إرشادك اليوم؟",
        "AI_TYPING": "المستشار الذكي يحلل طلبك الفاخر...",
        "SUPPORT_TYPING": "الكونسيرج يكتب...",
        "LOGIN_VIEW_ORDERS": "تسجيل الدخول لمتابعة طلبياتك",
        "TYPE_TO_SUPPORT": "أرسل رسالة للكونسيرج الخاص...",
        "ASK_ABOUT_PRODUCTS": "استفسر عن الساعات النادرة، المجوهرات، أو الشحن...",
        "SAVE": "حفظ الإعدادات",
        "CANCEL": "إلغاء",
        "ALL_CATEGORIES": "جميع الأقسام",
        "BESPOKE_SOURCING": "التوريد الحصري",
        "VIP_LOUNGE": "صالون VIP",
        "GUARANTEED_QUALITY": "100% جودة وأصالة مضمونة",
        "PREMIER_GLOBAL_PLATFORM": "منصة الاستيراد والتسوق الفاخرة",
        "WELCOME_TO_LUXVONO": "مرحباً بك في لوكسفونو",
        "JOIN_NOW": "انضم مجاناً",
        "LOGIN": "تسجيل الدخول",
        "SELL_WITH_US": "انضم كتاجر ومورد",
        "VENDOR_PORTAL": "لوحة المورد",
        "VENDOR_DASHBOARD": "لوحة تحكم التاجر",
        "APPLY_NOW": "قدم الآن",
        "SIGN_IN_ACCESS": "سجل الدخول للوصول لحسابك الفاخر",
        "SEARCH_PROMPT": "ابحث عن المنتجات، الماركات، والأقسام...",
        "FULL_NAME_REQUIRED": "الاسم الكامل للعميل *",
        "PHONE_REQUIRED": "رقم التواصل الأساسي *",
        "BACKUP_PHONE": "رقم تواصل احتياطي (اختياري)",
        "FULL_ADDRESS": "العنوان بالتفصيل (الشارع والحي ورقم المبنى) *",
        "CITY": "المدينة *",
        "COUNTRY": "الدولة *",
        "STREET": "الشارع والمبنى",
        "POSTAL_CODE": "الرمز البريدي",
        "PAYMENT_METHOD": "طريقة الدفع الفاخرة",
        "CREDIT_DEBIT_CARD": "بطاقة بنكية / مدى / فيزا / ماستركارد / أبل باي",
        "PAY_CARD_DESC": "دفع إلكتروني فوري ومؤمن عبر بوابة الدفع المباشرة",
        "CASH_ON_DELIVERY": "الدفع عند الاستلام (Cash on Delivery)",
        "PAY_CASH_DESC": "سداد نقدي عند التوصيل الشخصي الفاخر مع مندوب الكونسيرج.",
        "MOBILE_WALLET": "المحافظ الرقمية (STC Pay / Urpay)",
        "PAY_WALLET_DESC": "التحويل المباشر عبر المحافظ الإلكترونية المعتمدة.",
        "BANK_TRANSFER": "التحويل البنكي المباشر (Bank Transfer)",
        "PAY_BANK_DESC": "التحويل المباشر للحسابات البنكية المعتمدة للمؤسسة.",
        "UPLOAD_RECEIPT": "إرفاق إشعار التحويل البنكي (اختياري)",
        "PROCESSING_ORDER": "جاري معالجة وتأكيد طلبك الفاخر...",
        "PLACE_ORDER": "تأكيد ودفع الطلب الفاخر",
        "TAX": "ضريبة القيمة المضافة",
        "QTY": "الكمية",
        "FOR_YOU": "مختارات خاصة لك",
        "BACK_TO_FEED": "← العودة للمعرض",
        "NO_CONTENT_FOUND": "لا يوجد محتوى حصري متاح حالياً.",
        "PRIORITY_GLOBAL_DELIVERY": "شحن أولوية عالمي سريع",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "توصيل موثوق ومباشر لكافة الدول",
        "SECURE_CHECKOUT_TITLE": "دفع آمن وحماية 100%",
        "SECURE_CHECKOUT_DESC": "تشفير مصرفي معتمد وضمان كامل",
        "CURATED_AUTHENTICITY": "منتجات أصلية معتمدة",
        "CURATED_AUTHENTICITY_DESC": "فحص الجودة والمطابقة قبل الإرسال",
        "DEDICATED_CONCIERGE": "دعم كونسيرج 24/7",
        "DEDICATED_CONCIERGE_DESC": "مساعدة فورية من فريق مختص",
        "CUSTOMER_CARE": "خدمة العملاء",
        "TRACK_ORDER": "تتبع الطلب والشحنات",
        "VIP_CLUB": "نادي النخبة VIP",
        "HELP_SUPPORT": "مركز المساعدة والدعم",
        "ABOUT_LUXVONO": "عن لوكسفونو",
        "ABOUT_US_VISION": "من نحن وقصة الشركة",
        "SUPPLIER_PORTAL": "بوابة الموردين والشركاء",
        "LUXVONO_MAGAZINE": "مجلة لوكسفونو للأناقة",
        "TERMS_CONDITIONS": "الشروط والأحكام العامة",
        "PRIVACY_POLICY": "سياسة الخصوصية والأمان",
        "SECURE_PAYMENTS": "دفع آمن ومعتمد",
        "CONTACT_CONCIERGE_BTN": "تواصل مع الكونسيرج ✦",
        "DIRECT_VIP_PHONE": "الدعم الهاتفي والكونسيرج",
        "OFFICIAL_SUPPORT_EMAIL": "البريد الرسمي المعتمد",
        "GLOBAL_STANDARDS": "معايير الفخامة والجودة العالمية",
        "CONNECT_WITH_US": "تابع قنواتنا الرسمية:",
        "EMAIL_ADDRESS": "البريد الإلكتروني",
        "PASSWORD": "كلمة المرور",
        "FORGOT_PASSWORD": "نسيت كلمة المرور؟",
        "AUTHENTICATING": "جاري التحقق والدخول...",
        "OR_CONTINUE_WITH": "أو المتابعة عبر",
        "NEW_TO_LUXVONO": "عميل جديد في لوكسفونو؟",
        "CREATE_ACCOUNT_DESC": "أنشئ حسابك الفاخر الآن لتجربة تسوق استثنائية وعروض وخصومات حصرية.",
        "CREATE_ACCOUNT_BTN": "إنشاء حساب جديد ✦",
        "JOIN_LUXVONO": "انضم إلى لوكسفونو",
        "ENTER_EMAIL_START": "أدخل بريدك الإلكتروني للبدء في إنشاء حسابك الخاص.",
        "COMPLETE_SETUP": "إتمام إعداد الحساب",
        "VERIFY_EMAIL": "التحقق من البريد",
        "ENTER_6DIGIT_CODE": "أدخل الرمز المكون من 6 أرقام لتفعيل الحساب",
        "SECURE_ACCOUNT": "تأمين محفظتك الفاخرة بأعلى معايير التشفير",
        "SENDING_CODE": "جاري إرسال الرمز...",
        "CONTINUE": "متابعة",
        "CODE_SENT_TO": "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك:",
        "DIDNT_RECEIVE_CODE": "لم يصلك الرمز؟ إعادة الإرسال بعد",
        "RESEND_VERIFICATION_CODE": "↻ إعادة إرسال رمز التحقق",
        "VERIFY_CODE": "التحقق من الرمز",
        "VERIFYING": "جاري التحقق...",
        "CHANGE_EMAIL": "تغيير البريد الإلكتروني",
        "FIRST_NAME": "الاسم الأول",
        "LAST_NAME": "اسم العائلة",
        "PHONE_OPTIONAL": "رقم الهاتف (اختياري)",
        "PASSWORD_REQUIREMENTS": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل وتتضمن أرقاماً وحروفاً.",
        "CREATING_ACCOUNT": "جاري إنشاء الحساب...",
        "CREATE_ACCOUNT_SIGN_IN": "إنشاء الحساب والدخول",
        "ALREADY_HAVE_ACCOUNT": "لديك حساب بالفعل؟",
        "ALREADY_HAVE_ACCOUNT_DESC": "سجّل دخولك الآن للوصول إلى حقيبة التسوق الخاصة بك ومتابعة شحناتك.",
        "SIGN_IN_TO_ACCOUNT": "تسجيل الدخول →",
        "RESET_PASSWORD": "إعادة تعيين كلمة المرور",
        "FORGOT_PASSWORD_SUBTITLE": "أدخل بريدك الإلكتروني لتلقي رمز التحقق لإعادة تعيين كلمة المرور.",
        "NEW_PASSWORD": "كلمة المرور الجديدة",
        "ENTER_NEW_PASSWORD": "أدخل كلمة المرور الجديدة والقوية أدناه.",
        "SEND_RESET_LINK": "إرسال رمز التحقق",
        "REMEMBER_PASSWORD": "تذكرت كلمة المرور؟",
        "REMEMBER_PASSWORD_DESC": "يمكنك العودة إلى شاشة تسجيل الدخول ومتابعة تجربة التسوق في أي وقت.",
        "BACK_TO_SIGN_IN": "تسجيل الدخول →",
        "STORE_RATING": "تقييم المتجر",
        "ON_TIME_DELIVERY": "التسليم بالوقت",
        "RESPONSE_TIME": "سرعة الاستجابة",
        "CUSTOM_LOGO": "✓ تخصيص شعار",
        "CUSTOM_PACKAGING": "✓ تخصيص تغليف",
        "CUSTOMER_REVIEWS": "آراء وتقييمات العملاء",
        "VIEW_REVIEWS": "عرض التقييمات ✦",
        "WHOLESALE_ACTIVE": "سعر الجملة نشط",
        "LOWEST_PRICE_GUARANTEE": "🔥 ضمان أقل سعر",
        "ALWAYS_AVAILABLE": "متوفر دائماً",
        "OUT_OF_STOCK": "نفذت الكمية",
        "ONLY_1_LEFT": "متبقي قطعة واحدة فقط!",
        "ONLY_FEW_LEFT": "متبقي قطع محدودة فقط!",
        "LIMITED_QUANTITY": "كميات محدودة",
        "REMAINING_STOCK": "المتبقي في المخزون",
        "WHOLESALE_AVAILABLE": "💎 أسعار جملة متاحة",
        "ESTIMATED_DELIVERY": "التوصيل المتوقع",
        "PRODUCT_VIDEO_INCLUDED": "يتوفر فيديو للمنتج",
        "SCENT_SIGNATURE": "تفاصيل الهرم العطري الحصري",
        "SCENT_FAMILY": "العائلة العطرية:",
        "TOP_NOTES": "النوتات العليا (القمة)",
        "HEART_NOTES": "نوتات قلب العطر (الوسط)",
        "BASE_NOTES": "نوتات القاعدة (العمق المستمر)",
        "INGREDIENTS": "المكونات:",
        "VEHICLE_SPECS": "مواصفات المركبة الفاخرة",
        "MODEL": "الطراز",
        "YEAR": "سنة الصنع",
        "MILEAGE": "المسافة المقطوعة",
        "ENGINE": "المحرك",
        "TRANSMISSION": "ناقل الحركة",
        "SHOWROOM_LOCATION": "موقع الاستلام المعين (صالة العرض)",
        "UNMUTE": "تشغيل الصوت 🔊",
        "MUTE": "كتم الصوت 🔇",
        "ZOOM_IN": "تكبير",
        "ZOOM_OUT": "تصغير"
    },
    "so": {
        "HOME": "HOOYGA",
        "COLLECTIONS": "URURINTA",
        "VIDEO_COMMERCE": "TIYAATARKA MUQAALKA",
        "NAV_VIP": "QOLKA VIP",
        "NAV_LIVE": "BANDHIGA TOOSKA AH",
        "NAV_MAGAZINE": "WARGEYSKA CHRONICLE",
        "NAV_SOURCING": "ADEEGA QAASKA AH",
        "SEARCH_PLACEHOLDER": "Raadi ururintayada qaaliga ah...",
        "CART": "BOORSADA",
        "ORDERS": "DALABAADKA",
        "LIVE_AUDIO": "MAQALKA TOOSKA AH",
        "CONTACT": "LA XIRIIR KAALIYAHA",
        "SECURE_CHECKOUT": "Bixinta Sugan",
        "LOGOUT": "Ka Bax",
        "SIGN_IN": "Soo Gal",
        "REGIONAL_SETTINGS": "Dookhyada Gobolka",
        "SHIP_TO": "Dalka Loo Dirayo",
        "LANGUAGE": "Luqadda",
        "CURRENCY": "Lacagta",
        "REDEFINING": "QORAXDA RAAXADA IYO NIMCADA",
        "EXPLORE_COLLECTION": "Sahami Ururinta",
        "AUTHENTIC_BRANDS": "Damaanad Qaad 100% Asal ah",
        "ENCRYPTED_CHECKOUT": "Bixinta Sugan Ee La Hubaal Raaciyay",
        "CONCIERGE_SUPPORT": "24/7 Kaalmo Gaar ah",
        "ADD_TO_CART": "Kudar Boorsada",
        "ADD_TO_CART_BTN": "KUDAR BOORSADA",
        "BUY_NOW": "Hada Iibso",
        "NEW_ARRIVALS": "Kuwa Cusub",
        "NEW": "CUSUB",
        "TRENDING": "Aad Loo Doonayo",
        "RECOMMENDED": "KUU QAAS AH",
        "VIEW_ALL": "Eeg Dhammaan",
        "BACK": "Ku laabo",
        "GIFT_WRAPPING": "Duubista hadiyad bilaash ah",
        "FREE_SHIPPING": "Rarid bilaash ah oo caalami ah",
        "WARRANTY": "Damaanad laba sano ah oo Luxvono ah",
        "TRACKED_SHIPPING": "Rarid La Hubaal Raacay",
        "EASY_RETURNS": "Fursada Soo Celinta Fudud",
        "YOUR_CART": "XULASHADAADA",
        "CART_EMPTY": "Ururintaadu hadda waa maran tahay.",
        "CONTINUE_SHOPPING": "Ku laabo Bandhiga",
        "ORDER_SUMMARY": "Koobitaanka Dalabka",
        "SUBTOTAL": "Wadar hoose",
        "SHIPPING": "Raridda Priority",
        "COMPLIMENTARY": "Bilaash",
        "TOTAL": "Wadar",
        "PROCEED_CHECKOUT": "U SOCO BIXINTA",
        "CHECKOUT": "Bixinta",
        "EMPTY_CART": "Ururintaada qaaska ah waxay sugaysaa in la doorto.",
        "MY_ACCOUNT": "Akoonka",
        "MY_ORDERS": "Dalabaadka",
        "OFFERS": "Dalabyo Gaar ah",
        "SUPPORT": "Kaaliyaha Macmiilka",
        "AI_ASSISTANT_TITLE": "La-taliyaha Dijitaalka ah",
        "SUPPORT_CHAT": "Xafiiska VIP Concierge",
        "AI_WELCOME": "Ku soo dhawoow LUXVONO. Sideen maanta kuu caawin karaa?",
        "AI_TYPING": "La-taliyaha ayaa falanqeynaya dalabkaaga...",
        "SUPPORT_TYPING": "Kaaliyaha ayaa qoraya...",
        "LOGIN_VIEW_ORDERS": "Soo gal si aad u aragto dalabaadka",
        "TYPE_TO_SUPPORT": "U qor farriin kaaliyaha VIP...",
        "ASK_ABOUT_PRODUCTS": "Weydii saacadaha, dahabka, ama raridda...",
        "SAVE": "Keydi Dookhyada",
        "CANCEL": "Jooji",
        "ALL_CATEGORIES": "Dhammaan Qeybaha",
        "BESPOKE_SOURCING": "Dalab Gaar ah",
        "VIP_LOUNGE": "Adeegyada VIP",
        "GUARANTEED_QUALITY": "100% Tayo La Dammaanad Qaaday",
        "PREMIER_GLOBAL_PLATFORM": "Madal Caalami ah oo Qaali ah",
        "WELCOME_TO_LUXVONO": "Ku soo dhawoow Luxvono",
        "JOIN_NOW": "Ku Biir Hada",
        "LOGIN": "Soo Gal",
        "SELL_WITH_US": "Ku Iibi Luxvono (انضم كتاجر)",
        "VENDOR_PORTAL": "Xafiiska Ganacsadaha",
        "VENDOR_DASHBOARD": "Qolka Ganacsadaha",
        "APPLY_NOW": "Hada Codso",
        "SIGN_IN_ACCESS": "Soo gal si aad u gasho akoonkaaga",
        "SEARCH_PROMPT": "Raadi badeecooyinka, noocyada, qeybaha...",
        "FULL_NAME_REQUIRED": "Magaca oo Buuxa *",
        "PHONE_REQUIRED": "Telefoonka Koowaad *",
        "BACKUP_PHONE": "Telefoon Labaad (Ikhtiyaari)",
        "FULL_ADDRESS": "Cinwaanka oo Buuxa (Waddada, Degmada, Guriga) *",
        "CITY": "Magaalada *",
        "COUNTRY": "Dalka *",
        "STREET": "Waddada iyo Guriga",
        "POSTAL_CODE": "Koodhka Boostada",
        "PAYMENT_METHOD": "Qaabka Lacag Bixinta",
        "CREDIT_DEBIT_CARD": "Kaarka Bangiga / Visa / Mastercard / Apple Pay",
        "PAY_CARD_DESC": "Bixin toos ah oo sugan.",
        "CASH_ON_DELIVERY": "Lacag bixin marka la keeno (Cash on Delivery)",
        "PAY_CASH_DESC": "Bixi lacagta marka gacanta laguu galiyo alaabta.",
        "MOBILE_WALLET": "Zaad / Sahal / EVC Plus / STC Pay",
        "PAY_WALLET_DESC": "Ku bixi lacagta moobaylka si toos ah.",
        "BANK_TRANSFER": "Xawaalad Bangi oo Toos ah",
        "PAY_BANK_DESC": "Ku wareeji xisaabta bangiga ee shirkadda.",
        "UPLOAD_RECEIPT": "Ku lifaaq rasiidka lacag bixinta (Ikhtiyaari)",
        "PROCESSING_ORDER": "Dalabkaaga waa la diyaarinayaa...",
        "PLACE_ORDER": "Xaqiiji oo Dalbo",
        "TAX": "Canshuurta (VAT)",
        "QTY": "Tirada",
        "FOR_YOU": "Kuu Qaas ah",
        "BACK_TO_FEED": "← Ku laabo Bandhiga",
        "NO_CONTENT_FOUND": "Ma jiraan wax muqaallo ah hadda.",
        "PRIORITY_GLOBAL_DELIVERY": "Rarid Caalami ah oo Degdeg ah",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Gaarsiin sugan oo caalami ah",
        "SECURE_CHECKOUT_TITLE": "100% Bixin Sugan",
        "SECURE_CHECKOUT_DESC": "Lacag bixin qarsoon oo sugan",
        "CURATED_AUTHENTICITY": "Badeecooyin Asal ah oo La Hubiyay",
        "CURATED_AUTHENTICITY_DESC": "Hubin tayo leh ka hor dirista",
        "DEDICATED_CONCIERGE": "24/7 Kaalmo Gaar ah",
        "DEDICATED_CONCIERGE_DESC": "Caawinaad degdeg ah mar kasta",
        "CUSTOMER_CARE": "Daryeelka Macmiilka",
        "TRACK_ORDER": "La Soco Dalabka",
        "VIP_CLUB": "Kooxda VIP Concierge",
        "HELP_SUPPORT": "Caawinaad iyo Taageero",
        "ABOUT_LUXVONO": "Ku Saabsan LUXVONO",
        "ABOUT_US_VISION": "Yaan Nahay & Aragtidayada",
        "SUPPLIER_PORTAL": "Xafiiska Ganacsatada",
        "LUXVONO_MAGAZINE": "Joornaalka LUXVONO",
        "TERMS_CONDITIONS": "Shuruudaha & Xeerarka",
        "PRIVACY_POLICY": "Xeerka Qarsoodiga",
        "SECURE_PAYMENTS": "Lacag Bixin Sugan",
        "CONTACT_CONCIERGE_BTN": "La Xiriir Kaaliyaha VIP ✦",
        "DIRECT_VIP_PHONE": "Telefoonka Tooska ah ee VIP",
        "OFFICIAL_SUPPORT_EMAIL": "Email-ka Rasmiga ah",
        "GLOBAL_STANDARDS": "Heerarka Caalamiga ah ee Ganacsiga Raaxada",
        "CONNECT_WITH_US": "Nagala Soco Baraha Bulshada:",
        "EMAIL_ADDRESS": "Cinwaanka Email-ka",
        "PASSWORD": "Furaha Sirta ah",
        "FORGOT_PASSWORD": "Ma ilowday furaha?",
        "AUTHENTICATING": "Xaqiijinta socota...",
        "OR_CONTINUE_WITH": "Ama ku sii wad",
        "NEW_TO_LUXVONO": "Miyaad ku cusub tahay LuxVono?",
        "CREATE_ACCOUNT_DESC": "Sameyso akoon gaar ah maanta si aad u hesho qiimo dhimis iyo gaarsiin degdeg ah.",
        "CREATE_ACCOUNT_BTN": "Sameyso Akoon Cusub ✦",
        "JOIN_LUXVONO": "Ku Biir LUXVONO",
        "ENTER_EMAIL_START": "Geli email-kaaga si aad u bilowdo akoonkaaga gaarka ah.",
        "COMPLETE_SETUP": "Dhamaystir Dejinta Akoonka",
        "VERIFY_EMAIL": "Xaqiiji Email-kaaga",
        "ENTER_6DIGIT_CODE": "Geli lambarka 6-god ah si aad u kiciso akoonkaaga",
        "SECURE_ACCOUNT": "Ku xaqiiji hantidaada sirta ugu sareysa",
        "SENDING_CODE": "Diraya lambarka...",
        "CONTINUE": "Sii wad",
        "CODE_SENT_TO": "Geli lambarka 6-god ah ee loo diray:",
        "DIDNT_RECEIVE_CODE": "Miyaanad helin lambarka? Dib u dirid ka dib",
        "RESEND_VERIFICATION_CODE": "↻ Dib u dir lambarka xaqiijinta",
        "VERIFY_CODE": "Xaqiiji Lambarka",
        "VERIFYING": "Xaqiijin socota...",
        "CHANGE_EMAIL": "Beddel Email-ka",
        "FIRST_NAME": "Magaca Koowaad",
        "LAST_NAME": "Magaca Qoyska",
        "PHONE_OPTIONAL": "Telefoonka (Ikhtiyaari)",
        "PASSWORD_REQUIREMENTS": "Furaha sirta ah waa inuu ugu yaraan ka kooban yahay 8 xaraf oo leh xarfo iyo tirooyin.",
        "CREATING_ACCOUNT": "Sameynaya akoon...",
        "CREATE_ACCOUNT_SIGN_IN": "Sameyso Akoon & Soo Gal",
        "ALREADY_HAVE_ACCOUNT": "Akoon ma leedahay hore?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Soo gal si aad u aragto dalabaadkaaga iyo xaaladda shixnaddaada.",
        "SIGN_IN_TO_ACCOUNT": "Soo Gal Akoonka →",
        "RESET_PASSWORD": "Dib u Deji Furaha Sirta",
        "FORGOT_PASSWORD_SUBTITLE": "Geli email-kaaga si laguu soo diro lambarka beddelka furaha.",
        "NEW_PASSWORD": "Fure Cusub",
        "ENTER_NEW_PASSWORD": "Geli furahaaga sirta ah ee cusub.",
        "SEND_RESET_LINK": "Dir Lambarka Xaqiijinta",
        "REMEMBER_PASSWORD": "Ma xasuusataa Furaha?",
        "REMEMBER_PASSWORD_DESC": "Waxaad dib ugu noqon kartaa bogga gelitaanka si aad wax u iibsato.",
        "BACK_TO_SIGN_IN": "Dib ugu Noqo Gelitaanka →",
        "STORE_RATING": "Qiimeynta Dukaanka",
        "ON_TIME_DELIVERY": "Gaarsiinta Wakhtiga",
        "RESPONSE_TIME": "Xawaaraha Jawaabta",
        "CUSTOM_LOGO": "✓ Sumad Gaar ah",
        "CUSTOM_PACKAGING": "✓ Baakad Gaar ah",
        "CUSTOMER_REVIEWS": "Faallooyinka Macaamiisha",
        "VIEW_REVIEWS": "Fiiri Faallooyinka ✦",
        "WHOLESALE_ACTIVE": "Qiimaha Jumladdu waa Furanyahay",
        "LOWEST_PRICE_GUARANTEE": "🔥 Dammaanad Qiimaha ugu Hooseeya",
        "ALWAYS_AVAILABLE": "Had iyo jeer diyaar ah",
        "OUT_OF_STOCK": "Waa dhammaaday",
        "ONLY_1_LEFT": "Keliya 1 xabo ayaa haray!",
        "ONLY_FEW_LEFT": "Xabo kooban ayaa haray!",
        "LIMITED_QUANTITY": "Tiro Kooban",
        "REMAINING_STOCK": "Inta ku hartey Bakhaarka",
        "WHOLESALE_AVAILABLE": "💎 Jumlad baa la heli karaa",
        "ESTIMATED_DELIVERY": "Wakhtiga Gaarsiinta",
        "PRODUCT_VIDEO_INCLUDED": "Muuqaalka badeecada waa jiraa",
        "SCENT_SIGNATURE": "Qaab-dhismeedka Udgoonka",
        "SCENT_FAMILY": "Qoyska Udgoonka:",
        "TOP_NOTES": "Qaybta Sare",
        "HEART_NOTES": "Wadnaha Udgoonka",
        "BASE_NOTES": "Qaybta Hoose ee Joogtada ah",
        "INGREDIENTS": "Waxyaabaha ka kooban yahay:",
        "VEHICLE_SPECS": "Xogta Gaariga Raaxada",
        "MODEL": "Nooca",
        "YEAR": "Sanadka",
        "MILEAGE": "Masaafada",
        "ENGINE": "Matoorka",
        "TRANSMISSION": "Gudbinta",
        "SHOWROOM_LOCATION": "Goobta Qaadashada VIP",
        "UNMUTE": "Codka Daar 🔊",
        "MUTE": "Codka Demi 🔇",
        "ZOOM_IN": "Weynee",
        "ZOOM_OUT": "Yaree"
    },
    "gdq": {
        "HOME": "الرئيسية",
        "COLLECTIONS": "المقتنيات الفاخرة",
        "VIDEO_COMMERCE": "سينما السيعات",
        "NAV_VIP": "صالون VIP",
        "NAV_LIVE": "البث الحي المباشر",
        "NAV_MAGAZINE": "المجلة",
        "NAV_SOURCING": "التوريد الخاص",
        "SEARCH_PLACEHOLDER": "ابحث في السيعات والذهب...",
        "CART": "الكسوة والمشتريات",
        "ORDERS": "الطلبات",
        "LIVE_AUDIO": "المجلس",
        "CONTACT": "تواصل مع المستشار",
        "SECURE_CHECKOUT": "دفع مضمون وآمن",
        "LOGOUT": "خروج",
        "SIGN_IN": "دخول",
        "REGIONAL_SETTINGS": "البلاد واللغة والعملة",
        "SHIP_TO": "بلاد الشحن",
        "LANGUAGE": "اللسان",
        "CURRENCY": "العملة",
        "REDEFINING": "أرقى المقتنيات والسيعات النادرة",
        "EXPLORE_COLLECTION": "استكشف التشكيلة",
        "AUTHENTIC_BRANDS": "أصلي 100% مع الضمان",
        "ENCRYPTED_CHECKOUT": "دفع آمن ومعتمد",
        "CONCIERGE_SUPPORT": "خدمة خاصة 24/7",
        "ADD_TO_CART": "إضافة للحقيبة",
        "ADD_TO_CART_BTN": "إضافة للحقيبة",
        "BUY_NOW": "شراء فوري",
        "NEW_ARRIVALS": "المقتنيات الجديدة",
        "NEW": "جديد",
        "TRENDING": "الأنفس والأندر",
        "RECOMMENDED": "مختار لك",
        "VIEW_ALL": "عرض الكل",
        "BACK": "رجوع",
        "GIFT_WRAPPING": "تغليف فاخر مجاني",
        "FREE_SHIPPING": "شحن سريع ومضمون",
        "WARRANTY": "ضمان دولي معتمد",
        "TRACKED_SHIPPING": "تتبع الشحنة",
        "EASY_RETURNS": "إرجاع وتبديل ميسر",
        "YOUR_CART": "المشتريات",
        "CART_EMPTY": "الحقيبة خالية.",
        "CONTINUE_SHOPPING": "العودة للمعرض",
        "ORDER_SUMMARY": "الملخص",
        "SUBTOTAL": "المجموع",
        "SHIPPING": "الحمولة والنقل",
        "COMPLIMENTARY": "مجاناً",
        "TOTAL": "الإجمالي",
        "PROCEED_CHECKOUT": "إتمام الشراء",
        "CHECKOUT": "الدفع",
        "EMPTY_CART": "الحقيبة خالية حالياً.",
        "MY_ACCOUNT": "المحفظة",
        "MY_ORDERS": "طلباتي",
        "OFFERS": "العروض",
        "SUPPORT": "المستشار",
        "AI_ASSISTANT_TITLE": "المستشار المهري الذكي",
        "SUPPORT_CHAT": "صالون VIP",
        "AI_WELCOME": "مرحباً بك في LUXVONO. كيف نخدمك اليوم في السيعات والمقتنيات؟",
        "AI_TYPING": "المستشار يحلل طلبك...",
        "SUPPORT_TYPING": "المستشار يكتب...",
        "LOGIN_VIEW_ORDERS": "تسجيل الدخول لمتابعة طلبيتك",
        "TYPE_TO_SUPPORT": "اكتب للمستشار الخاص...",
        "ASK_ABOUT_PRODUCTS": "اسأل عن السيعات، الذهب، أو الشحن...",
        "SAVE": "حفظ",
        "CANCEL": "إلغاء",
        "ALL_CATEGORIES": "الأقسام كلها",
        "BESPOKE_SOURCING": "التوريد الخاص",
        "VIP_LOUNGE": "مجلس VIP",
        "GUARANTEED_QUALITY": "جودة وأصالة مضمونة",
        "PREMIER_GLOBAL_PLATFORM": "منصة المقتنيات الفاخرة",
        "WELCOME_TO_LUXVONO": "حياك الله في لوكسفونو",
        "JOIN_NOW": "انضم معنا",
        "LOGIN": "دخول",
        "SELL_WITH_US": "اعرض بضاعتك كمورد",
        "VENDOR_PORTAL": "بوابة التاجر",
        "VENDOR_DASHBOARD": "لوحة التاجر",
        "APPLY_NOW": "قدم الآن",
        "SIGN_IN_ACCESS": "سجل دخولك لحسابك",
        "SEARCH_PROMPT": "ابحث في السيعات والذهب...",
        "FULL_NAME_REQUIRED": "الاسم *",
        "PHONE_REQUIRED": "رقم الهاتف *",
        "BACKUP_PHONE": "رقم هاتف ثاني",
        "FULL_ADDRESS": "العنوان بالتفصيل *",
        "CITY": "المدينة *",
        "COUNTRY": "البلاد *",
        "STREET": "الشارع والبيت",
        "POSTAL_CODE": "الرمز البريدي",
        "PAYMENT_METHOD": "طريقة الدفع",
        "CREDIT_DEBIT_CARD": "بطاقة بنكية / فيزا / أبل باي",
        "PAY_CARD_DESC": "دفع إلكتروني فوري وآمن",
        "CASH_ON_DELIVERY": "الدفع عند الاستلام",
        "PAY_CASH_DESC": "سداد نقدي عند استلام السلعة.",
        "MOBILE_WALLET": "المحافظ الإلكترونية",
        "PAY_WALLET_DESC": "تحويل سريع عبر المحفظة.",
        "BANK_TRANSFER": "تحويل بنكي مباشر",
        "PAY_BANK_DESC": "تحويل مباشر لحساب المؤسسة البنكي.",
        "UPLOAD_RECEIPT": "إرفاق وصل التحويل",
        "PROCESSING_ORDER": "جاري تجهيز طلبك...",
        "PLACE_ORDER": "تأكيد الطلب",
        "TAX": "الضريبة",
        "QTY": "العدد",
        "FOR_YOU": "مختار لك",
        "BACK_TO_FEED": "← رجوع",
        "NO_CONTENT_FOUND": "لا يوجد محتوى حالياً.",
        "PRIORITY_GLOBAL_DELIVERY": "شحن سريع ومضمون",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "توصيل لكافة البلاد",
        "SECURE_CHECKOUT_TITLE": "دفع آمن 100%",
        "SECURE_CHECKOUT_DESC": "دفع مضمون ومحمي",
        "CURATED_AUTHENTICITY": "أصلي 100% مع الفحص",
        "CURATED_AUTHENTICITY_DESC": "فحص الجودة قبل الإرسال",
        "DEDICATED_CONCIERGE": "خدمة خاصة 24/7",
        "DEDICATED_CONCIERGE_DESC": "مستشار خاص جاهز لخدمتك",
        "CUSTOMER_CARE": "خدمة المشترين",
        "TRACK_ORDER": "تتبع الطلبات",
        "VIP_CLUB": "مجلس VIP",
        "HELP_SUPPORT": "المساعدة والدعم",
        "ABOUT_LUXVONO": "عن لوكسفونو",
        "ABOUT_US_VISION": "قصة الدار ورؤيتنا",
        "SUPPLIER_PORTAL": "بوابة التجار",
        "LUXVONO_MAGAZINE": "مجلة لوكسفونو",
        "TERMS_CONDITIONS": "الشروط والأحكام",
        "PRIVACY_POLICY": "الخصوصية والأمان",
        "SECURE_PAYMENTS": "دفع آمن ومعتمد",
        "CONTACT_CONCIERGE_BTN": "تواصل مع المستشار ✦",
        "DIRECT_VIP_PHONE": "هاتف المستشار المباشر",
        "OFFICIAL_SUPPORT_EMAIL": "البريد المعتمد",
        "GLOBAL_STANDARDS": "أعلى معايير الجودة العالمية",
        "CONNECT_WITH_US": "تابعنا:",
        "EMAIL_ADDRESS": "البريد الإلكتروني",
        "PASSWORD": "كلمة السر",
        "FORGOT_PASSWORD": "نسيت كلمة السر؟",
        "AUTHENTICATING": "جاري التحقق...",
        "OR_CONTINUE_WITH": "أو المتابعة عبر",
        "NEW_TO_LUXVONO": "مشترك جديد في لوكسفونو؟",
        "CREATE_ACCOUNT_DESC": "أنشئ حسابك الخاص الآن للحصول على أفضل العروض والخدمات الخاصة.",
        "CREATE_ACCOUNT_BTN": "إنشاء حساب جديد ✦",
        "JOIN_LUXVONO": "انضم إلى لوكسفونو",
        "ENTER_EMAIL_START": "أدخل بريدك للبدء في إنشاء حسابك الخاص.",
        "COMPLETE_SETUP": "إتمام إعداد الحساب",
        "VERIFY_EMAIL": "التحقق من البريد",
        "ENTER_6DIGIT_CODE": "أدخل رمز التفعيل المكون من 6 أرقام",
        "SECURE_ACCOUNT": "تأمين محفظتك بأعلى معايير الأمان",
        "SENDING_CODE": "جاري إرسال الرمز...",
        "CONTINUE": "متابعة",
        "CODE_SENT_TO": "أدخل الرمز المرسل إلى:",
        "DIDNT_RECEIVE_CODE": "لم يصلك الرمز؟ إعادة الإرسال بعد",
        "RESEND_VERIFICATION_CODE": "↻ إعادة إرسال الرمز",
        "VERIFY_CODE": "تأكيد الرمز",
        "VERIFYING": "جاري التأكيد...",
        "CHANGE_EMAIL": "تغيير البريد",
        "FIRST_NAME": "الاسم الأول",
        "LAST_NAME": "اللقب / العائلة",
        "PHONE_OPTIONAL": "رقم الهاتف",
        "PASSWORD_REQUIREMENTS": "كلمة السر 8 خانات على الأقل وتتضمن أرقاماً وحروفاً.",
        "CREATING_ACCOUNT": "جاري إنشاء الحساب...",
        "CREATE_ACCOUNT_SIGN_IN": "إنشاء الحساب والدخول",
        "ALREADY_HAVE_ACCOUNT": "لديك حساب بالفعل؟",
        "ALREADY_HAVE_ACCOUNT_DESC": "سجل دخولك لمتابعة مشترياتك وطلباتك.",
        "SIGN_IN_TO_ACCOUNT": "تسجيل الدخول →",
        "RESET_PASSWORD": "استعادة كلمة السر",
        "FORGOT_PASSWORD_SUBTITLE": "أدخل بريدك لتلقي رمز التحقق.",
        "NEW_PASSWORD": "كلمة السر الجديدة",
        "ENTER_NEW_PASSWORD": "أدخل كلمة السر الجديدة.",
        "SEND_RESET_LINK": "إرسال الرمز",
        "REMEMBER_PASSWORD": "تذكرت كلمة السر؟",
        "REMEMBER_PASSWORD_DESC": "يمكنك العودة إلى شاشة الدخول ومتابعة التسوق.",
        "BACK_TO_SIGN_IN": "الدخول إلى الحساب →",
        "STORE_RATING": "تقييم المتجر",
        "ON_TIME_DELIVERY": "التسليم في الموعد",
        "RESPONSE_TIME": "سرعة الرد",
        "CUSTOM_LOGO": "✓ شعار مخصص",
        "CUSTOM_PACKAGING": "✓ تغليف خاص",
        "CUSTOMER_REVIEWS": "تقييمات المشترين",
        "VIEW_REVIEWS": "عرض التقييمات ✦",
        "WHOLESALE_ACTIVE": "سعر الجملة نشط",
        "LOWEST_PRICE_GUARANTEE": "🔥 ضمان أقل سعر",
        "ALWAYS_AVAILABLE": "متوفر دائماً",
        "OUT_OF_STOCK": "نفذت الكمية",
        "ONLY_1_LEFT": "متبقي قطعة واحدة فقط!",
        "ONLY_FEW_LEFT": "متبقي قطع قليلة!",
        "LIMITED_QUANTITY": "كميات محدودة",
        "REMAINING_STOCK": "المتبقي في المخزن",
        "WHOLESALE_AVAILABLE": "💎 أسعار جملة متاحة",
        "ESTIMATED_DELIVERY": "التوصيل المتوقع",
        "PRODUCT_VIDEO_INCLUDED": "يوجد فيديو للمنتج",
        "SCENT_SIGNATURE": "تفاصيل الهرم العطري",
        "SCENT_FAMILY": "العائلة العطرية:",
        "TOP_NOTES": "قمة العطر",
        "HEART_NOTES": "قلب العطر",
        "BASE_NOTES": "قاعدة العطر",
        "INGREDIENTS": "المكونات:",
        "VEHICLE_SPECS": "مواصفات المركبة",
        "MODEL": "الطراز",
        "YEAR": "السنة",
        "MILEAGE": "الممشى",
        "ENGINE": "المحرك",
        "TRANSMISSION": "الجير",
        "SHOWROOM_LOCATION": "صالة العرض VIP",
        "UNMUTE": "تشغيل الصوت 🔊",
        "MUTE": "كتم الصوت 🔇",
        "ZOOM_IN": "تكبير",
        "ZOOM_OUT": "تصغير"
    },
    "de": {
        "HOME": "STARTSEITE",
        "COLLECTIONS": "KOLLEKTIONEN",
        "VIDEO_COMMERCE": "VIDEO THEATER",
        "NAV_VIP": "VIP LOUNGE",
        "NAV_LIVE": "LIVE SHOWCASE",
        "NAV_MAGAZINE": "DAS CHRONIK",
        "NAV_SOURCING": "BESPOKE SOURCING",
        "SEARCH_PLACEHOLDER": "Luxuskreationen durchsuchen...",
        "CART": "WARENKORB",
        "ORDERS": "BESTELLUNGEN",
        "LIVE_AUDIO": "LIVE AUDIO",
        "CONTACT": "CONCIERGE KONTAKTIEREN",
        "SECURE_CHECKOUT": "Sichere Kasse",
        "LOGOUT": "Abmelden",
        "SIGN_IN": "Anmelden",
        "REGIONAL_SETTINGS": "Regionale Einstellungen",
        "SHIP_TO": "Lieferland",
        "LANGUAGE": "Sprache",
        "CURRENCY": "Währung",
        "REDEFINING": "EXZELLENZ NEU DEFINIERT",
        "EXPLORE_COLLECTION": "Kollektion entdecken",
        "AUTHENTIC_BRANDS": "100% Zertifizierte Originale",
        "ENCRYPTED_CHECKOUT": "Vollverschlüsselte Bezahlung",
        "CONCIERGE_SUPPORT": "24/7 Exklusiver Concierge",
        "ADD_TO_CART": "In den Warenkorb",
        "ADD_TO_CART_BTN": "IN DEN WARENKORB",
        "BUY_NOW": "Jetzt erwerben",
        "NEW_ARRIVALS": "Neuheiten",
        "NEW": "NEU",
        "TRENDING": "Begehrte Ikonen",
        "RECOMMENDED": "FÜR SIE KURATIERT",
        "VIEW_ALL": "Alle anzeigen",
        "BACK": "Zurück",
        "GIFT_WRAPPING": "Kostenlose Geschenkverpackung",
        "FREE_SHIPPING": "Kostenloser versicherter Expressversand",
        "WARRANTY": "Zwei Jahre Luxvono Garantie",
        "TRACKED_SHIPPING": "Echtzeit-Tracking",
        "EASY_RETURNS": "14 Tage Rückgaberecht",
        "YOUR_CART": "IHRE AUSWAHL",
        "CART_EMPTY": "Ihr Warenkorb ist derzeit leer.",
        "CONTINUE_SHOPPING": "Weiter einkaufen",
        "ORDER_SUMMARY": "Bestellübersicht",
        "SUBTOTAL": "Zwischensumme",
        "SHIPPING": "Expressversand",
        "COMPLIMENTARY": "Kostenlos",
        "TOTAL": "Gesamtsumme",
        "PROCEED_CHECKOUT": "ZUR KASSE",
        "CHECKOUT": "Kasse",
        "EMPTY_CART": "Ihre private Auswahl wartet.",
        "MY_ACCOUNT": "Kundenkonto",
        "MY_ORDERS": "Bestellungen",
        "OFFERS": "Private Angebote",
        "SUPPORT": "Concierge",
        "AI_ASSISTANT_TITLE": "Digitaler Luxus-Berater",
        "SUPPORT_CHAT": "VIP Concierge Büro",
        "AI_WELCOME": "Willkommen bei LUXVONO. Ich bin Ihr digitaler Berater. Wie darf ich Ihnen heute helfen?",
        "AI_TYPING": "Digitaler Berater analysiert Ihre Anfrage...",
        "SUPPORT_TYPING": "VIP Concierge tippt...",
        "LOGIN_VIEW_ORDERS": "Anmelden, um Bestellungen einzusehen",
        "TYPE_TO_SUPPORT": "Nachricht an Ihren Concierge...",
        "ASK_ABOUT_PRODUCTS": "Fragen Sie nach Uhren, Schmuck oder Versand...",
        "SAVE": "Einstellungen speichern",
        "CANCEL": "Abbrechen",
        "ALL_CATEGORIES": "Alle Kategorien",
        "BESPOKE_SOURCING": "Exklusive Beschaffung",
        "VIP_LOUNGE": "VIP Lounge",
        "GUARANTEED_QUALITY": "100% Garantierte Qualität",
        "PREMIER_GLOBAL_PLATFORM": "Führende globale Luxusplattform",
        "WELCOME_TO_LUXVONO": "Willkommen bei LUXVONO",
        "JOIN_NOW": "Jetzt beitreten",
        "LOGIN": "Anmelden",
        "SELL_WITH_US": "Als Händler verkaufen",
        "VENDOR_PORTAL": "Händlerportal",
        "VENDOR_DASHBOARD": "Händler-Dashboard",
        "APPLY_NOW": "Jetzt bewerben",
        "SIGN_IN_ACCESS": "Melden Sie sich an, um auf Ihr Konto zuzugreifen",
        "SEARCH_PROMPT": "Produkte, Marken und Kategorien suchen...",
        "FULL_NAME_REQUIRED": "Vollständiger Name *",
        "PHONE_REQUIRED": "Telefonnummer *",
        "BACKUP_PHONE": "Alternative Telefonnummer",
        "FULL_ADDRESS": "Vollständige Adresse (Straße, Hausnr., PLZ) *",
        "CITY": "Stadt *",
        "COUNTRY": "Land *",
        "STREET": "Straße und Hausnummer",
        "POSTAL_CODE": "Postleitzahl",
        "PAYMENT_METHOD": "Zahlungsmethode",
        "CREDIT_DEBIT_CARD": "Kreditkarte / Apple Pay",
        "PAY_CARD_DESC": "Sofortige und sichere Zahlung.",
        "CASH_ON_DELIVERY": "Nachnahme",
        "PAY_CASH_DESC": "Barzahlung bei persönlicher Lieferung.",
        "MOBILE_WALLET": "Digitale Geldbörsen",
        "PAY_WALLET_DESC": "Zahlung über mobile Geldbörse.",
        "BANK_TRANSFER": "Banküberweisung",
        "PAY_BANK_DESC": "Direkte Überweisung auf Firmenkonto.",
        "UPLOAD_RECEIPT": "Überweisungsbeleg hochladen",
        "PROCESSING_ORDER": "Bestellung wird verarbeitet...",
        "PLACE_ORDER": "Kauf bestätigen",
        "TAX": "MwSt.",
        "QTY": "Menge",
        "FOR_YOU": "Für Sie kuratiert",
        "BACK_TO_FEED": "← Zurück zur Galerie",
        "NO_CONTENT_FOUND": "Derzeit keine Inhalte verfügbar.",
        "PRIORITY_GLOBAL_DELIVERY": "Prioritäts-Expressversand",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Schneller & versicherter internationaler Versand",
        "SECURE_CHECKOUT_TITLE": "100% Sichere Kasse",
        "SECURE_CHECKOUT_DESC": "Verschlüsselte Transaktionen & Käuferschutz",
        "CURATED_AUTHENTICITY": "Geprüfte Authentizität",
        "CURATED_AUTHENTICITY_DESC": "Zertifizierte Qualität & strenge Prüfung",
        "DEDICATED_CONCIERGE": "24/7 Persönlicher Concierge",
        "DEDICATED_CONCIERGE_DESC": "Rund um die Uhr erstklassige Betreuung",
        "CUSTOMER_CARE": "Kundenservice",
        "TRACK_ORDER": "Bestellung verfolgen",
        "VIP_CLUB": "VIP Concierge Club",
        "HELP_SUPPORT": "Hilfe & Support",
        "ABOUT_LUXVONO": "Über LUXVONO",
        "ABOUT_US_VISION": "Über Uns & Vision",
        "SUPPLIER_PORTAL": "Händlerportal",
        "LUXVONO_MAGAZINE": "LUXVONO Magazin",
        "TERMS_CONDITIONS": "AGB",
        "PRIVACY_POLICY": "Datenschutz",
        "SECURE_PAYMENTS": "Sichere Zahlungen",
        "CONTACT_CONCIERGE_BTN": "VIP Concierge kontaktieren ✦",
        "DIRECT_VIP_PHONE": "Direkte VIP-Hotline",
        "OFFICIAL_SUPPORT_EMAIL": "Offizielle Support-E-Mail",
        "GLOBAL_STANDARDS": "Globale Standards für Luxushandel",
        "CONNECT_WITH_US": "FOLGEN SIE LUXVONO:",
        "EMAIL_ADDRESS": "E-Mail-Adresse",
        "PASSWORD": "Passwort",
        "FORGOT_PASSWORD": "Passwort vergessen?",
        "AUTHENTICATING": "Authentifizierung...",
        "OR_CONTINUE_WITH": "Oder fortfahren mit",
        "NEW_TO_LUXVONO": "Neu bei LuxVono?",
        "CREATE_ACCOUNT_DESC": "Erstellen Sie noch heute ein exklusives Konto für Prioritätspreise und erstklassigen Service.",
        "CREATE_ACCOUNT_BTN": "Konto erstellen ✦",
        "JOIN_LUXVONO": "LUXVONO beitreten",
        "ENTER_EMAIL_START": "Geben Sie Ihre E-Mail-Adresse ein, um zu beginnen.",
        "COMPLETE_SETUP": "Kontoeinrichtung abschließen",
        "VERIFY_EMAIL": "E-Mail bestätigen",
        "ENTER_6DIGIT_CODE": "Geben Sie den 6-stelligen Code ein",
        "SECURE_ACCOUNT": "Sichern Sie Ihr Portfolio mit modernster Verschlüsselung",
        "SENDING_CODE": "Code wird gesendet...",
        "CONTINUE": "Weiter",
        "CODE_SENT_TO": "Geben Sie den 6-stelligen Code ein, gesendet an:",
        "DIDNT_RECEIVE_CODE": "Keinen Code erhalten? Erneut senden in",
        "RESEND_VERIFICATION_CODE": "↻ Bestätigungscode erneut senden",
        "VERIFY_CODE": "Code bestätigen",
        "VERIFYING": "Wird überprüft...",
        "CHANGE_EMAIL": "E-Mail-Adresse ändern",
        "FIRST_NAME": "Vorname",
        "LAST_NAME": "Nachname",
        "PHONE_OPTIONAL": "Telefonnummer (Optional)",
        "PASSWORD_REQUIREMENTS": "Mindestens 8 Zeichen mit Buchstaben und Zahlen.",
        "CREATING_ACCOUNT": "Konto wird erstellt...",
        "CREATE_ACCOUNT_SIGN_IN": "Konto erstellen & Anmelden",
        "ALREADY_HAVE_ACCOUNT": "Bereits registriert?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Melden Sie sich an, um Ihre Bestellungen und Lieferungen zu verfolgen.",
        "SIGN_IN_TO_ACCOUNT": "Zum Konto anmelden →",
        "RESET_PASSWORD": "Passwort zurücksetzen",
        "FORGOT_PASSWORD_SUBTITLE": "Geben Sie Ihre E-Mail ein, um einen Bestätigungscode zu erhalten.",
        "NEW_PASSWORD": "Neues Passwort",
        "ENTER_NEW_PASSWORD": "Geben Sie Ihr neues sicheres Passwort ein.",
        "SEND_RESET_LINK": "Code senden",
        "REMEMBER_PASSWORD": "Passwort wieder eingefallen?",
        "REMEMBER_PASSWORD_DESC": "Sie können direkt zur Anmeldeseite zurückkehren.",
        "BACK_TO_SIGN_IN": "Zurück zur Anmeldung →",
        "STORE_RATING": "Händlerbewertung",
        "ON_TIME_DELIVERY": "Pünktl. Lieferung",
        "RESPONSE_TIME": "Antwortzeit",
        "CUSTOM_LOGO": "✓ Eigenes Logo",
        "CUSTOM_PACKAGING": "✓ Eigene Verpackung",
        "CUSTOMER_REVIEWS": "Kundenbewertungen & Feedback",
        "VIEW_REVIEWS": "Bewertungen ansehen ✦",
        "WHOLESALE_ACTIVE": "Großhandelspreis aktiv",
        "LOWEST_PRICE_GUARANTEE": "🔥 Bestpreisgarantie",
        "ALWAYS_AVAILABLE": "Immer verfügbar",
        "OUT_OF_STOCK": "Ausverkauft",
        "ONLY_1_LEFT": "Nur noch 1 Stück verfügbar!",
        "ONLY_FEW_LEFT": "Nur noch wenige verfügbar!",
        "LIMITED_QUANTITY": "Begrenzte Menge",
        "REMAINING_STOCK": "Verbleibender Bestand",
        "WHOLESALE_AVAILABLE": "💎 Großhandelspreise verfügbar",
        "ESTIMATED_DELIVERY": "Voraussichtliche Lieferung",
        "PRODUCT_VIDEO_INCLUDED": "Produktvideo verfügbar",
        "SCENT_SIGNATURE": "Duftpyramide & Signatur",
        "SCENT_FAMILY": "Duftfamilie:",
        "TOP_NOTES": "Kopfnote",
        "HEART_NOTES": "Herznote",
        "BASE_NOTES": "Basisnote",
        "INGREDIENTS": "Inhaltsstoffe:",
        "VEHICLE_SPECS": "Fahrzeugdaten & Leistung",
        "MODEL": "Modell",
        "YEAR": "Baujahr",
        "MILEAGE": "Kilometerstand",
        "ENGINE": "Motor",
        "TRANSMISSION": "Getriebe",
        "SHOWROOM_LOCATION": "VIP Showroom Übergabe",
        "UNMUTE": "Ton einschalten 🔊",
        "MUTE": "Stummschalten 🔇",
        "ZOOM_IN": "Vergrößern",
        "ZOOM_OUT": "Verkleinern"
    },
    "fr": {
        "HOME": "ACCUEIL",
        "COLLECTIONS": "COLLECTIONS",
        "VIDEO_COMMERCE": "THÉÂTRE VIDÉO",
        "NAV_VIP": "SALON VIP",
        "NAV_LIVE": "SHOWCASE EN DIRECT",
        "NAV_MAGAZINE": "LE CHRONIQUE",
        "NAV_SOURCING": "SOURCING SUR MESURE",
        "SEARCH_PLACEHOLDER": "Rechercher dans nos collections de prestige...",
        "CART": "PANIER",
        "ORDERS": "ACQUISITIONS",
        "LIVE_AUDIO": "AUDIO EN DIRECT",
        "CONTACT": "CONTACTER LE CONCIERGE",
        "SECURE_CHECKOUT": "Paiement Sécurisé",
        "LOGOUT": "Déconnexion",
        "SIGN_IN": "Connexion",
        "REGIONAL_SETTINGS": "Préférences Régionales",
        "SHIP_TO": "Destination",
        "LANGUAGE": "Langue",
        "CURRENCY": "Devise",
        "REDEFINING": "L'EXCELLENCE REDÉFINIE",
        "EXPLORE_COLLECTION": "Découvrir la Collection",
        "AUTHENTIC_BRANDS": "100% Pièces Authentiques Certifiées",
        "ENCRYPTED_CHECKOUT": "Protocoles de Chiffrement Sécurisés",
        "CONCIERGE_SUPPORT": "Concierge Dédié 24/7",
        "ADD_TO_CART": "Ajouter au Panier",
        "ADD_TO_CART_BTN": "AJOUTER AU PANIER",
        "BUY_NOW": "Acquérir Maintenant",
        "NEW_ARRIVALS": "Nouvelles Créations",
        "NEW": "NOUVEAU",
        "TRENDING": "Icônes Très Convoitées",
        "RECOMMENDED": "SÉLECTION POUR VOUS",
        "VIEW_ALL": "Voir Tout",
        "BACK": "Retour",
        "GIFT_WRAPPING": "Emballage cadeau signature offert",
        "FREE_SHIPPING": "Livraison express internationale offerte",
        "WARRANTY": "Garantie signature Luxvono deux ans",
        "TRACKED_SHIPPING": "Suivi prioritaire sécurisé",
        "EASY_RETURNS": "Privilège de retour simplifié sous 14 jours",
        "YOUR_CART": "VOTRE SÉLECTION",
        "CART_EMPTY": "Votre panier est actuellement vide.",
        "CONTINUE_SHOPPING": "Retour à la Galerie",
        "ORDER_SUMMARY": "Récapitulatif",
        "SUBTOTAL": "Sous-total",
        "SHIPPING": "Livraison Express",
        "COMPLIMENTARY": "Offert",
        "TOTAL": "Total",
        "PROCEED_CHECKOUT": "PROCÉDER AU PAIEMENT",
        "CHECKOUT": "Paiement",
        "EMPTY_CART": "Votre collection privée vous attend.",
        "MY_ACCOUNT": "Portefeuille",
        "MY_ORDERS": "Acquisitions",
        "OFFERS": "Offres Privées",
        "SUPPORT": "Conciergerie",
        "AI_ASSISTANT_TITLE": "Conseiller Numérique",
        "SUPPORT_CHAT": "Bureau Concierge VIP",
        "AI_WELCOME": "Bienvenue chez LUXVONO. Je suis votre conseiller numérique d'exception. Comment puis-je vous guider ?",
        "AI_TYPING": "Le conseiller analyse votre demande...",
        "SUPPORT_TYPING": "Le concierge écrit...",
        "LOGIN_VIEW_ORDERS": "Connexion pour voir les acquisitions",
        "TYPE_TO_SUPPORT": "Écrire à votre concierge dédié...",
        "ASK_ABOUT_PRODUCTS": "Renseignez-vous sur l'horlogerie, la joaillerie ou la livraison...",
        "SAVE": "Enregistrer",
        "CANCEL": "Annuler",
        "ALL_CATEGORIES": "Toutes les catégories",
        "BESPOKE_SOURCING": "Sourcing sur mesure",
        "VIP_LOUNGE": "Salon VIP",
        "GUARANTEED_QUALITY": "100% Qualité et authenticité garanties",
        "PREMIER_GLOBAL_PLATFORM": "Plateforme d'approvisionnement de luxe",
        "WELCOME_TO_LUXVONO": "Bienvenue chez LUXVONO",
        "JOIN_NOW": "Rejoindre maintenant",
        "LOGIN": "Connexion",
        "SELL_WITH_US": "Devenir vendeur partenaire",
        "VENDOR_PORTAL": "Portail Vendeur",
        "VENDOR_DASHBOARD": "Tableau de bord Vendeur",
        "APPLY_NOW": "Postuler maintenant",
        "SIGN_IN_ACCESS": "Connectez-vous pour accéder à votre compte",
        "SEARCH_PROMPT": "Rechercher des produits, marques, catégories...",
        "FULL_NAME_REQUIRED": "Nom complet légal *",
        "PHONE_REQUIRED": "Numéro de téléphone *",
        "BACKUP_PHONE": "Numéro secondaire (facultatif)",
        "FULL_ADDRESS": "Adresse détaillée (Rue, Bâtiment, Ville) *",
        "CITY": "Ville *",
        "COUNTRY": "Pays *",
        "STREET": "Rue et numéro",
        "POSTAL_CODE": "Code postal",
        "PAYMENT_METHOD": "Moyen de paiement",
        "CREDIT_DEBIT_CARD": "Carte Bancaire / Apple Pay",
        "PAY_CARD_DESC": "Paiement instantané hautement sécurisé.",
        "CASH_ON_DELIVERY": "Paiement à la livraison",
        "PAY_CASH_DESC": "Paiement en espèces lors de la livraison en main propre.",
        "MOBILE_WALLET": "Portefeuilles Numériques",
        "PAY_WALLET_DESC": "Virement instantané par portefeuille mobile.",
        "BANK_TRANSFER": "Virement bancaire direct",
        "PAY_BANK_DESC": "Virement direct sur notre compte d'entreprise officiel.",
        "UPLOAD_RECEIPT": "Joindre le reçu de virement",
        "PROCESSING_ORDER": "Traitement de votre commande en cours...",
        "PLACE_ORDER": "Confirmer et commander",
        "TAX": "TVA / Taxes",
        "QTY": "Quantité",
        "FOR_YOU": "Sélectionné pour vous",
        "BACK_TO_FEED": "← Retour à la galerie",
        "NO_CONTENT_FOUND": "Aucun contenu exclusif pour le moment.",
        "PRIORITY_GLOBAL_DELIVERY": "Livraison Internationale Prioritaire",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Transit rapide et assuré dans le monde entier",
        "SECURE_CHECKOUT_TITLE": "Paiement 100% Sécurisé",
        "SECURE_CHECKOUT_DESC": "Transactions cryptées et garantie acheteur",
        "CURATED_AUTHENTICITY": "Authenticité Certifiée",
        "CURATED_AUTHENTICITY_DESC": "Contrôle qualité rigoureux avant expédition",
        "DEDICATED_CONCIERGE": "Concierge Dédié 24/7",
        "DEDICATED_CONCIERGE_DESC": "Assistance prioritaire 24h/24 et 7j/7",
        "CUSTOMER_CARE": "Service Client",
        "TRACK_ORDER": "Suivi de Commande",
        "VIP_CLUB": "Club VIP Concierge",
        "HELP_SUPPORT": "Aide & Support",
        "ABOUT_LUXVONO": "À Propos de LUXVONO",
        "ABOUT_US_VISION": "Notre Histoire & Vision",
        "SUPPLIER_PORTAL": "Portail Fournisseurs",
        "LUXVONO_MAGAZINE": "Magazine LUXVONO",
        "TERMS_CONDITIONS": "Conditions Générales",
        "PRIVACY_POLICY": "Politique de Confidentialité",
        "SECURE_PAYMENTS": "Paiements Sécurisés",
        "CONTACT_CONCIERGE_BTN": "Contacter le Concierge VIP ✦",
        "DIRECT_VIP_PHONE": "Ligne Directe VIP",
        "OFFICIAL_SUPPORT_EMAIL": "Email Officiel du Support",
        "GLOBAL_STANDARDS": "Normes Mondiales du Commerce de Prestige",
        "CONNECT_WITH_US": "SUIVEZ LUXVONO :",
        "EMAIL_ADDRESS": "Adresse E-mail",
        "PASSWORD": "Mot de passe",
        "FORGOT_PASSWORD": "Mot de passe oublié ?",
        "AUTHENTICATING": "Authentification...",
        "OR_CONTINUE_WITH": "Ou continuer avec",
        "NEW_TO_LUXVONO": "Nouveau sur LuxVono ?",
        "CREATE_ACCOUNT_DESC": "Créez un compte exclusif dès aujourd'hui pour des tarifs privilégiés et un service sur mesure.",
        "CREATE_ACCOUNT_BTN": "Créer un Compte ✦",
        "JOIN_LUXVONO": "Rejoindre LUXVONO",
        "ENTER_EMAIL_START": "Entrez votre e-mail pour commencer avec votre compte privé.",
        "COMPLETE_SETUP": "Finaliser la Configuration",
        "VERIFY_EMAIL": "Vérifier votre E-mail",
        "ENTER_6DIGIT_CODE": "Entrez le code à 6 chiffres pour activer votre compte",
        "SECURE_ACCOUNT": "Sécurisez votre portefeuille avec un cryptage de haut niveau",
        "SENDING_CODE": "Envoi du code...",
        "CONTINUE": "Continuer",
        "CODE_SENT_TO": "Entrez le code à 6 chiffres envoyé à :",
        "DIDNT_RECEIVE_CODE": "Code non reçu ? Renvoyer dans",
        "RESEND_VERIFICATION_CODE": "↻ Renvoyer le code de vérification",
        "VERIFY_CODE": "Vérifier le Code",
        "VERIFYING": "Vérification...",
        "CHANGE_EMAIL": "Changer d'adresse E-mail",
        "FIRST_NAME": "Prénom",
        "LAST_NAME": "Nom",
        "PHONE_OPTIONAL": "Numéro de téléphone (Optionnel)",
        "PASSWORD_REQUIREMENTS": "Au moins 8 caractères contenant des lettres et des chiffres.",
        "CREATING_ACCOUNT": "Création du compte...",
        "CREATE_ACCOUNT_SIGN_IN": "Créer un Compte & Se Connecter",
        "ALREADY_HAVE_ACCOUNT": "Vous avez déjà un compte ?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Connectez-vous pour accéder à vos commandes et suivre vos livraisons.",
        "SIGN_IN_TO_ACCOUNT": "Se connecter au compte →",
        "RESET_PASSWORD": "Réinitialiser le mot de passe",
        "FORGOT_PASSWORD_SUBTITLE": "Entrez votre e-mail pour recevoir un code de vérification.",
        "NEW_PASSWORD": "Nouveau mot de passe",
        "ENTER_NEW_PASSWORD": "Entrez votre nouveau mot de passe sécurisé.",
        "SEND_RESET_LINK": "Envoyer le code",
        "REMEMBER_PASSWORD": "Mot de passe retrouvé ?",
        "REMEMBER_PASSWORD_DESC": "Vous pouvez retourner à la page de connexion.",
        "BACK_TO_SIGN_IN": "Retour à la connexion →",
        "STORE_RATING": "Note de la Boutique",
        "ON_TIME_DELIVERY": "Livraison à Temps",
        "RESPONSE_TIME": "Temps de Réponse",
        "CUSTOM_LOGO": "✓ Logo Personnalisé",
        "CUSTOM_PACKAGING": "✓ Emballage Personnalisé",
        "CUSTOMER_REVIEWS": "Avis et Évaluations Clients",
        "VIEW_REVIEWS": "Voir les Avis ✦",
        "WHOLESALE_ACTIVE": "Tarif de Gros Actif",
        "LOWEST_PRICE_GUARANTEE": "🔥 Garantie Meilleur Prix",
        "ALWAYS_AVAILABLE": "Toujours disponible",
        "OUT_OF_STOCK": "Épuisé",
        "ONLY_1_LEFT": "Plus qu'une seule pièce !",
        "ONLY_FEW_LEFT": "Plus que quelques pièces !",
        "LIMITED_QUANTITY": "Quantités Limitées",
        "REMAINING_STOCK": "Stock Restant",
        "WHOLESALE_AVAILABLE": "💎 Tarifs de gros disponibles",
        "ESTIMATED_DELIVERY": "Livraison Estimée",
        "PRODUCT_VIDEO_INCLUDED": "Vidéo du produit disponible",
        "SCENT_SIGNATURE": "Pyramide Olfactive & Signature",
        "SCENT_FAMILY": "Famille Olfactive :",
        "TOP_NOTES": "Notes de Tête",
        "HEART_NOTES": "Notes de Cœur",
        "BASE_NOTES": "Notes de Fond",
        "INGREDIENTS": "Ingrédients :",
        "VEHICLE_SPECS": "Spécifications du Véhicule",
        "MODEL": "Modèle",
        "YEAR": "Année",
        "MILEAGE": "Kilométrage",
        "ENGINE": "Moteur",
        "TRANSMISSION": "Transmission",
        "SHOWROOM_LOCATION": "Lieu de Retrait Showroom VIP",
        "UNMUTE": "Activer le son 🔊",
        "MUTE": "Couper le son 🔇",
        "ZOOM_IN": "Agrandir",
        "ZOOM_OUT": "Réduire"
    },
    "es": {
        "HOME": "INICIO",
        "COLLECTIONS": "COLECCIONES",
        "VIDEO_COMMERCE": "TEATRO DE VIDEO",
        "NAV_VIP": "SALÓN VIP",
        "NAV_LIVE": "TRANSMISIÓN EN VIVO",
        "NAV_MAGAZINE": "LA CRÓNICA",
        "NAV_SOURCING": "ADQUISICIÓN A MEDIDA",
        "SEARCH_PLACEHOLDER": "Buscar en nuestras colecciones de lujo...",
        "CART": "BOLSA",
        "ORDERS": "ADQUISICIONES",
        "LIVE_AUDIO": "AUDIO EN VIVO",
        "CONTACT": "CONTACTAR CONSERJE",
        "SECURE_CHECKOUT": "Pago Seguro",
        "LOGOUT": "Cerrar Sesión",
        "SIGN_IN": "Iniciar Sesión",
        "REGIONAL_SETTINGS": "Preferencias Regionales",
        "SHIP_TO": "País de Envío",
        "LANGUAGE": "Idioma",
        "CURRENCY": "Moneda",
        "REDEFINING": "REDEFINIENDO LA EXCELENCIA",
        "EXPLORE_COLLECTION": "Descubrir la Colección",
        "AUTHENTIC_BRANDS": "100% Autenticidad Garantizada",
        "ENCRYPTED_CHECKOUT": "Pago Encriptado y Seguro",
        "CONCIERGE_SUPPORT": "Soporte Concierge 24/7",
        "ADD_TO_CART": "Añadir a la Bolsa",
        "ADD_TO_CART_BTN": "AÑADIR A LA BOLSA",
        "BUY_NOW": "Adquirir Ahora",
        "NEW_ARRIVALS": "Nuevas Creaciones",
        "NEW": "NUEVO",
        "TRENDING": "Piezas Más Codiciadas",
        "RECOMMENDED": "SELECCIÓN EXCLUSIVA",
        "VIEW_ALL": "Ver Todo",
        "BACK": "Volver",
        "GIFT_WRAPPING": "Envoltorio de regalo de cortesía",
        "FREE_SHIPPING": "Envío exprés internacional gratuito",
        "WARRANTY": "Garantía de dos años Luxvono",
        "TRACKED_SHIPPING": "Seguimiento prioritario asegurado",
        "EASY_RETURNS": "Devoluciones sencillas en 14 días",
        "YOUR_CART": "SU SELECCIÓN",
        "CART_EMPTY": "Su bolsa está vacía actualmente.",
        "CONTINUE_SHOPPING": "Continuar Explorando",
        "ORDER_SUMMARY": "Resumen de Compra",
        "SUBTOTAL": "Subtotal",
        "SHIPPING": "Envío Prioritario",
        "COMPLIMENTARY": "Cortesía",
        "TOTAL": "Total",
        "PROCEED_CHECKOUT": "PROCEDER AL PAGO",
        "CHECKOUT": "Pago",
        "EMPTY_CART": "Su selección privada está esperando.",
        "MY_ACCOUNT": "Mi Cuenta",
        "MY_ORDERS": "Mis Pedidos",
        "OFFERS": "Ofertas Privadas",
        "SUPPORT": "Conserjería",
        "AI_ASSISTANT_TITLE": "Asesor Digital de Lujo",
        "SUPPORT_CHAT": "Oficina Concierge VIP",
        "AI_WELCOME": "Bienvenido a LUXVONO. Soy su asesor digital exclusivo. ¿En qué puedo orientarle hoy?",
        "AI_TYPING": "El asesor está analizando su solicitud...",
        "SUPPORT_TYPING": "El conserje está escribiendo...",
        "LOGIN_VIEW_ORDERS": "Inicie sesión para ver pedidos",
        "TYPE_TO_SUPPORT": "Escriba a su conserje VIP...",
        "ASK_ABOUT_PRODUCTS": "Pregunte por relojes, joyas o envíos...",
        "SAVE": "Guardar Preferencias",
        "CANCEL": "Cancelar",
        "ALL_CATEGORIES": "Todas las Categorías",
        "BESPOKE_SOURCING": "Adquisición a Medida",
        "VIP_LOUNGE": "Salón VIP",
        "GUARANTEED_QUALITY": "100% Calidad y Autenticidad Garantizadas",
        "PREMIER_GLOBAL_PLATFORM": "Plataforma Global de Compras de Lujo",
        "WELCOME_TO_LUXVONO": "Bienvenido a LUXVONO",
        "JOIN_NOW": "Unirse Ahora",
        "LOGIN": "Iniciar Sesión",
        "SELL_WITH_US": "Vender como Proveedor",
        "VENDOR_PORTAL": "Portal de Proveedores",
        "VENDOR_DASHBOARD": "Panel de Proveedores",
        "APPLY_NOW": "Postularse Ahora",
        "SIGN_IN_ACCESS": "Inicie sesión para acceder a su cuenta exclusiva",
        "SEARCH_PROMPT": "Buscar productos, marcas, categorías...",
        "FULL_NAME_REQUIRED": "Nombre Completo Legal *",
        "PHONE_REQUIRED": "Teléfono de Contacto Principal *",
        "BACKUP_PHONE": "Teléfono Alternativo (Opcional)",
        "FULL_ADDRESS": "Dirección Completa (Calle, Edificio, Ciudad) *",
        "CITY": "Ciudad *",
        "COUNTRY": "País *",
        "STREET": "Calle y Número",
        "POSTAL_CODE": "Código Postal",
        "PAYMENT_METHOD": "Método de Pago",
        "CREDIT_DEBIT_CARD": "Tarjeta de Crédito / Débito / Apple Pay",
        "PAY_CARD_DESC": "Pago seguro e instantáneo.",
        "CASH_ON_DELIVERY": "Pago contra Reembolso",
        "PAY_CASH_DESC": "Pago en efectivo en el momento de la entrega.",
        "MOBILE_WALLET": "Billeteras Digitales",
        "PAY_WALLET_DESC": "Pago mediante billeteras móviles autorizadas.",
        "BANK_TRANSFER": "Transferencia Bancaria Directa",
        "PAY_BANK_DESC": "Transferencia directa a nuestras cuentas corporativas oficiales.",
        "UPLOAD_RECEIPT": "Adjuntar comprobante de transferencia",
        "PROCESSING_ORDER": "Procesando su pedido exclusivo...",
        "PLACE_ORDER": "Confirmar y Realizar Pedido",
        "TAX": "Impuestos / IVA",
        "QTY": "Cantidad",
        "FOR_YOU": "Selección para usted",
        "BACK_TO_FEED": "← Volver a la galería",
        "NO_CONTENT_FOUND": "No hay contenido exclusivo disponible en este momento.",
        "PRIORITY_GLOBAL_DELIVERY": "Envío Global Prioritario",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Tránsito internacional rápido y asegurado",
        "SECURE_CHECKOUT_TITLE": "Pago 100% Seguro",
        "SECURE_CHECKOUT_DESC": "Transacciones encriptadas y protección al comprador",
        "CURATED_AUTHENTICITY": "Autenticidad Certificada",
        "CURATED_AUTHENTICITY_DESC": "Control de calidad riguroso antes del envío",
        "DEDICATED_CONCIERGE": "Conserjería Exclusiva 24/7",
        "DEDICATED_CONCIERGE_DESC": "Asistencia prioritaria las 24 horas",
        "CUSTOMER_CARE": "Atención al Cliente",
        "TRACK_ORDER": "Rastrear Pedido",
        "VIP_CLUB": "Club Concierge VIP",
        "HELP_SUPPORT": "Ayuda y Soporte",
        "ABOUT_LUXVONO": "Acerca de LUXVONO",
        "ABOUT_US_VISION": "Sobre Nosotros y Visión",
        "SUPPLIER_PORTAL": "Portal de Proveedores",
        "LUXVONO_MAGAZINE": "Revista LUXVONO",
        "TERMS_CONDITIONS": "Términos y Condiciones",
        "PRIVACY_POLICY": "Política de Privacidad",
        "SECURE_PAYMENTS": "Pagos Seguros",
        "CONTACT_CONCIERGE_BTN": "Contactar Conserje VIP ✦",
        "DIRECT_VIP_PHONE": "Teléfono VIP Directo",
        "OFFICIAL_SUPPORT_EMAIL": "Correo Electrónico Oficial",
        "GLOBAL_STANDARDS": "Estándares Globales de Comercio de Lujo",
        "CONNECT_WITH_US": "SÍGUENOS EN REDES:",
        "EMAIL_ADDRESS": "Correo Electrónico",
        "PASSWORD": "Contraseña",
        "FORGOT_PASSWORD": "¿Olvidó su contraseña?",
        "AUTHENTICATING": "Autenticando...",
        "OR_CONTINUE_WITH": "O continuar con",
        "NEW_TO_LUXVONO": "¿Nuevo en LuxVono?",
        "CREATE_ACCOUNT_DESC": "Cree una cuenta exclusiva hoy para precios preferenciales y servicio personalizado.",
        "CREATE_ACCOUNT_BTN": "Crear una Cuenta ✦",
        "JOIN_LUXVONO": "Unirse a LUXVONO",
        "ENTER_EMAIL_START": "Ingrese su correo para comenzar con su cuenta privada.",
        "COMPLETE_SETUP": "Completar Registro",
        "VERIFY_EMAIL": "Verifique su Correo",
        "ENTER_6DIGIT_CODE": "Ingrese el código de 6 dígitos para activar su cuenta",
        "SECURE_ACCOUNT": "Proteja su cartera con encriptación estándar",
        "SENDING_CODE": "Enviando código...",
        "CONTINUE": "Continuar",
        "CODE_SENT_TO": "Ingrese el código de 6 dígitos enviado a:",
        "DIDNT_RECEIVE_CODE": "¿No recibió el código? Reenviar en",
        "RESEND_VERIFICATION_CODE": "↻ Reenviar código de verificación",
        "VERIFY_CODE": "Verificar Código",
        "VERIFYING": "Verificando...",
        "CHANGE_EMAIL": "Cambiar Correo",
        "FIRST_NAME": "Nombre",
        "LAST_NAME": "Apellido",
        "PHONE_OPTIONAL": "Teléfono (Opcional)",
        "PASSWORD_REQUIREMENTS": "Mínimo 8 caracteres con letras y números.",
        "CREATING_ACCOUNT": "Creando cuenta...",
        "CREATE_ACCOUNT_SIGN_IN": "Crear Cuenta e Iniciar Sesión",
        "ALREADY_HAVE_ACCOUNT": "¿Ya tiene una cuenta?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Inicie sesión para acceder a sus pedidos y rastrear envíos.",
        "SIGN_IN_TO_ACCOUNT": "Iniciar Sesión →",
        "RESET_PASSWORD": "Restablecer Contraseña",
        "FORGOT_PASSWORD_SUBTITLE": "Ingrese su correo para recibir el código de verificación.",
        "NEW_PASSWORD": "Nueva Contraseña",
        "ENTER_NEW_PASSWORD": "Ingrese su nueva contraseña segura.",
        "SEND_RESET_LINK": "Enviar Código",
        "REMEMBER_PASSWORD": "¿Recordó su contraseña?",
        "REMEMBER_PASSWORD_DESC": "Puede volver a la página de inicio de sesión.",
        "BACK_TO_SIGN_IN": "Volver a Iniciar Sesión →",
        "STORE_RATING": "Calificación Tienda",
        "ON_TIME_DELIVERY": "Entrega Puntual",
        "RESPONSE_TIME": "Tiempo de Respuesta",
        "CUSTOM_LOGO": "✓ Logo Personalizado",
        "CUSTOM_PACKAGING": "✓ Empaque Personalizado",
        "CUSTOMER_REVIEWS": "Opiniones y Reseñas",
        "VIEW_REVIEWS": "Ver Reseñas ✦",
        "WHOLESALE_ACTIVE": "Precio Mayorista Activo",
        "LOWEST_PRICE_GUARANTEE": "🔥 Garantía Mejor Precio",
        "ALWAYS_AVAILABLE": "Siempre disponible",
        "OUT_OF_STOCK": "Agotado",
        "ONLY_1_LEFT": "¡Solo queda 1 unidad!",
        "ONLY_FEW_LEFT": "¡Solo quedan pocas unidades!",
        "LIMITED_QUANTITY": "Cantidades Limitadas",
        "REMAINING_STOCK": "Stock Restante",
        "WHOLESALE_AVAILABLE": "💎 Precios por mayor disponibles",
        "ESTIMATED_DELIVERY": "Entrega Estimada",
        "PRODUCT_VIDEO_INCLUDED": "Video del producto disponible",
        "SCENT_SIGNATURE": "Pirámide Olfativa",
        "SCENT_FAMILY": "Familia Olfativa:",
        "TOP_NOTES": "Notas de Salida",
        "HEART_NOTES": "Notas de Corazón",
        "BASE_NOTES": "Notas de Fondo",
        "INGREDIENTS": "Ingredientes:",
        "VEHICLE_SPECS": "Especificaciones del Vehículo",
        "MODEL": "Modelo",
        "YEAR": "Año",
        "MILEAGE": "Kilometraje",
        "ENGINE": "Motor",
        "TRANSMISSION": "Transmisión",
        "SHOWROOM_LOCATION": "Ubicación de Retiro Showroom VIP",
        "UNMUTE": "Activar sonido 🔊",
        "MUTE": "Silenciar 🔇",
        "ZOOM_IN": "Acercar",
        "ZOOM_OUT": "Alejar"
    },
    "it": {
        "HOME": "HOME",
        "COLLECTIONS": "COLLEZIONI",
        "VIDEO_COMMERCE": "TEATRO VIDEO",
        "NAV_VIP": "SALOTTO VIP",
        "NAV_LIVE": "VETRINA LIVE",
        "NAV_MAGAZINE": "LA CRONACA",
        "NAV_SOURCING": "SOURCING SU MISURA",
        "SEARCH_PLACEHOLDER": "Cerca nelle nostre collezioni di lusso...",
        "CART": "CARRELLO",
        "ORDERS": "ACQUISIZIONI",
        "LIVE_AUDIO": "AUDIO LIVE",
        "CONTACT": "CONTATTA CONCIERGE",
        "SECURE_CHECKOUT": "Pagamento Sicuro",
        "LOGOUT": "Disconnetti",
        "SIGN_IN": "Accedi",
        "REGIONAL_SETTINGS": "Preferenze Regionali",
        "SHIP_TO": "Paese di Destinazione",
        "LANGUAGE": "Lingua",
        "CURRENCY": "Valuta",
        "REDEFINING": "L'ECCELLENZA RIDEFINITA",
        "EXPLORE_COLLECTION": "Scopri la Collezione",
        "AUTHENTIC_BRANDS": "100% Autenticità Certificata",
        "ENCRYPTED_CHECKOUT": "Pagamento Crittografato Protetto",
        "CONCIERGE_SUPPORT": "Supporto Concierge Dedicato 24/7",
        "ADD_TO_CART": "Aggiungi al Carrello",
        "ADD_TO_CART_BTN": "AGGIUNGI AL CARRELLO",
        "BUY_NOW": "Acquista Ora",
        "NEW_ARRIVALS": "Nuovi Arrivi",
        "NEW": "NUOVO",
        "TRENDING": "Icone Più Ricercate",
        "RECOMMENDED": "CURATO PER LEI",
        "VIEW_ALL": "Mostra Tutto",
        "BACK": "Indietro",
        "GIFT_WRAPPING": "Confezione regalo esclusiva in omaggio",
        "FREE_SHIPPING": "Spedizione espressa internazionale gratuita",
        "WARRANTY": "Garanzia di due anni Luxvono",
        "TRACKED_SHIPPING": "Tracciamento prioritario assicurato",
        "EASY_RETURNS": "Reso facile entro 14 giorni",
        "YOUR_CART": "LA SUA SELEZIONE",
        "CART_EMPTY": "Il carrello è attualmente vuoto.",
        "CONTINUE_SHOPPING": "Continua lo Shopping",
        "ORDER_SUMMARY": "Riepilogo Ordine",
        "SUBTOTAL": "Subtotale",
        "SHIPPING": "Spedizione Espressa",
        "COMPLIMENTARY": "Offerto",
        "TOTAL": "Totale",
        "PROCEED_CHECKOUT": "PROCEDI ALL'ACQUISTO",
        "CHECKOUT": "Acquisto",
        "EMPTY_CART": "La sua selezione privata è in attesa.",
        "MY_ACCOUNT": "Account",
        "MY_ORDERS": "Ordini",
        "OFFERS": "Offerte Private",
        "SUPPORT": "Concierge",
        "AI_ASSISTANT_TITLE": "Consulente Digitale",
        "SUPPORT_CHAT": "Ufficio Concierge VIP",
        "AI_WELCOME": "Benvenuto in LUXVONO. Sono il suo consulente digitale di prestigio. Come posso aiutarla oggi?",
        "AI_TYPING": "Il consulente sta analizzando la richiesta...",
        "SUPPORT_TYPING": "Il concierge sta scrivendo...",
        "LOGIN_VIEW_ORDERS": "Accedi per visualizzare gli ordini",
        "TYPE_TO_SUPPORT": "Scrivi al tuo concierge VIP...",
        "ASK_ABOUT_PRODUCTS": "Chiedi di orologi, gioielli o spedizioni...",
        "SAVE": "Salva Preferenze",
        "CANCEL": "Annulla",
        "ALL_CATEGORIES": "Tutte le Categorie",
        "BESPOKE_SOURCING": "Sourcing su Misura",
        "VIP_LOUNGE": "Salotto VIP",
        "GUARANTEED_QUALITY": "100% Qualità e Autenticità Garantite",
        "PREMIER_GLOBAL_PLATFORM": "Piattaforma Globale di Lusso",
        "WELCOME_TO_LUXVONO": "Benvenuto in LUXVONO",
        "JOIN_NOW": "Iscriviti Ora",
        "LOGIN": "Accedi",
        "SELL_WITH_US": "Diventa Fornitore",
        "VENDOR_PORTAL": "Portale Fornitori",
        "VENDOR_DASHBOARD": "Dashboard Fornitori",
        "APPLY_NOW": "Candidati Ora",
        "SIGN_IN_ACCESS": "Accedi per visualizzare il tuo account",
        "SEARCH_PROMPT": "Cerca prodotti, marchi, categorie...",
        "FULL_NAME_REQUIRED": "Nome e Cognome *",
        "PHONE_REQUIRED": "Numero di Telefono *",
        "BACKUP_PHONE": "Numero Alternativo",
        "FULL_ADDRESS": "Indirizzo Completo (Via, Civico, Città) *",
        "CITY": "Città *",
        "COUNTRY": "Paese *",
        "STREET": "Via e Numero",
        "POSTAL_CODE": "CAP",
        "PAYMENT_METHOD": "Metodo di Pagamento",
        "CREDIT_DEBIT_CARD": "Carta di Credito / Apple Pay",
        "PAY_CARD_DESC": "Pagamento immediato e protetto.",
        "CASH_ON_DELIVERY": "Pagamento alla Consegna",
        "PAY_CASH_DESC": "Pagamento in contanti alla consegna.",
        "MOBILE_WALLET": "Portafogli Digitali",
        "PAY_WALLET_DESC": "Pagamento tramite portafoglio mobile.",
        "BANK_TRANSFER": "Bonifico Bancario Diretto",
        "PAY_BANK_DESC": "Bonifico sui nostri conti aziendali ufficiali.",
        "UPLOAD_RECEIPT": "Allega ricevuta di pagamento",
        "PROCESSING_ORDER": "Elaborazione dell'ordine in corso...",
        "PLACE_ORDER": "Conferma e Ordina",
        "TAX": "IVA",
        "QTY": "Quantità",
        "FOR_YOU": "Scelto per lei",
        "BACK_TO_FEED": "← Torna alla galleria",
        "NO_CONTENT_FOUND": "Nessun contenuto disponibile al momento.",
        "PRIORITY_GLOBAL_DELIVERY": "Spedizione Globale Prioritaria",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Transito internazionale rapido e assicurato",
        "SECURE_CHECKOUT_TITLE": "Pagamento Sicuro al 100%",
        "SECURE_CHECKOUT_DESC": "Transazioni crittografate e protezione acquirente",
        "CURATED_AUTHENTICITY": "Autenticità Certificata",
        "CURATED_AUTHENTICITY_DESC": "Rigido controllo di qualità prima della spedizione",
        "DEDICATED_CONCIERGE": "Concierge Dedicato 24/7",
        "DEDICATED_CONCIERGE_DESC": "Assistenza prioritaria 24 ore su 24",
        "CUSTOMER_CARE": "Servizio Clienti",
        "TRACK_ORDER": "Traccia Ordine",
        "VIP_CLUB": "Club VIP Concierge",
        "HELP_SUPPORT": "Aiuto e Supporto",
        "ABOUT_LUXVONO": "Chi Siamo",
        "ABOUT_US_VISION": "Storia e Visione",
        "SUPPLIER_PORTAL": "Portale Fornitori",
        "LUXVONO_MAGAZINE": "Rivista LUXVONO",
        "TERMS_CONDITIONS": "Termini e Condizioni",
        "PRIVACY_POLICY": "Informativa sulla Privacy",
        "SECURE_PAYMENTS": "Pagamenti Protetti",
        "CONTACT_CONCIERGE_BTN": "Contatta Concierge VIP ✦",
        "DIRECT_VIP_PHONE": "Telefono Diretto VIP",
        "OFFICIAL_SUPPORT_EMAIL": "Email di Supporto Ufficiale",
        "GLOBAL_STANDARDS": "Standard Globali per il Commercio di Lusso",
        "CONNECT_WITH_US": "SEGUICI SU:",
        "EMAIL_ADDRESS": "Indirizzo E-mail",
        "PASSWORD": "Password",
        "FORGOT_PASSWORD": "Password dimenticata?",
        "AUTHENTICATING": "Autenticazione in corso...",
        "OR_CONTINUE_WITH": "O continua con",
        "NEW_TO_LUXVONO": "Nuovo su LuxVono?",
        "CREATE_ACCOUNT_DESC": "Crea un account esclusivo oggi per prezzi prioritari e servizio personalizzato.",
        "CREATE_ACCOUNT_BTN": "Crea un Account ✦",
        "JOIN_LUXVONO": "Unisciti a LUXVONO",
        "ENTER_EMAIL_START": "Inserisci la tua e-mail per iniziare.",
        "COMPLETE_SETUP": "Completa Registrazione",
        "VERIFY_EMAIL": "Verifica la tua E-mail",
        "ENTER_6DIGIT_CODE": "Inserisci il codice a 6 cifre per attivare l'account",
        "SECURE_ACCOUNT": "Proteggi il tuo portafoglio con crittografia bancaria",
        "SENDING_CODE": "Invio codice...",
        "CONTINUE": "Continua",
        "CODE_SENT_TO": "Inserisci il codice a 6 cifre inviato a:",
        "DIDNT_RECEIVE_CODE": "Non hai ricevuto il codice? Reinvia in",
        "RESEND_VERIFICATION_CODE": "↻ Reinvia codice di verifica",
        "VERIFY_CODE": "Verifica Codice",
        "VERIFYING": "Verifica in corso...",
        "CHANGE_EMAIL": "Modifica Indirizzo E-mail",
        "FIRST_NAME": "Nome",
        "LAST_NAME": "Cognome",
        "PHONE_OPTIONAL": "Telefono (Opzionale)",
        "PASSWORD_REQUIREMENTS": "Almeno 8 caratteri con lettere e numeri.",
        "CREATING_ACCOUNT": "Creazione account...",
        "CREATE_ACCOUNT_SIGN_IN": "Crea Account e Accedi",
        "ALREADY_HAVE_ACCOUNT": "Hai già un account?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Accedi per visualizzare i tuoi ordini e tracciare le spedizioni.",
        "SIGN_IN_TO_ACCOUNT": "Accedi all'Account →",
        "RESET_PASSWORD": "Reimposta Password",
        "FORGOT_PASSWORD_SUBTITLE": "Inserisci la tua e-mail per ricevere il codice.",
        "NEW_PASSWORD": "Nuova Password",
        "ENTER_NEW_PASSWORD": "Inserisci la tua nuova password sicura.",
        "SEND_RESET_LINK": "Invia Codice",
        "REMEMBER_PASSWORD": "Ti ricordi la password?",
        "REMEMBER_PASSWORD_DESC": "Puoi tornare direttamente alla pagina di accesso.",
        "BACK_TO_SIGN_IN": "Torna all'Accesso →",
        "STORE_RATING": "Valutazione Negozio",
        "ON_TIME_DELIVERY": "Consegna Puntuale",
        "RESPONSE_TIME": "Tempo di Risposta",
        "CUSTOM_LOGO": "✓ Logo Personalizzato",
        "CUSTOM_PACKAGING": "✓ Confezione Personalizzata",
        "CUSTOMER_REVIEWS": "Recensioni Clienti",
        "VIEW_REVIEWS": "Visualizza Recensioni ✦",
        "WHOLESALE_ACTIVE": "Prezzo all'Ingrosso Attivo",
        "LOWEST_PRICE_GUARANTEE": "🔥 Garanzia Miglior Prezzo",
        "ALWAYS_AVAILABLE": "Sempre disponibile",
        "OUT_OF_STOCK": "Esaurito",
        "ONLY_1_LEFT": "Solo 1 pezzo rimasto!",
        "ONLY_FEW_LEFT": "Solo pochi pezzi rimasti!",
        "LIMITED_QUANTITY": "Quantità Limitate",
        "REMAINING_STOCK": "Giacenza Rimanente",
        "WHOLESALE_AVAILABLE": "💎 Prezzi all'ingrosso disponibili",
        "ESTIMATED_DELIVERY": "Consegna Stimata",
        "PRODUCT_VIDEO_INCLUDED": "Video del prodotto disponibile",
        "SCENT_SIGNATURE": "Piramide Olfattiva",
        "SCENT_FAMILY": "Famiglia Olfattiva:",
        "TOP_NOTES": "Note di Testa",
        "HEART_NOTES": "Note di Cuore",
        "BASE_NOTES": "Note di Fondo",
        "INGREDIENTS": "Ingredienti:",
        "VEHICLE_SPECS": "Specifiche del Veicolo",
        "MODEL": "Modello",
        "YEAR": "Anno",
        "MILEAGE": "Chilometraggio",
        "ENGINE": "Motore",
        "TRANSMISSION": "Trasmissione",
        "SHOWROOM_LOCATION": "Ritiro Showroom VIP",
        "UNMUTE": "Attiva audio 🔊",
        "MUTE": "Disattiva audio 🔇",
        "ZOOM_IN": "Ingrandisci",
        "ZOOM_OUT": "Riduci"
    },
    "tr": {
        "HOME": "ANA SAYFA",
        "COLLECTIONS": "KOLEKSİYONLAR",
        "VIDEO_COMMERCE": "VİDEO VİTRİNİ",
        "NAV_VIP": "VIP SALONU",
        "NAV_LIVE": "CANLI YAYIN",
        "NAV_MAGAZINE": "LÜKS DERGİ",
        "NAV_SOURCING": "ÖZEL TEDARİK",
        "SEARCH_PLACEHOLDER": "Lüks koleksiyonlarımızda arayın...",
        "CART": "SEPET",
        "ORDERS": "SİPARİŞLER",
        "LIVE_AUDIO": "CANLI SES ODASI",
        "CONTACT": "CONCIERGE İLE İLETİŞİM",
        "SECURE_CHECKOUT": "Güvenli Ödeme",
        "LOGOUT": "Çıkış Yap",
        "SIGN_IN": "Giriş Yap",
        "REGIONAL_SETTINGS": "Bölgesel Tercihler",
        "SHIP_TO": "Teslimat Ülkesi",
        "LANGUAGE": "Dil",
        "CURRENCY": "Para Birimi",
        "REDEFINING": "MÜKEMMELLİĞİN YENİ TANIMI",
        "EXPLORE_COLLECTION": "Koleksiyonu Keşfet",
        "AUTHENTIC_BRANDS": "%100 Orijinallik Garantisi",
        "ENCRYPTED_CHECKOUT": "Şifreli Güvenli Ödeme",
        "CONCIERGE_SUPPORT": "7/24 Özel Concierge Hizmeti",
        "ADD_TO_CART": "Sepete Ekle",
        "ADD_TO_CART_BTN": "SEPETE EKLE",
        "BUY_NOW": "Hemen Satın Al",
        "NEW_ARRIVALS": "Yeni Tasarımlar",
        "NEW": "YENİ",
        "TRENDING": "En Çok Arananlar",
        "RECOMMENDED": "SİZİN İÇİN SEÇİLENLER",
        "VIEW_ALL": "Tümünü Gör",
        "BACK": "Geri",
        "GIFT_WRAPPING": "Özel hediye paketi ücretsiz",
        "FREE_SHIPPING": "Ücretsiz sigortalı uluslararası kargo",
        "WARRANTY": "İki yıl Luxvono garantisi",
        "TRACKED_SHIPPING": "Sigortalı kargo takibi",
        "EASY_RETURNS": "14 gün içinde kolay iade",
        "YOUR_CART": "SEÇİMLERİNİZ",
        "CART_EMPTY": "Sepetiniz şu anda boş.",
        "CONTINUE_SHOPPING": "Alışverişe Devam Et",
        "ORDER_SUMMARY": "Sipariş Özeti",
        "SUBTOTAL": "Ara Toplam",
        "SHIPPING": "Hızlı Kargo",
        "COMPLIMENTARY": "Ücretsiz",
        "TOTAL": "Toplam",
        "PROCEED_CHECKOUT": "ÖDEMEYE GEÇ",
        "CHECKOUT": "Ödeme",
        "EMPTY_CART": "Özel koleksiyonunuz sizi bekliyor.",
        "MY_ACCOUNT": "Hesabım",
        "MY_ORDERS": "Siparişlerim",
        "OFFERS": "Özel Teklifler",
        "SUPPORT": "Müşteri Hizmetleri",
        "AI_ASSISTANT_TITLE": "Dijital Lüks Danışmanı",
        "SUPPORT_CHAT": "VIP Concierge Ofisi",
        "AI_WELCOME": "LUXVONO'ya hoş geldiniz. Ben dijital danışmanınızım. Bugün size nasıl yardımcı olabilirim?",
        "AI_TYPING": "Danışman talebinizi inceliyor...",
        "SUPPORT_TYPING": "Concierge yazıyor...",
        "LOGIN_VIEW_ORDERS": "Siparişleri görmek için giriş yapın",
        "TYPE_TO_SUPPORT": "VIP Concierge'e mesaj yazın...",
        "ASK_ABOUT_PRODUCTS": "Saatler, mücevherler veya kargo hakkında sorun...",
        "SAVE": "Tercihleri Kaydet",
        "CANCEL": "İptal",
        "ALL_CATEGORIES": "Tüm Kategoriler",
        "BESPOKE_SOURCING": "Özel Tedarik",
        "VIP_LOUNGE": "VIP Salonu",
        "GUARANTEED_QUALITY": "%100 Kalite ve Orijinallik Garantisi",
        "PREMIER_GLOBAL_PLATFORM": "Küresel Lüks Tedarik Platformu",
        "WELCOME_TO_LUXVONO": "LUXVONO'ya Hoş Geldiniz",
        "JOIN_NOW": "Hemen Katılın",
        "LOGIN": "Giriş Yap",
        "SELL_WITH_US": "Tedarikçi Olarak Satış Yap",
        "VENDOR_PORTAL": "Tedarikçi Portalı",
        "VENDOR_DASHBOARD": "Tedarikçi Paneli",
        "APPLY_NOW": "Şimdi Başvur",
        "SIGN_IN_ACCESS": "Hesabınıza erişmek için giriş yapın",
        "SEARCH_PROMPT": "Ürün, marka, kategori arayın...",
        "FULL_NAME_REQUIRED": "Ad Soyad *",
        "PHONE_REQUIRED": "Telefon Numarası *",
        "BACKUP_PHONE": "İkinci Telefon (İsteğe bağlı)",
        "FULL_ADDRESS": "Açık Adres (Sokak, Bina, Şehir) *",
        "CITY": "Şehir *",
        "COUNTRY": "Ülke *",
        "STREET": "Sokak ve Bina",
        "POSTAL_CODE": "Posta Kodu",
        "PAYMENT_METHOD": "Ödeme Yöntemi",
        "CREDIT_DEBIT_CARD": "Kredi Kartı / Banka Kartı / Apple Pay",
        "PAY_CARD_DESC": "Anında ve güvenli ödeme.",
        "CASH_ON_DELIVERY": "Kapıda Ödeme",
        "PAY_CASH_DESC": "Teslimat anında nakit ödeme.",
        "MOBILE_WALLET": "Dijital Cüzdanlar",
        "PAY_WALLET_DESC": "Mobil cüzdan üzerinden ödeme.",
        "BANK_TRANSFER": "Doğrudan Banka Havalesi",
        "PAY_BANK_DESC": "Şirket banka hesabına doğrudan havale/EFT.",
        "UPLOAD_RECEIPT": "Havale Dekontunu Yükle",
        "PROCESSING_ORDER": "Siparişiniz işleniyor...",
        "PLACE_ORDER": "Siparişi Onayla ve Tamamla",
        "TAX": "KDV",
        "QTY": "Adet",
        "FOR_YOU": "Sizin İçin Seçilenler",
        "BACK_TO_FEED": "← Galeriye Dön",
        "NO_CONTENT_FOUND": "Şu anda özel içerik bulunamadı.",
        "PRIORITY_GLOBAL_DELIVERY": "Öncelikli Küresel Kargo",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Hızlı ve sigortalı uluslararası teslimat",
        "SECURE_CHECKOUT_TITLE": "%100 Güvenli Ödeme",
        "SECURE_CHECKOUT_DESC": "Şifreli işlemler ve alıcı koruma kalkanı",
        "CURATED_AUTHENTICITY": "Sertifikalı Orijinallik",
        "CURATED_AUTHENTICITY_DESC": "Gönderim öncesi titiz kalite denetimi",
        "DEDICATED_CONCIERGE": "7/24 Özel Concierge Hizmeti",
        "DEDICATED_CONCIERGE_DESC": "Günün her saati öncelikli yardım",
        "CUSTOMER_CARE": "Müşteri Hizmetleri",
        "TRACK_ORDER": "Kargo Takibi",
        "VIP_CLUB": "VIP Concierge Kulübü",
        "HELP_SUPPORT": "Yardım ve Destek",
        "ABOUT_LUXVONO": "LUXVONO Hakkında",
        "ABOUT_US_VISION": "Hakkımızda ve Vizyonumuz",
        "SUPPLIER_PORTAL": "Tedarikçi Portalı",
        "LUXVONO_MAGAZINE": "LUXVONO Dergisi",
        "TERMS_CONDITIONS": "Şartlar ve Koşullar",
        "PRIVACY_POLICY": "Gizlilik Politikası",
        "SECURE_PAYMENTS": "Güvenli Ödemeler",
        "CONTACT_CONCIERGE_BTN": "VIP Concierge ile İletişim ✦",
        "DIRECT_VIP_PHONE": "Doğrudan VIP Telefon",
        "OFFICIAL_SUPPORT_EMAIL": "Resmi Destek E-postası",
        "GLOBAL_STANDARDS": "Lüks Ticarette Küresel Standartlar",
        "CONNECT_WITH_US": "BİZİ TAKİP EDİN:",
        "EMAIL_ADDRESS": "E-posta Adresi",
        "PASSWORD": "Şifre",
        "FORGOT_PASSWORD": "Şifrenizi mi unuttunuz?",
        "AUTHENTICATING": "Doğrulanıyor...",
        "OR_CONTINUE_WITH": "Veya şununla devam et",
        "NEW_TO_LUXVONO": "LuxVono'da yeni misiniz?",
        "CREATE_ACCOUNT_DESC": "Özel fiyatlar ve hızlı teslimat için bugün özel bir hesap oluşturun.",
        "CREATE_ACCOUNT_BTN": "Hesap Oluştur ✦",
        "JOIN_LUXVONO": "LUXVONO'ya Katılın",
        "ENTER_EMAIL_START": "Özel hesabınızı oluşturmak için e-postanızı girin.",
        "COMPLETE_SETUP": "Kurulumu Tamamla",
        "VERIFY_EMAIL": "E-postanızı Doğrulayın",
        "ENTER_6DIGIT_CODE": "Hesabınızı etkinleştirmek için 6 haneli kodu girin",
        "SECURE_ACCOUNT": "Portföyünüzü en yüksek şifrelemeyle koruyun",
        "SENDING_CODE": "Kod gönderiliyor...",
        "CONTINUE": "Devam Et",
        "CODE_SENT_TO": "Şu adrese gönderilen 6 haneli kodu girin:",
        "DIDNT_RECEIVE_CODE": "Kod gelmedi mi? Yeniden gönder:",
        "RESEND_VERIFICATION_CODE": "↻ Doğrulama kodunu tekrar gönder",
        "VERIFY_CODE": "Kodu Doğrula",
        "VERIFYING": "Doğrulanıyor...",
        "CHANGE_EMAIL": "E-postayı Değiştir",
        "FIRST_NAME": "Ad",
        "LAST_NAME": "Soyad",
        "PHONE_OPTIONAL": "Telefon Numarası (İsteğe Bağlı)",
        "PASSWORD_REQUIREMENTS": "Harf ve rakamlardan oluşan en az 8 karakter.",
        "CREATING_ACCOUNT": "Hesap oluşturuluyor...",
        "CREATE_ACCOUNT_SIGN_IN": "Hesap Oluştur ve Giriş Yap",
        "ALREADY_HAVE_ACCOUNT": "Zaten bir hesabınız var mı?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Siparişlerinizi ve kargonuzu takip etmek için giriş yapın.",
        "SIGN_IN_TO_ACCOUNT": "Hesaba Giriş Yap →",
        "RESET_PASSWORD": "Şifreyi Sıfırla",
        "FORGOT_PASSWORD_SUBTITLE": "Doğrulama kodu almak için e-postanızı girin.",
        "NEW_PASSWORD": "Yeni Şifre",
        "ENTER_NEW_PASSWORD": "Yeni güçlü şifrenizi girin.",
        "SEND_RESET_LINK": "Doğrulama Kodunu Gönder",
        "REMEMBER_PASSWORD": "Şifrenizi hatırladınız mı?",
        "REMEMBER_PASSWORD_DESC": "Giriş sayfasına geri dönebilirsiniz.",
        "BACK_TO_SIGN_IN": "Girişe Dön →",
        "STORE_RATING": "Mağaza Puanı",
        "ON_TIME_DELIVERY": "Zamanında Teslimat",
        "RESPONSE_TIME": "Yanıt Süresi",
        "CUSTOM_LOGO": "✓ Özel Logo",
        "CUSTOM_PACKAGING": "✓ Özel Ambalaj",
        "CUSTOMER_REVIEWS": "Müşteri Değerlendirmeleri",
        "VIEW_REVIEWS": "Yorumları Gör ✦",
        "WHOLESALE_ACTIVE": "Toptan Fiyatı Aktif",
        "LOWEST_PRICE_GUARANTEE": "🔥 En Düşük Fiyat Garantisi",
        "ALWAYS_AVAILABLE": "Her Zaman Mevcut",
        "OUT_OF_STOCK": "Tükendi",
        "ONLY_1_LEFT": "Son 1 adet kaldı!",
        "ONLY_FEW_LEFT": "Sadece birkaç adet kaldı!",
        "LIMITED_QUANTITY": "Sınırlı Miktar",
        "REMAINING_STOCK": "Kalan Stok",
        "WHOLESALE_AVAILABLE": "💎 Toptan Fiyatlar Mevcut",
        "ESTIMATED_DELIVERY": "Tahmini Teslimat",
        "PRODUCT_VIDEO_INCLUDED": "Ürün videosu mevcut",
        "SCENT_SIGNATURE": "Koku Piramidi",
        "SCENT_FAMILY": "Koku Ailesi:",
        "TOP_NOTES": "Üst Notalar",
        "HEART_NOTES": "Kalp Notaları",
        "BASE_NOTES": "Dip Notalar",
        "INGREDIENTS": "İçindekiler:",
        "VEHICLE_SPECS": "Araç Özellikleri",
        "MODEL": "Model",
        "YEAR": "Yıl",
        "MILEAGE": "Kilometre",
        "ENGINE": "Motor",
        "TRANSMISSION": "Vites",
        "SHOWROOM_LOCATION": "VIP Showroom Teslimat Noktası",
        "UNMUTE": "Sesi Aç 🔊",
        "MUTE": "Sesi Kapat 🔇",
        "ZOOM_IN": "Yakınlaştır",
        "ZOOM_OUT": "Uzaklaştır"
    },
    "zh": {
        "HOME": "首页",
        "COLLECTIONS": "顶级藏品",
        "VIDEO_COMMERCE": "沉浸视频展厅",
        "NAV_VIP": "VIP 贵宾沙龙",
        "NAV_LIVE": "实况品鉴直播",
        "NAV_MAGAZINE": "奢华志",
        "NAV_SOURCING": "尊享定制采购",
        "SEARCH_PLACEHOLDER": "搜索顶级名表、高级珠宝与皮具...",
        "CART": "购物袋",
        "ORDERS": "珍藏订单",
        "LIVE_AUDIO": "贵宾私享语音厅",
        "CONTACT": "联系专属管家",
        "SECURE_CHECKOUT": "银行级加密结算",
        "LOGOUT": "退出登录",
        "SIGN_IN": "立即登录",
        "REGIONAL_SETTINGS": "国家与语言偏好",
        "SHIP_TO": "配送目的国",
        "LANGUAGE": "界面语言",
        "CURRENCY": "计价币种",
        "REDEFINING": "重塑极致奢华典范",
        "EXPLORE_COLLECTION": "探索当季典藏",
        "AUTHENTIC_BRANDS": "100% 官方正品防伪认证",
        "ENCRYPTED_CHECKOUT": "国际级安全支付协议",
        "CONCIERGE_SUPPORT": "24/7 私人专属管家服务",
        "ADD_TO_CART": "加入购物袋",
        "ADD_TO_CART_BTN": "加入购物袋",
        "BUY_NOW": "立即珍藏",
        "NEW_ARRIVALS": "最新传世佳作",
        "NEW": "新品",
        "TRENDING": "名流焦点臻品",
        "RECOMMENDED": "为您专属定制",
        "VIEW_ALL": "查看全部",
        "BACK": "返回",
        "GIFT_WRAPPING": "尊享典雅礼盒丝带包装",
        "FREE_SHIPPING": "全程高额保价全球特快专递",
        "WARRANTY": "LUXVONO 官方两年全球联保",
        "TRACKED_SHIPPING": "全程实时定位物流追踪",
        "EASY_RETURNS": "14天无忧退换特权",
        "YOUR_CART": "您的私享购物袋",
        "CART_EMPTY": "您的购物袋暂无藏品。",
        "CONTINUE_SHOPPING": "返回展厅继续选购",
        "ORDER_SUMMARY": "订单结算汇总",
        "SUBTOTAL": "藏品小计",
        "SHIPPING": "特快专递",
        "COMPLIMENTARY": "尊享免费",
        "TOTAL": "合计应付",
        "PROCEED_CHECKOUT": "进入安全结算",
        "CHECKOUT": "结算",
        "EMPTY_CART": "您的私享藏品袋正等待甄选。",
        "MY_ACCOUNT": "个人中心",
        "MY_ORDERS": "我的订单",
        "OFFERS": "贵宾专享特权",
        "SUPPORT": "专属管家",
        "AI_ASSISTANT_TITLE": "AI 智能数字顾问",
        "SUPPORT_CHAT": "VIP 私人管家办公室",
        "AI_WELCOME": "尊贵的客户，欢迎莅临 LUXVONO。我是您的 AI 智能顾问，今天为您提供怎样的专属服务？",
        "AI_TYPING": "智能顾问正在为您深度检索...",
        "SUPPORT_TYPING": "VIP 管家正在输入...",
        "LOGIN_VIEW_ORDERS": "登录查看珍藏订单",
        "TYPE_TO_SUPPORT": "向 VIP 专属管家发送信息...",
        "ASK_ABOUT_PRODUCTS": "咨询名表、珠宝、国际物流或正品保障...",
        "SAVE": "保存设置",
        "CANCEL": "取消",
        "ALL_CATEGORIES": "全部品类",
        "BESPOKE_SOURCING": "尊享定制采购",
        "VIP_LOUNGE": "贵宾沙龙",
        "GUARANTEED_QUALITY": "100% 正品品质保障",
        "PREMIER_GLOBAL_PLATFORM": "全球顶级奢侈品采购平台",
        "WELCOME_TO_LUXVONO": "欢迎莅临 LUXVONO",
        "JOIN_NOW": "即刻加入",
        "LOGIN": "登录",
        "SELL_WITH_US": "成为认证供应商",
        "VENDOR_PORTAL": "供应商门户",
        "VENDOR_DASHBOARD": "供应商管理后台",
        "APPLY_NOW": "立即申请",
        "SIGN_IN_ACCESS": "登录以访问您的尊享账户",
        "SEARCH_PROMPT": "搜索商品、品牌、品类...",
        "FULL_NAME_REQUIRED": "收件人真实姓名 *",
        "PHONE_REQUIRED": "联系电话 *",
        "BACKUP_PHONE": "备用联系电话",
        "FULL_ADDRESS": "详细收件地址 (街道、楼栋、门牌号) *",
        "CITY": "城市 *",
        "COUNTRY": "国家 *",
        "STREET": "街道与门牌",
        "POSTAL_CODE": "邮政编码",
        "PAYMENT_METHOD": "支付方式",
        "CREDIT_DEBIT_CARD": "信用卡 / 银联 / Apple Pay",
        "PAY_CARD_DESC": "银行级实时安全加密支付。",
        "CASH_ON_DELIVERY": "货到付款",
        "PAY_CASH_DESC": "专属管家送达时当面现金结清。",
        "MOBILE_WALLET": "微信支付 / 支付宝",
        "PAY_WALLET_DESC": "便捷的移动端即时安全转账。",
        "BANK_TRANSFER": "企业银行电汇",
        "PAY_BANK_DESC": "直接电汇至公司官方对公账户。",
        "UPLOAD_RECEIPT": "上传银行电汇凭证",
        "PROCESSING_ORDER": "正在处理您的尊享订单...",
        "PLACE_ORDER": "确认并提交订单",
        "TAX": "预估税费 / 关税",
        "QTY": "数量",
        "FOR_YOU": "为您精选",
        "BACK_TO_FEED": "← 返回展厅",
        "NO_CONTENT_FOUND": "当前暂无专属内容。",
        "PRIORITY_GLOBAL_DELIVERY": "全球优先特快专递",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "全程高额保价极速安全送达",
        "SECURE_CHECKOUT_TITLE": "100% 银行级安全结算",
        "SECURE_CHECKOUT_DESC": "高级加密通道与买家全额保障",
        "CURATED_AUTHENTICITY": "官方认证正品",
        "CURATED_AUTHENTICITY_DESC": "发货前经过多重权威质检鉴定",
        "DEDICATED_CONCIERGE": "24/7 私人专属管家",
        "DEDICATED_CONCIERGE_DESC": "全天候无间断尊享优先服务",
        "CUSTOMER_CARE": "客户关怀中心",
        "TRACK_ORDER": "实时物流追踪",
        "VIP_CLUB": "VIP 贵宾俱乐部",
        "HELP_SUPPORT": "帮助与支持",
        "ABOUT_LUXVONO": "关于 LUXVONO",
        "ABOUT_US_VISION": "品牌故事与愿景",
        "SUPPLIER_PORTAL": "供应商合作门户",
        "LUXVONO_MAGAZINE": "LUXVONO 奢华杂志",
        "TERMS_CONDITIONS": "服务条款与细则",
        "PRIVACY_POLICY": "隐私与数据安全政策",
        "SECURE_PAYMENTS": "安全合规支付",
        "CONTACT_CONCIERGE_BTN": "联系专属管家 ✦",
        "DIRECT_VIP_PHONE": "贵宾专属直通热线",
        "OFFICIAL_SUPPORT_EMAIL": "官方服务邮箱",
        "GLOBAL_STANDARDS": "全球顶级奢侈品商业卓越标准",
        "CONNECT_WITH_US": "关注官方渠道:",
        "EMAIL_ADDRESS": "电子邮箱",
        "PASSWORD": "登录密码",
        "FORGOT_PASSWORD": "忘记密码？",
        "AUTHENTICATING": "正在验证并登录...",
        "OR_CONTINUE_WITH": "或者通过以下方式",
        "NEW_TO_LUXVONO": "首次体验 LUXVONO？",
        "CREATE_ACCOUNT_DESC": "立即创建尊享专属账户，享受优先采购特权与全球极速礼遇。",
        "CREATE_ACCOUNT_BTN": "创建新账户 ✦",
        "JOIN_LUXVONO": "加入 LUXVONO",
        "ENTER_EMAIL_START": "输入您的电子邮箱以开启您的私享贵宾账户。",
        "COMPLETE_SETUP": "完成账户设置",
        "VERIFY_EMAIL": "验证您的邮箱",
        "ENTER_6DIGIT_CODE": "输入 6 位数验证码以激活您的账户",
        "SECURE_ACCOUNT": "以最高安全加密标准保障您的奢华资产",
        "SENDING_CODE": "正在发送验证码...",
        "CONTINUE": "继续",
        "CODE_SENT_TO": "请输入发送至以下邮箱的 6 位验证码：",
        "DIDNT_RECEIVE_CODE": "未收到验证码？重新发送倒计时",
        "RESEND_VERIFICATION_CODE": "↻ 重新获取验证码",
        "VERIFY_CODE": "确认验证码",
        "VERIFYING": "正在验证中...",
        "CHANGE_EMAIL": "更换电子邮箱",
        "FIRST_NAME": "名",
        "LAST_NAME": "姓氏",
        "PHONE_OPTIONAL": "联系电话（选填）",
        "PASSWORD_REQUIREMENTS": "密码须至少包含 8 位字符，且包含字母与数字组合。",
        "CREATING_ACCOUNT": "正在创建私享账户...",
        "CREATE_ACCOUNT_SIGN_IN": "创建账户并直接登录",
        "ALREADY_HAVE_ACCOUNT": "已有专属账户？",
        "ALREADY_HAVE_ACCOUNT_DESC": "登录即可查看您的订单历史、实时追踪全球物流与心愿单。",
        "SIGN_IN_TO_ACCOUNT": "登录专属账户 →",
        "RESET_PASSWORD": "重置登录密码",
        "FORGOT_PASSWORD_SUBTITLE": "输入您的注册邮箱以获取重置密码验证码。",
        "NEW_PASSWORD": "新密码",
        "ENTER_NEW_PASSWORD": "请在下方输入您的全新高强度密码。",
        "SEND_RESET_LINK": "发送验证码",
        "REMEMBER_PASSWORD": "想起登录密码了？",
        "REMEMBER_PASSWORD_DESC": "您可以随时返回登录页面继续您的奢华购物之旅。",
        "BACK_TO_SIGN_IN": "返回登录页面 →",
        "STORE_RATING": "商家综合评分",
        "ON_TIME_DELIVERY": "准时履约率",
        "RESPONSE_TIME": "即时响应",
        "CUSTOM_LOGO": "✓ 支持定制专属标识",
        "CUSTOM_PACKAGING": "✓ 支持高定奢华包装",
        "CUSTOMER_REVIEWS": "贵宾鉴赏评价与反馈",
        "VIEW_REVIEWS": "查看全部鉴赏评价 ✦",
        "WHOLESALE_ACTIVE": "大宗批发尊享价已生效",
        "LOWEST_PRICE_GUARANTEE": "🔥 全球正品价格保证",
        "ALWAYS_AVAILABLE": "常规现货供应",
        "OUT_OF_STOCK": "当前已售罄",
        "ONLY_1_LEFT": "全球仅余最后 1 件！",
        "ONLY_FEW_LEFT": "仅余少量稀缺现货！",
        "LIMITED_QUANTITY": "限量供应",
        "REMAINING_STOCK": "当前库存余量",
        "WHOLESALE_AVAILABLE": "💎 支持大宗批发采购",
        "ESTIMATED_DELIVERY": "预计送达时效",
        "PRODUCT_VIDEO_INCLUDED": "包含官方实拍视频",
        "SCENT_SIGNATURE": "嗅觉艺术金字塔解析",
        "SCENT_FAMILY": "香调家族：",
        "TOP_NOTES": "前调",
        "HEART_NOTES": "中调",
        "BASE_NOTES": "后调",
        "INGREDIENTS": "核心珍稀成分：",
        "VEHICLE_SPECS": "顶级座驾性能规格",
        "MODEL": "型号",
        "YEAR": "出厂年份",
        "MILEAGE": "行驶里程",
        "ENGINE": "动力引擎",
        "TRANSMISSION": "变速箱",
        "SHOWROOM_LOCATION": "贵宾展厅专属交接点",
        "UNMUTE": "开启原声 🔊",
        "MUTE": "静音 🔇",
        "ZOOM_IN": "放大观察",
        "ZOOM_OUT": "缩小视图"
    },
    "ja": {
        "HOME": "ホーム",
        "COLLECTIONS": "コレクション",
        "VIDEO_COMMERCE": "ビデオシアター",
        "NAV_VIP": "VIPラウンジ",
        "NAV_LIVE": "ライブショーケース",
        "NAV_MAGAZINE": "マガジン",
        "NAV_SOURCING": "特別調達サービス",
        "SEARCH_PLACEHOLDER": "高級時計・ジュエリー・バッグを検索...",
        "CART": "カート",
        "ORDERS": "注文履歴",
        "LIVE_AUDIO": "ライブオーディオ",
        "CONTACT": "コンシェルジュに連絡",
        "SECURE_CHECKOUT": "安全な決済",
        "LOGOUT": "ログアウト",
        "SIGN_IN": "サインイン",
        "REGIONAL_SETTINGS": "地域・言語設定",
        "SHIP_TO": "お届け先の国",
        "LANGUAGE": "言語",
        "CURRENCY": "通貨",
        "REDEFINING": "究極の卓越性を再定義",
        "EXPLORE_COLLECTION": "コレクションを見る",
        "AUTHENTIC_BRANDS": "100％真正性保証（正規品）",
        "ENCRYPTED_CHECKOUT": "高度な暗号化決済",
        "CONCIERGE_SUPPORT": "24時間年中無休コンシェルジュ",
        "ADD_TO_CART": "カートに追加",
        "ADD_TO_CART_BTN": "カートに追加",
        "BUY_NOW": "今すぐ購入",
        "NEW_ARRIVALS": "新作コレクション",
        "NEW": "NEW",
        "TRENDING": "注目のマスターピース",
        "RECOMMENDED": "おすすめの逸品",
        "VIEW_ALL": "すべて表示",
        "BACK": "戻る",
        "GIFT_WRAPPING": "特製ギフトラッピング無料",
        "FREE_SHIPPING": "全額保険付き国際エクスプレス無料配送",
        "WARRANTY": "LUXVONO 2年間国際保証",
        "TRACKED_SHIPPING": "リアルタイム配送追跡",
        "EASY_RETURNS": "14日間安心返品保証",
        "YOUR_CART": "選択した商品",
        "CART_EMPTY": "カートに商品がありません。",
        "CONTINUE_SHOPPING": "ギャラリーに戻る",
        "ORDER_SUMMARY": "ご注文内容",
        "SUBTOTAL": "小計",
        "SHIPPING": "エクスプレス配送",
        "COMPLIMENTARY": "無料",
        "TOTAL": "合計",
        "PROCEED_CHECKOUT": "ご購入手続きへ",
        "CHECKOUT": "決済",
        "EMPTY_CART": "お客様のカートは現在空です。",
        "MY_ACCOUNT": "マイページ",
        "MY_ORDERS": "ご注文履歴",
        "OFFERS": "限定オファー",
        "SUPPORT": "コンシェルジュ",
        "AI_ASSISTANT_TITLE": "AI デジタルアドバイザー",
        "SUPPORT_CHAT": "VIPコンシェルジュオフィス",
        "AI_WELCOME": "LUXVONOへようこそ。私は専任のAIデジタルアドバイザーです。本日はどのようなご案内をいたしましょうか？",
        "AI_TYPING": "アドバイザーがリクエストを分析中...",
        "SUPPORT_TYPING": "コンシェルジュが入力中...",
        "LOGIN_VIEW_ORDERS": "ログインして注文を確認",
        "TYPE_TO_SUPPORT": "VIPコンシェルジュにメッセージを入力...",
        "ASK_ABOUT_PRODUCTS": "時計、ジュエリー、配送について質問する...",
        "SAVE": "設定を保存",
        "CANCEL": "キャンセル",
        "ALL_CATEGORIES": "すべてのカテゴリー",
        "BESPOKE_SOURCING": "特別調達",
        "VIP_LOUNGE": "VIPラウンジ",
        "GUARANTEED_QUALITY": "100％品質保証・本物保証",
        "PREMIER_GLOBAL_PLATFORM": "世界最高峰の高級品調達プラットフォーム",
        "WELCOME_TO_LUXVONO": "LUXVONOへようこそ",
        "JOIN_NOW": "今すぐ登録",
        "LOGIN": "ログイン",
        "SELL_WITH_US": "サプライヤーとして出品",
        "VENDOR_PORTAL": "出品者ポータル",
        "VENDOR_DASHBOARD": "出品者ダッシュボード",
        "APPLY_NOW": "今すぐ申請",
        "SIGN_IN_ACCESS": "アカウントにアクセスしてログイン",
        "SEARCH_PROMPT": "商品、ブランド、カテゴリーを検索...",
        "FULL_NAME_REQUIRED": "お名前（フルネーム） *",
        "PHONE_REQUIRED": "お電話番号 *",
        "BACKUP_PHONE": "予備のお電話番号",
        "FULL_ADDRESS": "お届け先ご住所（市区町村、番地、建物名） *",
        "CITY": "市区町村 *",
        "COUNTRY": "国 *",
        "STREET": "番地・建物名",
        "POSTAL_CODE": "郵便番号",
        "PAYMENT_METHOD": "お支払い方法",
        "CREDIT_DEBIT_CARD": "クレジットカード / Apple Pay",
        "PAY_CARD_DESC": "即時かつ安全な暗号化決済。",
        "CASH_ON_DELIVERY": "代金引換",
        "PAY_CASH_DESC": "商品お届け時の現金払い。",
        "MOBILE_WALLET": "デジタルウォレット",
        "PAY_WALLET_DESC": "モバイルウォレットによる即時決済。",
        "BANK_TRANSFER": "銀行振込",
        "PAY_BANK_DESC": "公式法人口座への直接振込。",
        "UPLOAD_RECEIPT": "振込明細書を添付",
        "PROCESSING_ORDER": "ご注文を処理中です...",
        "PLACE_ORDER": "注文を確定する",
        "TAX": "消費税 / 関税",
        "QTY": "数量",
        "FOR_YOU": "あなたへのおすすめ",
        "BACK_TO_FEED": "← ギャラリーに戻る",
        "NO_CONTENT_FOUND": "現在、特別なコンテンツはありません。",
        "PRIORITY_GLOBAL_DELIVERY": "最優先国際エクスプレス配送",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "全額保険付きの迅速・確実な国際輸送",
        "SECURE_CHECKOUT_TITLE": "100％ 安全・安心な決済",
        "SECURE_CHECKOUT_DESC": "暗号化取引と完全な購入者保護",
        "CURATED_AUTHENTICITY": "厳格な本物保証",
        "CURATED_AUTHENTICITY_DESC": "発送前の徹底した品質検査と鑑定",
        "DEDICATED_CONCIERGE": "24時間専任コンシェルジュ",
        "DEDICATED_CONCIERGE_DESC": "24時間いつでも最優先サポート",
        "CUSTOMER_CARE": "カスタマーケア",
        "TRACK_ORDER": "配送状況の確認",
        "VIP_CLUB": "VIPコンシェルジュクラブ",
        "HELP_SUPPORT": "ヘルプ＆サポート",
        "ABOUT_LUXVONO": "LUXVONOについて",
        "ABOUT_US_VISION": "ブランドストーリーと理念",
        "SUPPLIER_PORTAL": "サプライヤーポータル",
        "LUXVONO_MAGAZINE": "LUXVONOマガジン",
        "TERMS_CONDITIONS": "利用規約",
        "PRIVACY_POLICY": "プライバシーポリシー",
        "SECURE_PAYMENTS": "安全な決済システム",
        "CONTACT_CONCIERGE_BTN": "VIPコンシェルジュに相談 ✦",
        "DIRECT_VIP_PHONE": "VIP専用直通ダイヤル",
        "OFFICIAL_SUPPORT_EMAIL": "公式サポートメール",
        "GLOBAL_STANDARDS": "ラグジュアリーコマースの世界基準",
        "CONNECT_WITH_US": "公式アカウントをフォロー:",
        "EMAIL_ADDRESS": "メールアドレス",
        "PASSWORD": "パスワード",
        "FORGOT_PASSWORD": "パスワードをお忘れですか？",
        "AUTHENTICATING": "認証中...",
        "OR_CONTINUE_WITH": "または次で続行",
        "NEW_TO_LUXVONO": "初めてご利用ですか？",
        "CREATE_ACCOUNT_DESC": "専用アカウントを作成して、優先価格とパーソナルサービスをお楽しみください。",
        "CREATE_ACCOUNT_BTN": "アカウントを作成 ✦",
        "JOIN_LUXVONO": "LUXVONOへようこそ",
        "ENTER_EMAIL_START": "メールアドレスを入力して登録を開始してください。",
        "COMPLETE_SETUP": "アカウント設定を完了",
        "VERIFY_EMAIL": "メールアドレスの確認",
        "ENTER_6DIGIT_CODE": "6桁の認証コードを入力してください",
        "SECURE_ACCOUNT": "最高水準の暗号化でお客様の情報を保護します",
        "SENDING_CODE": "コードを送信中...",
        "CONTINUE": "次へ進む",
        "CODE_SENT_TO": "送信された6桁の認証コードを入力してください：",
        "DIDNT_RECEIVE_CODE": "コードが届きませんか？再送信まで",
        "RESEND_VERIFICATION_CODE": "↻ 認証コードを再送信",
        "VERIFY_CODE": "コードを認証",
        "VERIFYING": "認証中...",
        "CHANGE_EMAIL": "メールアドレスを変更",
        "FIRST_NAME": "名",
        "LAST_NAME": "姓",
        "PHONE_OPTIONAL": "電話番号（任意）",
        "PASSWORD_REQUIREMENTS": "英数字を含む8文字以上。",
        "CREATING_ACCOUNT": "アカウント作成中...",
        "CREATE_ACCOUNT_SIGN_IN": "アカウントを作成してサインイン",
        "ALREADY_HAVE_ACCOUNT": "すでにアカウントをお持ちですか？",
        "ALREADY_HAVE_ACCOUNT_DESC": "サインインして注文履歴や配送状況を確認できます。",
        "SIGN_IN_TO_ACCOUNT": "サインインする →",
        "RESET_PASSWORD": "パスワードの再設定",
        "FORGOT_PASSWORD_SUBTITLE": "メールアドレスを入力して認証コードを受け取ってください。",
        "NEW_PASSWORD": "新しいパスワード",
        "ENTER_NEW_PASSWORD": "新しいパスワードを入力してください。",
        "SEND_RESET_LINK": "認証コードを送信",
        "REMEMBER_PASSWORD": "パスワードを思い出しましたか？",
        "REMEMBER_PASSWORD_DESC": "サインイン画面に戻ってお買い物を続けられます。",
        "BACK_TO_SIGN_IN": "サインインへ戻る →",
        "STORE_RATING": "ストア評価",
        "ON_TIME_DELIVERY": "納期遵守率",
        "RESPONSE_TIME": "応答時間",
        "CUSTOM_LOGO": "✓ ロゴ刻印対応",
        "CUSTOM_PACKAGING": "✓ 専用ギフト包装対応",
        "CUSTOMER_REVIEWS": "お客様のご感想・レビュー",
        "VIEW_REVIEWS": "レビューを見る ✦",
        "WHOLESALE_ACTIVE": "卸売価格適用中",
        "LOWEST_PRICE_GUARANTEE": "🔥 最低価格保証",
        "ALWAYS_AVAILABLE": "常時在庫あり",
        "OUT_OF_STOCK": "在庫切れ",
        "ONLY_1_LEFT": "残り1点のみ！",
        "ONLY_FEW_LEFT": "残りわずか！",
        "LIMITED_QUANTITY": "数量限定",
        "REMAINING_STOCK": "残り在庫数",
        "WHOLESALE_AVAILABLE": "💎 大口卸売対応",
        "ESTIMATED_DELIVERY": "お届け予定日",
        "PRODUCT_VIDEO_INCLUDED": "公式動画あり",
        "SCENT_SIGNATURE": "香りのピラミッド構成",
        "SCENT_FAMILY": "香調カテゴリー：",
        "TOP_NOTES": "トップノート",
        "HEART_NOTES": "ミドルノート",
        "BASE_NOTES": "ラストノート",
        "INGREDIENTS": "原材料・成分：",
        "VEHICLE_SPECS": "車両性能スペック",
        "MODEL": "モデル",
        "YEAR": "年式",
        "MILEAGE": "走行距離",
        "ENGINE": "エンジン",
        "TRANSMISSION": "トランスミッション",
        "SHOWROOM_LOCATION": "VIPショールーム受取場所",
        "UNMUTE": "音声を再生 🔊",
        "MUTE": "ミュート 🔇",
        "ZOOM_IN": "拡大",
        "ZOOM_OUT": "縮小"
    },
    "ko": {
        "HOME": "홈",
        "COLLECTIONS": "컬렉션",
        "VIDEO_COMMERCE": "비디오 극장",
        "NAV_VIP": "VIP 라운지",
        "NAV_LIVE": "라이브 쇼케이스",
        "NAV_MAGAZINE": "매거진",
        "NAV_SOURCING": "맞춤형 조달",
        "SEARCH_PLACEHOLDER": "명품 컬렉션 검색...",
        "CART": "쇼핑백",
        "ORDERS": "주문 내역",
        "LIVE_AUDIO": "라이브 오디오",
        "CONTACT": "컨시어지 문의",
        "SECURE_CHECKOUT": "보안 결제",
        "LOGOUT": "로그아웃",
        "SIGN_IN": "로그인",
        "REGIONAL_SETTINGS": "국가 및 언어 설정",
        "SHIP_TO": "배송 국가",
        "LANGUAGE": "언어",
        "CURRENCY": "통화",
        "REDEFINING": "럭셔리의 새로운 정의",
        "EXPLORE_COLLECTION": "컬렉션 탐색",
        "AUTHENTIC_BRANDS": "100% 정품 보증",
        "ENCRYPTED_CHECKOUT": "암호화된 안전 결제",
        "CONCIERGE_SUPPORT": "24/7 전담 컨시어지 지원",
        "ADD_TO_CART": "쇼핑백에 담기",
        "ADD_TO_CART_BTN": "쇼핑백에 담기",
        "BUY_NOW": "바로 구매",
        "NEW_ARRIVALS": "신제품",
        "NEW": "신상품",
        "TRENDING": "인기 마스터피스",
        "RECOMMENDED": "맞춤 추천",
        "VIEW_ALL": "전체 보기",
        "BACK": "돌아가기",
        "GIFT_WRAPPING": "시그니처 선물 포장 무료 제공",
        "FREE_SHIPPING": "전액 보험 적용 글로벌 특급 무료 배송",
        "WARRANTY": "LUXVONO 2년 품질 보증",
        "TRACKED_SHIPPING": "실시간 안심 배송 추적",
        "EASY_RETURNS": "14일 이내 간편 반품 특권",
        "YOUR_CART": "선택하신 상품",
        "CART_EMPTY": "쇼핑백이 비어 있습니다.",
        "CONTINUE_SHOPPING": "쇼핑 계속하기",
        "ORDER_SUMMARY": "주문 요약",
        "SUBTOTAL": "소계",
        "SHIPPING": "특급 배송",
        "COMPLIMENTARY": "무료",
        "TOTAL": "총액",
        "PROCEED_CHECKOUT": "결제 진행",
        "CHECKOUT": "결제",
        "EMPTY_CART": "쇼핑백에 담긴 상품이 없습니다.",
        "MY_ACCOUNT": "마이페이지",
        "MY_ORDERS": "주문 내역",
        "OFFERS": "VIP 전용 혜택",
        "SUPPORT": "컨시어지",
        "AI_ASSISTANT_TITLE": "AI 디지털 어드바이저",
        "SUPPORT_CHAT": "VIP 컨시어지 데스크",
        "AI_WELCOME": "LUXVONO에 오신 것을 환영합니다. 귀하만을 위한 AI 디지털 어드바이저입니다. 무엇을 도와드릴까요?",
        "AI_TYPING": "어드바이저가 요청을 분석 중입니다...",
        "SUPPORT_TYPING": "컨시어지가 작성 중입니다...",
        "LOGIN_VIEW_ORDERS": "주문 조회를 위해 로그인하세요",
        "TYPE_TO_SUPPORT": "VIP 컨시어지에게 메시지 보내기...",
        "ASK_ABOUT_PRODUCTS": "시계, 주얼리, 배송에 대해 문의하세요...",
        "SAVE": "설정 저장",
        "CANCEL": "취소",
        "ALL_CATEGORIES": "전체 카테고리",
        "BESPOKE_SOURCING": "맞춤형 조달",
        "VIP_LOUNGE": "VIP 라운지",
        "GUARANTEED_QUALITY": "100% 정품 및 최고 품질 보증",
        "PREMIER_GLOBAL_PLATFORM": "글로벌 럭셔리 소싱 플랫폼",
        "WELCOME_TO_LUXVONO": "LUXVONO에 오신 것을 환영합니다",
        "JOIN_NOW": "지금 가입하기",
        "LOGIN": "로그인",
        "SELL_WITH_US": "입점 판매 신청",
        "VENDOR_PORTAL": "입점사 포털",
        "VENDOR_DASHBOARD": "판매자 대시보드",
        "APPLY_NOW": "지금 신청하기",
        "SIGN_IN_ACCESS": "계정에 접속하여 로그인하세요",
        "SEARCH_PROMPT": "상품, 브랜드, 카테고리 검색...",
        "FULL_NAME_REQUIRED": "성명 (실명) *",
        "PHONE_REQUIRED": "연락처 *",
        "BACKUP_PHONE": "비상 연락처 (선택)",
        "FULL_ADDRESS": "상세 주소 (도로명, 건물명, 동/호수) *",
        "CITY": "도시 *",
        "COUNTRY": "국가 *",
        "STREET": "도로명 및 상세 주소",
        "POSTAL_CODE": "우편번호",
        "PAYMENT_METHOD": "결제 수단",
        "CREDIT_DEBIT_CARD": "신용/체크카드 / Apple Pay",
        "PAY_CARD_DESC": "즉시 안전 결제 암호화.",
        "CASH_ON_DELIVERY": "착불 현금 결제",
        "PAY_CASH_DESC": "배송 시 기사님께 현금 결제.",
        "MOBILE_WALLET": "간편 결제 (카카오페이 / 토스)",
        "PAY_WALLET_DESC": "모바일 간편 결제.",
        "BANK_TRANSFER": "실시간 계좌이체",
        "PAY_BANK_DESC": "공식 법인 계좌로 무통장 입금.",
        "UPLOAD_RECEIPT": "입금 영수증 첨부",
        "PROCESSING_ORDER": "주문 처리 중입니다...",
        "PLACE_ORDER": "주문 확정 및 결제",
        "TAX": "부가세 (VAT)",
        "QTY": "수량",
        "FOR_YOU": "맞춤 추천",
        "BACK_TO_FEED": "← 갤러리로 돌아가기",
        "NO_CONTENT_FOUND": "현재 표시할 콘텐츠가 없습니다.",
        "PRIORITY_GLOBAL_DELIVERY": "최우선 글로벌 특급 배송",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "전액 보험 적용 안전하고 신속한 해외 배송",
        "SECURE_CHECKOUT_TITLE": "100% 안전 암호화 결제",
        "SECURE_CHECKOUT_DESC": "최고 수준 보안 거래 및 구매자 보호",
        "CURATED_AUTHENTICITY": "100% 공식 정품 보증",
        "CURATED_AUTHENTICITY_DESC": "출고 전 철저한 품질 및 정품 검수",
        "DEDICATED_CONCIERGE": "24/7 전담 컨시어지",
        "DEDICATED_CONCIERGE_DESC": "24시간 연중무휴 최우선 맞춤 지원",
        "CUSTOMER_CARE": "고객 지원 센터",
        "TRACK_ORDER": "배송 조회",
        "VIP_CLUB": "VIP 컨시어지 클럽",
        "HELP_SUPPORT": "도움말 및 지원",
        "ABOUT_LUXVONO": "LUXVONO 소개",
        "ABOUT_US_VISION": "브랜드 스토리 및 비전",
        "SUPPLIER_PORTAL": "입점 파트너 포털",
        "LUXVONO_MAGAZINE": "LUXVONO 매거진",
        "TERMS_CONDITIONS": "이용약관",
        "PRIVACY_POLICY": "개인정보 처리방침",
        "SECURE_PAYMENTS": "안전 결제",
        "CONTACT_CONCIERGE_BTN": "VIP 컨시어지 문의 ✦",
        "DIRECT_VIP_PHONE": "VIP 전용 직통 전화",
        "OFFICIAL_SUPPORT_EMAIL": "공식 고객지원 이메일",
        "GLOBAL_STANDARDS": "글로벌 럭셔리 커머스 표준",
        "CONNECT_WITH_US": "공식 채널 바로가기:",
        "EMAIL_ADDRESS": "이메일 주소",
        "PASSWORD": "비밀번호",
        "FORGOT_PASSWORD": "비밀번호를 잊으셨나요?",
        "AUTHENTICATING": "인증 진행 중...",
        "OR_CONTINUE_WITH": "또는 다음으로 계속",
        "NEW_TO_LUXVONO": "LUXVONO가 처음이신가요?",
        "CREATE_ACCOUNT_DESC": "전용 계정을 생성하고 특별한 혜택과 빠른 배송 서비스를 경험해보세요.",
        "CREATE_ACCOUNT_BTN": "새 계정 만들기 ✦",
        "JOIN_LUXVONO": "LUXVONO 가입하기",
        "ENTER_EMAIL_START": "이메일을 입력하여 전용 계정 설정을 시작하세요.",
        "COMPLETE_SETUP": "계정 설정 완료",
        "VERIFY_EMAIL": "이메일 인증",
        "ENTER_6DIGIT_CODE": "계정 활성화를 위해 6자리 인증 코드를 입력하세요",
        "SECURE_ACCOUNT": "최고 수준의 암호화로 계정을 안전하게 보호합니다",
        "SENDING_CODE": "코드 전송 중...",
        "CONTINUE": "계속하기",
        "CODE_SENT_TO": "다음 이메일로 발송된 6자리 코드를 입력하세요:",
        "DIDNT_RECEIVE_CODE": "코드를 받지 못하셨나요? 재전송 가능 시간",
        "RESEND_VERIFICATION_CODE": "↻ 인증 코드 재전송",
        "VERIFY_CODE": "코드 인증",
        "VERIFYING": "인증 확인 중...",
        "CHANGE_EMAIL": "이메일 주소 변경",
        "FIRST_NAME": "이름",
        "LAST_NAME": "성",
        "PHONE_OPTIONAL": "전화번호 (선택사항)",
        "PASSWORD_REQUIREMENTS": "영문과 숫자를 포함하여 8자 이상 입력하세요.",
        "CREATING_ACCOUNT": "계정 생성 중...",
        "CREATE_ACCOUNT_SIGN_IN": "계정 생성 및 로그인",
        "ALREADY_HAVE_ACCOUNT": "이미 계정이 있으신가요?",
        "ALREADY_HAVE_ACCOUNT_DESC": "로그인하여 주문 내역과 실시간 배송 조회를 확인하세요.",
        "SIGN_IN_TO_ACCOUNT": "계정 로그인 →",
        "RESET_PASSWORD": "비밀번호 재설정",
        "FORGOT_PASSWORD_SUBTITLE": "인증 코드를 받을 이메일 주소를 입력하세요.",
        "NEW_PASSWORD": "새 비밀번호",
        "ENTER_NEW_PASSWORD": "새로운 비밀번호를 입력하세요.",
        "SEND_RESET_LINK": "인증 코드 발송",
        "REMEMBER_PASSWORD": "비밀번호가 기억나셨나요?",
        "REMEMBER_PASSWORD_DESC": "로그인 페이지로 돌아가 쇼핑을 계속할 수 있습니다.",
        "BACK_TO_SIGN_IN": "로그인 화면으로 이동 →",
        "STORE_RATING": "스토어 평점",
        "ON_TIME_DELIVERY": "정시 배송률",
        "RESPONSE_TIME": "응답 속도",
        "CUSTOM_LOGO": "✓ 로고 각인 맞춤 제작",
        "CUSTOM_PACKAGING": "✓ 전용 선물 포장 지원",
        "CUSTOMER_REVIEWS": "고객 구매 후기",
        "VIEW_REVIEWS": "후기 전체보기 ✦",
        "WHOLESALE_ACTIVE": "도매 할인가 적용됨",
        "LOWEST_PRICE_GUARANTEE": "🔥 최저가 보장",
        "ALWAYS_AVAILABLE": "상시 구매 가능",
        "OUT_OF_STOCK": "품절",
        "ONLY_1_LEFT": "마지막 1개 남음!",
        "ONLY_FEW_LEFT": "소량 한정 수량 남음!",
        "LIMITED_QUANTITY": "한정 수량",
        "REMAINING_STOCK": "남은 재고 수량",
        "WHOLESALE_AVAILABLE": "💎 대량 도매 가능",
        "ESTIMATED_DELIVERY": "예상 배송 기간",
        "PRODUCT_VIDEO_INCLUDED": "제품 실물 영상 포함",
        "SCENT_SIGNATURE": "시그니처 향수 피라미드",
        "SCENT_FAMILY": "향 계열:",
        "TOP_NOTES": "탑 노트",
        "HEART_NOTES": "미들 노트",
        "BASE_NOTES": "베이스 노트",
        "INGREDIENTS": "주요 원료 및 성분:",
        "VEHICLE_SPECS": "차량 제원 및 성능",
        "MODEL": "모델",
        "YEAR": "연식",
        "MILEAGE": "주행거리",
        "ENGINE": "엔진",
        "TRANSMISSION": "변속기",
        "SHOWROOM_LOCATION": "VIP 쇼룸 픽업 장소",
        "UNMUTE": "소리 켜기 🔊",
        "MUTE": "음소거 🔇",
        "ZOOM_IN": "확대",
        "ZOOM_OUT": "축소"
    },
    "ru": {
        "HOME": "ГЛАВНАЯ",
        "COLLECTIONS": "КОЛЛЕКЦИИ",
        "VIDEO_COMMERCE": "ВИДЕО ГАЛЕРЕЯ",
        "NAV_VIP": "VIP САЛОН",
        "NAV_LIVE": "ПРЯМОЙ ЭФИР",
        "NAV_MAGAZINE": "ЖУРНАЛ",
        "NAV_SOURCING": "ИНДИВИДУАЛЬНЫЙ ЗАКАЗ",
        "SEARCH_PLACEHOLDER": "Поиск премиальных часов, ювелирных изделий...",
        "CART": "КОРЗИНА",
        "ORDERS": "ЗАКАЗЫ",
        "LIVE_AUDIO": "АУДИО ЗАЛ",
        "CONTACT": "СВЯЗАТЬСЯ С КОНСЬЕРЖЕМ",
        "SECURE_CHECKOUT": "Безопасная Оплата",
        "LOGOUT": "Выйти",
        "SIGN_IN": "Войти",
        "REGIONAL_SETTINGS": "Региональные Настройки",
        "SHIP_TO": "Страна Доставки",
        "LANGUAGE": "Язык",
        "CURRENCY": "Валюта",
        "REDEFINING": "НОВЫЙ СТАНДАРТ РОСКОШИ",
        "EXPLORE_COLLECTION": "Смотреть Коллекцию",
        "AUTHENTIC_BRANDS": "100% Гарантия Подлинности",
        "ENCRYPTED_CHECKOUT": "Защищенный Протокол Оплаты",
        "CONCIERGE_SUPPORT": "Круглосуточный VIP Консьерж",
        "ADD_TO_CART": "В Корзину",
        "ADD_TO_CART_BTN": "В КОРЗИНУ",
        "BUY_NOW": "Купить Сейчас",
        "NEW_ARRIVALS": "Новые Поступления",
        "NEW": "НОВИНКА",
        "TRENDING": "Самые Востребованные",
        "RECOMMENDED": "ПОДОБРАНО ДЛЯ ВАС",
        "VIEW_ALL": "Смотреть Все",
        "BACK": "Назад",
        "GIFT_WRAPPING": "Фирменная подарочная упаковка в подарок",
        "FREE_SHIPPING": "Бесплатная застрахованная экспресс-доставка",
        "WARRANTY": "Международная гарантия Luxvono 2 года",
        "TRACKED_SHIPPING": "Отслеживание доставки в реальном времени",
        "EASY_RETURNS": "Простой возврат в течение 14 дней",
        "YOUR_CART": "ВАША КОРЗИНА",
        "CART_EMPTY": "Ваша корзина пуста.",
        "CONTINUE_SHOPPING": "Продолжить Покупки",
        "ORDER_SUMMARY": "Детали Заказа",
        "SUBTOTAL": "Сумма",
        "SHIPPING": "Экспресс Доставка",
        "COMPLIMENTARY": "Бесплатно",
        "TOTAL": "Итого",
        "PROCEED_CHECKOUT": "ПЕРЕЙТИ К ОПЛАТЕ",
        "CHECKOUT": "Оплата",
        "EMPTY_CART": "Ваша корзина ждет ваших выборов.",
        "MY_ACCOUNT": "Личный Кабинет",
        "MY_ORDERS": "Мои Заказы",
        "OFFERS": "Приватные Предложения",
        "SUPPORT": "Консьерж",
        "AI_ASSISTANT_TITLE": "Цифровой Консультант",
        "SUPPORT_CHAT": "VIP Консьерж Сервис",
        "AI_WELCOME": "Добро пожаловать в LUXVONO. Я ваш персональный цифровой консультант. Чем я могу помочь вам сегодня?",
        "AI_TYPING": "Консультант анализирует ваш запрос...",
        "SUPPORT_TYPING": "Консьерж печатает...",
        "LOGIN_VIEW_ORDERS": "Войдите для просмотра заказов",
        "TYPE_TO_SUPPORT": "Сообщение вашему VIP консьержу...",
        "ASK_ABOUT_PRODUCTS": "Спросите о часах, украшениях или доставке...",
        "SAVE": "Сохранить Настройки",
        "CANCEL": "Отмена",
        "ALL_CATEGORIES": "Все Категории",
        "BESPOKE_SOURCING": "Индивидуальный Заказ",
        "VIP_LOUNGE": "VIP Салон",
        "GUARANTEED_QUALITY": "100% Гарантия Качества и Подлинности",
        "PREMIER_GLOBAL_PLATFORM": "Глобальная платформа люксовых закупок",
        "WELCOME_TO_LUXVONO": "Добро пожаловать в LUXVONO",
        "JOIN_NOW": "Присоединиться",
        "LOGIN": "Войти",
        "SELL_WITH_US": "Стать Поставщиком",
        "VENDOR_PORTAL": "Портал Поставщиков",
        "VENDOR_DASHBOARD": "Панель Поставщика",
        "APPLY_NOW": "Подать Заявку",
        "SIGN_IN_ACCESS": "Войдите для доступа к личному кабинету",
        "SEARCH_PROMPT": "Поиск товаров, брендов, категорий...",
        "FULL_NAME_REQUIRED": "ФИО Получателя *",
        "PHONE_REQUIRED": "Номер Телефона *",
        "BACKUP_PHONE": "Дополнительный Телефон",
        "FULL_ADDRESS": "Полный Адрес Доставки (Улица, Дом, Квартира) *",
        "CITY": "Город *",
        "COUNTRY": "Страна *",
        "STREET": "Улица и Дом",
        "POSTAL_CODE": "Почтовый Индекс",
        "PAYMENT_METHOD": "Способ Оплаты",
        "CREDIT_DEBIT_CARD": "Банковская Карта / Apple Pay",
        "PAY_CARD_DESC": "Мгновенная и безопасная онлайн-оплата.",
        "CASH_ON_DELIVERY": "Оплата при Получении",
        "PAY_CASH_DESC": "Оплата наличными при курьерской доставке.",
        "MOBILE_WALLET": "Электронные Кошельки",
        "PAY_WALLET_DESC": "Быстрая оплата через цифровые кошельки.",
        "BANK_TRANSFER": "Прямой Банковский Перевод",
        "PAY_BANK_DESC": "Прямой перевод на расчетный счет компании.",
        "UPLOAD_RECEIPT": "Прикрепить квитанцию об оплате",
        "PROCESSING_ORDER": "Обработка вашего заказа...",
        "PLACE_ORDER": "Подтвердить и Оформить Заказ",
        "TAX": "НДС / Налоги",
        "QTY": "Количество",
        "FOR_YOU": "Подобрано для вас",
        "BACK_TO_FEED": "← Назад в галерею",
        "NO_CONTENT_FOUND": "В данный момент нет доступного контента.",
        "PRIORITY_GLOBAL_DELIVERY": "Приоритетная Международная Доставка",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "Быстрая и застрахованная доставка по всему миру",
        "SECURE_CHECKOUT_TITLE": "100% Безопасная Оплата",
        "SECURE_CHECKOUT_DESC": "Банковское шифрование и полная защита покупателя",
        "CURATED_AUTHENTICITY": "Гарантированная Подлинность",
        "CURATED_AUTHENTICITY_DESC": "Строгая экспертиза и контроль качества перед отправкой",
        "DEDICATED_CONCIERGE": "Круглосуточный VIP Консьерж",
        "DEDICATED_CONCIERGE_DESC": "Приоритетная персональная поддержка 24/7",
        "CUSTOMER_CARE": "Клиентский Сервис",
        "TRACK_ORDER": "Отследить Заказ",
        "VIP_CLUB": "Клуб VIP Консьерж",
        "HELP_SUPPORT": "Помощь и Поддержка",
        "ABOUT_LUXVONO": "О LUXVONO",
        "ABOUT_US_VISION": "История и Миссия",
        "SUPPLIER_PORTAL": "Портал Поставщиков",
        "LUXVONO_MAGAZINE": "Журнал LUXVONO",
        "TERMS_CONDITIONS": "Условия Обслуживания",
        "PRIVACY_POLICY": "Политика Конфиденциальности",
        "SECURE_PAYMENTS": "Безопасные Платежи",
        "CONTACT_CONCIERGE_BTN": "Связаться с VIP Консьержем ✦",
        "DIRECT_VIP_PHONE": "Прямая VIP Линия",
        "OFFICIAL_SUPPORT_EMAIL": "Официальная Служба Поддержки",
        "GLOBAL_STANDARDS": "Мировые Стандарты Премиальной Торговли",
        "CONNECT_WITH_US": "СЛЕДИТЕ ЗА НАМИ:",
        "EMAIL_ADDRESS": "Электронная почта",
        "PASSWORD": "Пароль",
        "FORGOT_PASSWORD": "Забыли пароль?",
        "AUTHENTICATING": "Проверка данных...",
        "OR_CONTINUE_WITH": "Или продолжить через",
        "NEW_TO_LUXVONO": "Впервые в LuxVono?",
        "CREATE_ACCOUNT_DESC": "Создайте персональный аккаунт сегодня для привилегированных цен и быстрой доставки.",
        "CREATE_ACCOUNT_BTN": "Создать аккаунт ✦",
        "JOIN_LUXVONO": "Присоединиться к LUXVONO",
        "ENTER_EMAIL_START": "Введите ваш email, чтобы начать создание профиля.",
        "COMPLETE_SETUP": "Завершение регистрации",
        "VERIFY_EMAIL": "Подтверждение Email",
        "ENTER_6DIGIT_CODE": "Введите 6-значный код для активации аккаунта",
        "SECURE_ACCOUNT": "Защита вашего портфолио высшими стандартами шифрования",
        "SENDING_CODE": "Отправка кода...",
        "CONTINUE": "Продолжить",
        "CODE_SENT_TO": "Введите 6-значный код, отправленный на:",
        "DIDNT_RECEIVE_CODE": "Не получили код? Повтор через",
        "RESEND_VERIFICATION_CODE": "↻ Отправить код повторно",
        "VERIFY_CODE": "Подтвердить код",
        "VERIFYING": "Проверка...",
        "CHANGE_EMAIL": "Изменить Email",
        "FIRST_NAME": "Имя",
        "LAST_NAME": "Фамилия",
        "PHONE_OPTIONAL": "Номер телефона (необязательно)",
        "PASSWORD_REQUIREMENTS": "Минимум 8 символов, включая буквы и цифры.",
        "CREATING_ACCOUNT": "Создание аккаунта...",
        "CREATE_ACCOUNT_SIGN_IN": "Создать аккаунт и войти",
        "ALREADY_HAVE_ACCOUNT": "Уже есть аккаунт?",
        "ALREADY_HAVE_ACCOUNT_DESC": "Войдите, чтобы отслеживать заказы и просматривать избранное.",
        "SIGN_IN_TO_ACCOUNT": "Войти в аккаунт →",
        "RESET_PASSWORD": "Сброс пароля",
        "FORGOT_PASSWORD_SUBTITLE": "Введите email для получения кода сброса пароля.",
        "NEW_PASSWORD": "Новый пароль",
        "ENTER_NEW_PASSWORD": "Введите ваш новый надежный пароль ниже.",
        "SEND_RESET_LINK": "Отправить код",
        "REMEMBER_PASSWORD": "Вспомнили пароль?",
        "REMEMBER_PASSWORD_DESC": "Вы можете вернуться на страницу входа и продолжить покупки.",
        "BACK_TO_SIGN_IN": "Вернуться ко входу →",
        "STORE_RATING": "Рейтинг магазина",
        "ON_TIME_DELIVERY": "Доставка вовремя",
        "RESPONSE_TIME": "Время ответа",
        "CUSTOM_LOGO": "✓ Фирменный логотип",
        "CUSTOM_PACKAGING": "✓ Премиум упаковка",
        "CUSTOMER_REVIEWS": "Отзывы клиентов",
        "VIEW_REVIEWS": "Смотреть отзывы ✦",
        "WHOLESALE_ACTIVE": "Оптовая цена активна",
        "LOWEST_PRICE_GUARANTEE": "🔥 Гарантия лучшей цены",
        "ALWAYS_AVAILABLE": "Всегда в наличии",
        "OUT_OF_STOCK": "Нет в наличии",
        "ONLY_1_LEFT": "Осталась всего 1 штука!",
        "ONLY_FEW_LEFT": "Осталось мало!",
        "LIMITED_QUANTITY": "Ограниченное количество",
        "REMAINING_STOCK": "Остаток на складе",
        "WHOLESALE_AVAILABLE": "💎 Доступны оптовые цены",
        "ESTIMATED_DELIVERY": "Ориентировочная доставка",
        "PRODUCT_VIDEO_INCLUDED": "Есть видео товара",
        "SCENT_SIGNATURE": "Парфюмерная пирамида",
        "SCENT_FAMILY": "Семейство ароматов:",
        "TOP_NOTES": "Верхние ноты",
        "HEART_NOTES": "Ноты сердца",
        "BASE_NOTES": "Базовые ноты",
        "INGREDIENTS": "Ингредиенты:",
        "VEHICLE_SPECS": "Характеристики автомобиля",
        "MODEL": "Модель",
        "YEAR": "Год выпуска",
        "MILEAGE": "Пробег",
        "ENGINE": "Двигатель",
        "TRANSMISSION": "Коробка передач",
        "SHOWROOM_LOCATION": "Выдача в VIP шоуруме",
        "UNMUTE": "Включить звук 🔊",
        "MUTE": "Выключить звук 🔇",
        "ZOOM_IN": "Увеличить",
        "ZOOM_OUT": "Уменьшить"
    },
    "am": {
        "HOME": "መነሻ",
        "COLLECTIONS": "ስብስቦች",
        "VIDEO_COMMERCE": "የቪዲዮ ቲያትር",
        "NAV_VIP": "ቪአይፒ ሳሎን",
        "NAV_LIVE": "ቀጥታ ስርጭት",
        "NAV_MAGAZINE": "መጽሔት",
        "NAV_SOURCING": "ልዩ ትዕዛዝ",
        "SEARCH_PLACEHOLDER": "የቅንጦት ምርቶችን ይፈልጉ...",
        "CART": "ጋሪ",
        "ORDERS": "ትዕዛዞች",
        "LIVE_AUDIO": "የቀጥታ ድምጽ",
        "CONTACT": "አስተዳዳሪን ያነጋግሩ",
        "SECURE_CHECKOUT": "ደህንነቱ የተጠበቀ ክፍያ",
        "LOGOUT": "ውጣ",
        "SIGN_IN": "ግባ",
        "REGIONAL_SETTINGS": "የአገር እና ቋንቋ ቅንብሮች",
        "SHIP_TO": "መድረሻ አገር",
        "LANGUAGE": "ቋንቋ",
        "CURRENCY": "የገንዘብ አይነት",
        "REDEFINING": "የቅንጦት አዲስ ትርጉም",
        "EXPLORE_COLLECTION": "ስብስቦችን ያስሱ",
        "AUTHENTIC_BRANDS": "100% ትክክለኛ ጥራት ዋስትና",
        "ENCRYPTED_CHECKOUT": "የተጠበቀ እና የተመሰጠረ ክፍያ",
        "CONCIERGE_SUPPORT": "24/7 የቪአይፒ ድጋፍ",
        "ADD_TO_CART": "ወደ ጋሪ ጨምር",
        "ADD_TO_CART_BTN": "ወደ ጋሪ ጨምር",
        "BUY_NOW": "አሁን ይግዙ",
        "NEW_ARRIVALS": "አዳዲስ ምርቶች",
        "NEW": "አዲስ",
        "TRENDING": "ተወዳጅ ምርቶች",
        "RECOMMENDED": "ለእርስዎ የተመረጡ",
        "VIEW_ALL": "ሁሉንም ይመልከቱ",
        "BACK": "ተመለስ",
        "GIFT_WRAPPING": "ነፃ የቅንጦት የስጦታ ማሸጊያ",
        "FREE_SHIPPING": "ነፃ አለምአቀፍ ፈጣን መላኪያ",
        "WARRANTY": "የሁለት ዓመት LUXVONO ዋስትና",
        "TRACKED_SHIPPING": "ትዕዛዝዎን በቀጥታ ይከታተሉ",
        "EASY_RETURNS": "ቀላል የመመለሻ ዋስትና",
        "YOUR_CART": "የእርስዎ ጋሪ",
        "CART_EMPTY": "ጋሪዎ ባዶ ነው።",
        "CONTINUE_SHOPPING": "ግዢዎን ይቀጥሉ",
        "ORDER_SUMMARY": "የትዕዛዝ ማጠቃለያ",
        "SUBTOTAL": "ንዑስ ድምር",
        "SHIPPING": "ፈጣን መላኪያ",
        "COMPLIMENTARY": "በነፃ",
        "TOTAL": "አጠቃላይ ድምር",
        "PROCEED_CHECKOUT": "ወደ ክፍያ ይቀጥሉ",
        "CHECKOUT": "ክፍያ",
        "EMPTY_CART": "የእርስዎ ምርጫዎች እየተጠበቁ ናቸው።",
        "MY_ACCOUNT": "መለያ",
        "MY_ORDERS": "የእኔ ትዕዛዞች",
        "OFFERS": "ልዩ ቅናሾች",
        "SUPPORT": "የደንበኞች አገልግሎት",
        "AI_ASSISTANT_TITLE": "ስማርት ዲጂታል አማካሪ",
        "SUPPORT_CHAT": "የቪአይፒ ቢሮ",
        "AI_WELCOME": "እንኳን ወደ LUXVONO በደህና መጡ። ዛሬ እንዴት ልረዳዎ እችላለሁ?",
        "AI_TYPING": "አማካሪው ጥያቄዎን በመተንተን ላይ ነው...",
        "SUPPORT_TYPING": "ቪአይፒ ድጋፍ በመጻፍ ላይ ነው...",
        "LOGIN_VIEW_ORDERS": "ትዕዛዞችን ለማየት ይግቡ",
        "TYPE_TO_SUPPORT": "መልእክት ይጻፉ...",
        "ASK_ABOUT_PRODUCTS": "ስለ ሰዓቶች፣ ጌጣጌጦች ወይም መላኪያ ይጠይቁ...",
        "SAVE": "አስቀምጥ",
        "CANCEL": "ሰርዝ",
        "ALL_CATEGORIES": "ሁሉም ምድቦች",
        "BESPOKE_SOURCING": "ልዩ ግዢ",
        "VIP_LOUNGE": "ቪአይፒ ላውንጅ",
        "GUARANTEED_QUALITY": "100% ጥራት እና ትክክለኛነት የተረጋገጠ",
        "PREMIER_GLOBAL_PLATFORM": "የአለም አቀፍ የቅንጦት ንግድ መድረክ",
        "WELCOME_TO_LUXVONO": "ወደ LUXVONO እንኳን በደህና መጡ",
        "JOIN_NOW": "አሁን ይቀላቀሉ",
        "LOGIN": "ግባ",
        "SELL_WITH_US": "እንደ ሻጭ ይመዝገቡ",
        "VENDOR_PORTAL": "የሻጭ መድረክ",
        "VENDOR_DASHBOARD": "የሻጭ ዳሽቦርድ",
        "APPLY_NOW": "አሁን ያመልክቱ",
        "SIGN_IN_ACCESS": "መለያዎን ለመክፈት ይግቡ",
        "SEARCH_PROMPT": "ምርቶችን፣ ብራንዶችን እና ምድቦችን ይፈልጉ...",
        "FULL_NAME_REQUIRED": "ሙሉ ስም *",
        "PHONE_REQUIRED": "ስልክ ቁጥር *",
        "BACKUP_PHONE": "ተጨማሪ ስልክ ቁጥር",
        "FULL_ADDRESS": "ሙሉ አድራሻ (መንገድ፣ ህንፃ፣ ከተማ) *",
        "CITY": "ከተማ *",
        "COUNTRY": "አገር *",
        "STREET": "መንገድ እና ህንፃ",
        "POSTAL_CODE": "የፖስታ ኮድ",
        "PAYMENT_METHOD": "የክፍያ ዘዴ",
        "CREDIT_DEBIT_CARD": "ክሬዲት / ዴቢት ካርድ / Apple Pay",
        "PAY_CARD_DESC": "ፈጣን እና ደህንነቱ የተጠበቀ ክፍያ።",
        "CASH_ON_DELIVERY": "በእጅ ሲደርስ መክፈል",
        "PAY_CASH_DESC": "ዕቃው በእጅዎ ሲደርስ በጥሬ ገንዘብ ይክፈሉ።",
        "MOBILE_WALLET": "ቴሌብር / የሞባይል ባንኪንግ",
        "PAY_WALLET_DESC": "በሞባይል የክፍያ አማራጮች በቀጥታ ይክፈሉ።",
        "BANK_TRANSFER": "የባንክ ዝውውር",
        "PAY_BANK_DESC": "ወደ ኩባንያው ኦፊሴላዊ የባንክ ሂሳብ በቀጥታ ያስተላልፉ።",
        "UPLOAD_RECEIPT": "የደረሰኝ ፎቶ ያያይዙ",
        "PROCESSING_ORDER": "ትዕዛዝዎ በመካሄድ ላይ ነው...",
        "PLACE_ORDER": "ትዕዛዙን ያረጋግጡ",
        "TAX": "ተጨማሪ እሴት ታክስ (VAT)",
        "QTY": "ብዛት",
        "FOR_YOU": "ለእርስዎ የተመረጡ",
        "BACK_TO_FEED": "← ወደ ጋለሪ ተመለስ",
        "NO_CONTENT_FOUND": "በአሁኑ ጊዜ ምንም ይዘት የለም።",
        "PRIORITY_GLOBAL_DELIVERY": "ፈጣን አለምአቀፍ መላኪያ",
        "PRIORITY_GLOBAL_DELIVERY_DESC": "ፈጣን እና ዋስትና ያለው አለምአቀፍ ትራንዚት",
        "SECURE_CHECKOUT_TITLE": "100% አስተማማኝ ክፍያ",
        "SECURE_CHECKOUT_DESC": "የተመሰጠረ ግብይት እና የገዢ ጥበቃ",
        "CURATED_AUTHENTICITY": "ትክክለኛ እና የተመረጡ ምርቶች",
        "CURATED_AUTHENTICITY_DESC": "ከመላኩ በፊት ጥራቱ የተረጋገጠ",
        "DEDICATED_CONCIERGE": "24/7 የቪአይፒ ድጋፍ",
        "DEDICATED_CONCIERGE_DESC": "የሙሉ ሰዓት ቅድሚያ እርዳታ",
        "CUSTOMER_CARE": "የደንበኞች አገልግሎት",
        "TRACK_ORDER": "ትዕዛዝ ይከታተሉ",
        "VIP_CLUB": "የቪአይፒ ክለብ",
        "HELP_SUPPORT": "እርዳታ እና ድጋፍ",
        "ABOUT_LUXVONO": "ስለ LUXVONO",
        "ABOUT_US_VISION": "ስለ እኛ እና ራዕያችን",
        "SUPPLIER_PORTAL": "የአቅራቢዎች መግቢያ",
        "LUXVONO_MAGAZINE": "የ LUXVONO መጽሔት",
        "TERMS_CONDITIONS": "ውሎች እና ሁኔታዎች",
        "PRIVACY_POLICY": "የግላዊነት መመሪያ",
        "SECURE_PAYMENTS": "ደህንነቱ የተጠበቀ ክፍያ",
        "CONTACT_CONCIERGE_BTN": "ቪአይፒ አስተዳዳሪን ያነጋግሩ ✦",
        "DIRECT_VIP_PHONE": "የቀጥታ ቪአይፒ ስልክ",
        "OFFICIAL_SUPPORT_EMAIL": "ኦፊሴላዊ የኢሜል አድራሻ",
        "GLOBAL_STANDARDS": "የአለም አቀፍ የቅንጦት ንግድ ደረጃዎች",
        "CONNECT_WITH_US": "ማህበራዊ ሚዲያችንን ይከተሉ:",
        "EMAIL_ADDRESS": "የኢሜይል አድራሻ",
        "PASSWORD": "የይለፍ ቃል",
        "FORGOT_PASSWORD": "የይለፍ ቃል ረሱ?",
        "AUTHENTICATING": "በማረጋገጥ ላይ...",
        "OR_CONTINUE_WITH": "ወይም በዚህ ይቀጥሉ",
        "NEW_TO_LUXVONO": "ለ LUXVONO አዲስ ነዎት?",
        "CREATE_ACCOUNT_DESC": "ልዩ ቅናሾችን እና ፈጣን አገልግሎትን ለማግኘት አዲስ መለያ ይክፈቱ።",
        "CREATE_ACCOUNT_BTN": "አዲስ መለያ ይክፈቱ ✦",
        "JOIN_LUXVONO": "LUXVONOን ይቀላቀሉ",
        "ENTER_EMAIL_START": "የግል መለያዎን ለመጀመር ኢሜይልዎን ያስገቡ።",
        "COMPLETE_SETUP": "የመለያ ማዋቀርን ያጠናቅቁ",
        "VERIFY_EMAIL": "ኢሜይልዎን ያረጋግጡ",
        "ENTER_6DIGIT_CODE": "መለያዎን ለማግበር የ 6 አሃዝ ኮድ ያስገቡ",
        "SECURE_ACCOUNT": "የእርስዎን የቅንጦት መለያ በደህንነት ይጠብቁ",
        "SENDING_CODE": "ኮድ በመላክ ላይ...",
        "CONTINUE": "ይቀጥሉ",
        "CODE_SENT_TO": "የተላከውን የ 6 አሃዝ ኮድ ያስገቡ ወደ:",
        "DIDNT_RECEIVE_CODE": "ኮድ አልደረሰዎትም? በድጋሚ ይላኩ ከ",
        "RESEND_VERIFICATION_CODE": "↻ የማረጋገጫ ኮድ በድጋሚ ላክ",
        "VERIFY_CODE": "ኮድ አረጋግጥ",
        "VERIFYING": "በማረጋገጥ ላይ...",
        "CHANGE_EMAIL": "ኢሜይል አድራሻ ቀይር",
        "FIRST_NAME": "ስም",
        "LAST_NAME": "የአባት ስም",
        "PHONE_OPTIONAL": "ስልክ ቁጥር (አማራጭ)",
        "PASSWORD_REQUIREMENTS": "የይለፍ ቃል ቢያንስ 8 ፊደላት እና ቁጥሮችን መያዝ አለበት።",
        "CREATING_ACCOUNT": "መለያ በመፍጠር ላይ...",
        "CREATE_ACCOUNT_SIGN_IN": "መለያ ፍጠር እና ግባ",
        "ALREADY_HAVE_ACCOUNT": "መለያ አለዎት?",
        "ALREADY_HAVE_ACCOUNT_DESC": "ትዕዛዞችን ለመከታተል ወደ መለያዎ ይግቡ።",
        "SIGN_IN_TO_ACCOUNT": "ወደ መለያ ግባ →",
        "RESET_PASSWORD": "የይለፍ ቃል ዳግም አስጀምር",
        "FORGOT_PASSWORD_SUBTITLE": "የይለፍ ቃል ለመቀየር ኢሜይልዎን ያስገቡ።",
        "NEW_PASSWORD": "አዲስ የይለፍ ቃል",
        "ENTER_NEW_PASSWORD": "አዲስ ጠንካራ የይለፍ ቃል ያስገቡ።",
        "SEND_RESET_LINK": "የማረጋገጫ ኮድ ላክ",
        "REMEMBER_PASSWORD": "የይለፍ ቃል አስታወሱ?",
        "REMEMBER_PASSWORD_DESC": "ወደ መግቢያ ገጽ ተመልሰው መግዛት መቀጠል ይችላሉ።",
        "BACK_TO_SIGN_IN": "ወደ መግቢያ ተመለስ →",
        "STORE_RATING": "የመደብር ደረጃ",
        "ON_TIME_DELIVERY": "በሰዓቱ ማድረስ",
        "RESPONSE_TIME": "የምላሽ ፍጥነት",
        "CUSTOM_LOGO": "✓ ብጁ አርማ",
        "CUSTOM_PACKAGING": "✓ ብጁ ማሸጊያ",
        "CUSTOMER_REVIEWS": "የደንበኞች አስተያየት",
        "VIEW_REVIEWS": "አስተያየቶችን ይመልከቱ ✦",
        "WHOLESALE_ACTIVE": "የጅምላ ዋጋ ገቢር ሆኗል",
        "LOWEST_PRICE_GUARANTEE": "🔥 ዝቅተኛ ዋጋ ዋስትና",
        "ALWAYS_AVAILABLE": "ሁልጊዜ ዝግጁ",
        "OUT_OF_STOCK": "አልቋል",
        "ONLY_1_LEFT": "1 ብቻ ቀርቷል!",
        "ONLY_FEW_LEFT": "ጥቂት ብቻ ቀርተዋል!",
        "LIMITED_QUANTITY": "የተወሰነ መጠን",
        "REMAINING_STOCK": "በክምችት የቀረ",
        "WHOLESALE_AVAILABLE": "💎 የጅምላ ሽያጭ ይገኛል",
        "ESTIMATED_DELIVERY": "የሚደርስበት ግምት",
        "PRODUCT_VIDEO_INCLUDED": "የምርት ቪዲዮ ይገኛል",
        "SCENT_SIGNATURE": "የሽቶ መዓዛ ዝርዝር",
        "SCENT_FAMILY": "የመዓዛ ዓይነት:",
        "TOP_NOTES": "የላይኛው መዓዛ",
        "HEART_NOTES": "ዋና መዓዛ",
        "BASE_NOTES": "የስረ መዓዛ",
        "INGREDIENTS": "ግብዓቶች:",
        "VEHICLE_SPECS": "የቅንጦት መኪና ዝርዝሮች",
        "MODEL": "ሞዴል",
        "YEAR": "ዓመት",
        "MILEAGE": "የተጓዘው ርቀት",
        "ENGINE": "ሞተር",
        "TRANSMISSION": "ማስተላለፊያ",
        "SHOWROOM_LOCATION": "ቪአይፒ ሾውሩም",
        "UNMUTE": "ድምጽ ክፈት 🔊",
        "MUTE": "ድምጽ ዝጋ 🔇",
        "ZOOM_IN": "አጉላ",
        "ZOOM_OUT": "አሳንስ"
    }
};

export const getTranslation = (key) => {
    try {
        const lang = getCurrentLanguage();

        if (translations[lang] && translations[lang][key]) {
            return translations[lang][key];
        }
        if (translations['ar'] && translations['ar'][key]) {
            return translations['ar'][key];
        }
        if (translations['en'] && translations['en'][key]) {
            return translations['en'][key];
        }
        if (typeof key === 'string') {
            return key.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
        }
        return key;
    } catch (e) {
        return key;
    }
};

export const getCurrentLanguage = () => {
    try {
        if (typeof window !== 'undefined' && window.location && window.location.pathname) {
            const parts = window.location.pathname.split('/').filter(Boolean);
            for (const part of parts) {
                if (SUPPORTED_LANGUAGES.some(l => l.code === part)) {
                    return part;
                }
            }
        }
        const geoContextStr = localStorage.getItem('luxvono_geo_context');
        const geoContext = geoContextStr ? JSON.parse(geoContextStr) : null;
        if (geoContext && geoContext.language) return geoContext.language;
        const explicit = localStorage.getItem('luxvono_user_explicit_language');
        if (explicit) return explicit;
        return 'ar';
    } catch (e) {
        return 'ar';
    }
};

export const isRTL = () => {
    try {
        const lang = getCurrentLanguage();
        return lang === 'ar' || lang === 'gdq' || lang === 'fa' || lang === 'ur';
    } catch (e) {
        return false;
    }
};

export const setLanguage = (langCode) => {
    try {
        const geoContextStr = localStorage.getItem('luxvono_geo_context');
        let geoContext = geoContextStr ? JSON.parse(geoContextStr) : {};
        geoContext.language = langCode;
        geoContext.userExplicitLanguage = true;
        
        localStorage.setItem('luxvono_user_explicit_language', langCode);
        localStorage.setItem('luxvono_language_lock', 'true');
        localStorage.setItem('luxvono_geo_context', JSON.stringify(geoContext));
        
        // Update document attributes
        if (typeof document !== 'undefined') {
            const rtl = langCode === 'ar' || langCode === 'gdq' || langCode === 'fa' || langCode === 'ur';
            document.documentElement.dir = rtl ? 'rtl' : 'ltr';
            document.documentElement.lang = langCode;
        }

        // Dispatch custom events for immediate UI updates
        window.dispatchEvent(new Event('languageChange'));
        window.dispatchEvent(new Event('geoContextChange'));
    } catch (e) {
        console.error("Failed to set language", e);
    }
};

/**
 * High-End Multilingual Error Translation Engine
 * Translates technical timeouts, network disconnects, and backend validation
 * errors into the active visitor language automatically.
 */
const ERROR_DICTIONARY = {
    timeout: {
        ar: "استغرقت الاستجابة وقتاً أطول من المتوقع، يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
        en: "The request timed out. Please check your connection and try again.",
        so: "Codsigii wuxuu qaatay waqti dheer. Fadlan hubi khadkaaga oo mar kale isku day.",
        fr: "Le délai d'attente a expiré. Veuillez vérifier votre connexion et réessayer.",
        es: "Se agotó el tiempo de espera. Comprueba tu conexión e inténtalo de nuevo.",
        de: "Zeitüberschreitung der Anforderung. Bitte überprüfen Sie Ihre Verbindung.",
        tr: "İstek zaman aşımına uğradı. Lütfen bağlantınızı kontrol edip tekrar deneyin.",
        zh: "请求超时，请检查网络连接后重试。",
        ru: "Время ожидания запроса истекло. Пожалуйста, проверьте подключение.",
        ja: "リクエストがタイムアウトしました。接続を確認して再試行してください。",
        ko: "요청 시간이 초과되었습니다. 네트워크 연결을 확인하고 다시 시도해 주세요.",
        am: "የጥያቄው ጊዜ አልቋል። እባክዎን ግንኙነትዎን ያረጋግጡና እንደገና ይሞክሩ።",
        gdq: "استغرقت الاستجابة وقتاً أطول من المتوقع، عاود المحاولة."
    },
    network: {
        ar: "تعذر الاتصال بالخادم، يرجى التأكد من اتصالك بالإنترنت.",
        en: "Unable to connect to the server. Please check your internet connection.",
        so: "Laguma xiriiri karo adeegaha. Fadlan hubi khadkaaga internet-ka.",
        fr: "Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet.",
        es: "No se pudo conectar al servidor. Comprueba tu conexión a Internet.",
        de: "Verbindung zum Server fehlgeschlagen. Bitte Internetverbindung prüfen.",
        tr: "Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.",
        zh: "无法连接到服务器，请检查网络连接。",
        ru: "Не удалось подключиться к серверу. Проверьте интернет-соединение.",
        ja: "サーバーに接続できません。インターネット接続を確認してください。",
        ko: "서버에 연결할 수 없습니다. 인터넷 연결을 확인해 주세요.",
        am: "ከአገልጋዩ ጋር መገናኘት አልተቻለም። እባክዎን የበይነመረብ ግንኙነትዎን ያረጋግጡ።",
        gdq: "تعذر الاتصال بالخادم، تأكد من الإنترنت."
    },
    invalid_credentials: {
        ar: "كلمة المرور غير صحيحة، يرجى التأكد والمحاولة مجدداً.",
        en: "Incorrect password, please verify and try again.",
        so: "Furaha sirta ah waa khalad, fadlan hubi oo mar kale isku day.",
        fr: "Mot de passe incorrect, veuillez vérifier et réessayer.",
        es: "Contraseña incorrecta, verifícala e inténtalo de nuevo.",
        de: "Falsches Passwort, bitte überprüfen und erneut versuchen.",
        tr: "Hatalı şifre, lütfen kontrol edip tekrar deneyin.",
        zh: "密码错误，请核对后重试。",
        ru: "Неверный пароль, пожалуйста, проверьте и повторите попытку.",
        ja: "パスワードが正しくありません。確認して再試行してください。",
        ko: "비밀번호가 올바르지 않습니다. 다시 시도해 주세요.",
        am: "የይለፍ ቃል የተሳሳተ ነው፣ እባክዎ እንደገና ይሞክሩ።",
        gdq: "كلمة المرور غير صحيحة، تأكد وحاول."
    },
    invalid_otp: {
        ar: "رمز التحقق غير صحيح أو منتهي الصلاحية، يرجى طلب رمز جديد.",
        en: "Invalid or expired verification code, please request a new one.",
        so: "Koodhka xaqiijinta waa khalad ama wuu dhacay, fadlan codso mid cusub.",
        fr: "Code de vérification invalide ou expiré, veuillez en demander un nouveau.",
        es: "Código de verificación inválido o vencido, solicita uno nuevo.",
        de: "Ungültiger oder abgelaufener Bestätigungscode, bitte neuen anfordern.",
        tr: "Doğrulama kodu geçersiz veya süresi dolmuş, lütfen yeni bir kod isteyin.",
        zh: "验证码无效或已过期，请重新获取。",
        ru: "Неверный или просроченный код подтверждения, запросите новый.",
        ja: "認証コードが無効または期限切れです。再取得してください。",
        ko: "인증 코드가 유효하지 않거나 만료되었습니다. 새 코드를 요청하세요.",
        am: "የማረጋገጫ ኮድ የተሳሳተ ወይም ጊዜው ያለፈበት ነው፣ እባክዎ አዲስ ኮድ ይጠይቁ።",
        gdq: "رمز التحقق غير صحيح أو منتهي، اطلب رمزاً جديداً."
    },
    banned_account: {
        ar: "تم حظر وتجميد حسابك، يرجى التواصل مع الدعم الفني.",
        en: "Your account is suspended or banned. Please contact technical support.",
        so: "Koontadaada waa la xannibay. Fadlan la xiriir kooxda taageerada farsamada.",
        fr: "Votre compte est suspendu. Veuillez contacter le support technique.",
        es: "Tu cuenta ha sido suspendida. Comunícate con soporte técnico.",
        de: "Ihr Konto wurde gesperrt. Bitte kontaktieren Sie den Kundensupport.",
        tr: "Hesabınız askıya alındı. Lütfen teknik destek ile iletişime geçin.",
        zh: "您的帐户已被封禁，请联系技术支持。",
        ru: "Ваш аккаунт заблокирован. Пожалуйста, обратитесь в службу поддержки.",
        ja: "アカウントが停止されています。テクニカルサポートにお問い合わせください。",
        ko: "계정이 정지되었습니다. 고객 지원팀에 문의해 주세요.",
        am: "መለያዎ ታግዷል። እባክዎን የቴክኒክ ድጋፍን ያነጋግሩ።",
        gdq: "تم حظر وتجميد حسابك، تواصل مع الدعم الفني."
    },
    user_not_found: {
        ar: "الحساب غير موجود، يرجى التحقق من البريد الإلكتروني.",
        en: "Account not found, please check your email address.",
        so: "Koontada lama helin, fadlan hubi cinwaankaaga email-ka.",
        fr: "Compte introuvable, veuillez vérifier votre adresse e-mail.",
        es: "Cuenta no encontrada, verifica tu correo electrónico.",
        de: "Konto nicht gefunden, bitte überprüfen Sie Ihre E-Mail-Adresse.",
        tr: "Hesap bulunamadı, lütfen e-posta adresinizi kontrol edin.",
        zh: "未找到帐户，请检查您的电子邮件地址。",
        ru: "Аккаунт не найден, проверьте адрес электронной почты.",
        ja: "アカウントが見つかりません。メールアドレスを確認してください。",
        ko: "계정을 찾을 수 없습니다. 이메일 주소를 확인해 주세요.",
        am: "መለያው አልተገኘም፣ እባክዎ የኢሜይል አድራሻዎን ያረጋግጡ።",
        gdq: "الحساب غير موجود، تأكد من البريد الإلكتروني."
    },
    email_exists: {
        ar: "البريد الإلكتروني مسجل بالفعل، يمكنك تسجيل الدخول مباشرة.",
        en: "Email is already registered. You can sign in directly.",
        so: "Email-kan horey ayaa loo diiwaangeliyay. Toos ayaad u gali kartaa.",
        fr: "Cet e-mail est déjà enregistré. Vous pouvez vous connecter directement.",
        es: "Este correo ya está registrado. Puedes iniciar sesión directamente.",
        de: "Diese E-Mail ist bereits registriert. Sie können sich direkt anmelden.",
        tr: "Bu e-posta zaten kayıtlı. Doğrudan giriş yapabilirsiniz.",
        zh: "该电子邮件已注册，您可以直接登录。",
        ru: "Этот email уже зарегистрирован. Вы можете войти напрямую.",
        ja: "このメールアドレスは既に登録されています。直接ログインできます。",
        ko: "이미 등록된 이메일입니다. 바로 로그인할 수 있습니다.",
        am: "ይህ ኢሜይል አስቀድሞ ተመዝግቧል። በቀጥታ መግባት ይችላሉ።",
        gdq: "البريد مسجل بالفعل، يمكنك الدخول مباشرة."
    },
    username_taken: {
        ar: "اسم المستخدم مأخوذ بالفعل، يرجى اختيار اسم آخر.",
        en: "Username is already taken, please choose another one.",
        so: "Magaca isticmaalaha horey ayaa loo qaatay, fadlan dooro mid kale.",
        fr: "Ce nom d'utilisateur est déjà pris, veuillez en choisir un autre.",
        es: "Este nombre de usuario ya está en uso, elige otro.",
        de: "Dieser Benutzername ist bereits vergeben, bitte wählen Sie einen anderen.",
        tr: "Bu kullanıcı adı zaten alınmış, lütfen başka bir ad seçin.",
        zh: "该用户名已被占用，请选择其他名称。",
        ru: "Это имя пользователя уже занято, выберите другое.",
        ja: "このユーザー名は既に使用されています。別の名前を選択してください。",
        ko: "이미 사용 중인 사용자 이름입니다. 다른 이름을 선택해 주세요.",
        am: "ይህ የተጠቃሚ ስም አስቀድሞ ተወስዷል፣ እባክዎ ሌላ ይምረጡ።",
        gdq: "اسم المستخدم مأخوذ بالفعل، اختر اسماً آخر."
    },
    invalid_email: {
        ar: "يرجى إدخال عنوان بريد إلكتروني صحيح.",
        en: "Please enter a valid email address.",
        so: "Fadlan geli cinwaan email sax ah.",
        fr: "Veuillez entrer une adresse e-mail valide.",
        es: "Introduce un correo electrónico válido.",
        de: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        tr: "Lütfen geçerli bir e-posta adresi girin.",
        zh: "请输入有效的电子邮件地址。",
        ru: "Пожалуйста, введите действительный адрес электронной почты.",
        ja: "有効なメールアドレスを入力してください。",
        ko: "유효한 이메일 주소를 입력해 주세요.",
        am: "እባክዎን ትክክለኛ የኢሜይል አድራሻ ያስገቡ።",
        gdq: "يرجى إدخال بريد إلكتروني صحيح."
    },
    enter_password: {
        ar: "يرجى إدخال كلمة المرور.",
        en: "Please enter your password.",
        so: "Fadlan geli furahaaga sirta ah.",
        fr: "Veuillez entrer votre mot de passe.",
        es: "Introduce tu contraseña.",
        de: "Bitte geben Sie Ihr Passwort ein.",
        tr: "Lütfen şifrenizi girin.",
        zh: "请输入您的密码。",
        ru: "Пожалуйста, введите свой пароль.",
        ja: "パスワードを入力してください。",
        ko: "비밀번호를 입력해 주세요.",
        am: "እባክዎ የይለፍ ቃልዎን ያስገቡ።",
        gdq: "يرجى إدخال كلمة المرور."
    },
    enter_name: {
        ar: "يرجى إدخال الاسم الأول واسم العائلة.",
        en: "Please enter your first and last name.",
        so: "Fadlan geli magacaaga hore iyo kan dambe.",
        fr: "Veuillez entrer votre prénom et nom.",
        es: "Introduce tu nombre y apellido.",
        de: "Bitte geben Sie Ihren Vor- und Nachnamen ein.",
        tr: "Lütfen adınızı ve soyadınızı girin.",
        zh: "请输入您的名和姓。",
        ru: "Пожалуйста, введите свое имя и фамилию.",
        ja: "姓名を入力してください。",
        ko: "이름과 성을 입력해 주세요.",
        am: "እባክዎ የመጀመሪያ እና የአባት ስምዎን ያስገቡ።",
        gdq: "يرجى إدخال الاسم الأول واسم العائلة."
    },
    password_length: {
        ar: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
        en: "Password must be at least 8 characters.",
        so: "Furaha sirta ah waa inuu ka koobnaadaa ugu yaraan 8 xaraf.",
        fr: "Le mot de passe doit comporter au moins 8 caractères.",
        es: "La contraseña debe tener al menos 8 caracteres.",
        de: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        tr: "Şifre en az 8 karakterden oluşmalıdır.",
        zh: "密码长度必须至少为8个字符。",
        ru: "Пароль должен состоять как минимум из 8 символов.",
        ja: "パスワードは8文字以上である必要があります。",
        ko: "비밀번호는 최소 8자 이상이어야 합니다.",
        am: "የይለፍ ቃሉ ቢያንስ 8 ቁምፊዎች መሆን አለበት።",
        gdq: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل."
    },
    choose_username: {
        ar: "يرجى اختيار اسم مستخدم متاح أو النقر على أحد الاقتراحات.",
        en: "Please choose an available username or click a suggestion.",
        so: "Fadlan dooro magac isticmaale oo furan ama taabo mid ka mid ah talooyinka.",
        fr: "Veuillez choisir un nom d'utilisateur disponible.",
        es: "Elige un nombre de usuario disponible o haz clic en una sugerencia.",
        de: "Bitte wählen Sie einen verfügbaren Benutzernamen.",
        tr: "Lütfen uygun bir kullanıcı adı seçin.",
        zh: "请选择可用的用户名或点击建议。",
        ru: "Пожалуйста, выберите доступное имя пользователя.",
        ja: "利用可能なユーザー名を選択してください。",
        ko: "사용 가능한 사용자 이름을 선택하거나 제안을 클릭하세요.",
        am: "እባክዎ የሚገኝ የተጠቃሚ ስም ይምረጡ።",
        gdq: "يرجى اختيار اسم مستخدم متاح."
    },
    google_failed: {
        ar: "فشل تسجيل الدخول عبر Google، يرجى المحاولة مرة أخرى.",
        en: "Google Sign-In failed, please try again.",
        so: "Ku gelitaanka Google wuu guuldareystay, fadlan mar kale isku day.",
        fr: "Échec de la connexion avec Google, veuillez réessayer.",
        es: "Error al iniciar sesión con Google, inténtalo de nuevo.",
        de: "Google-Anmeldung fehlgeschlagen, bitte erneut versuchen.",
        tr: "Google ile giriş başarısız oldu, lütfen tekrar deneyin.",
        zh: "Google 登录失败，请重试。",
        ru: "Ошибка входа через Google, пожалуйста, повторите попытку.",
        ja: "Google ログインに失敗しました。再試行してください。",
        ko: "Google 로그인에 실패했습니다. 다시 시도해 주세요.",
        am: "በGoogle መግባት አልተሳካም፣ እባክዎ እንደገና ይሞክሩ።",
        gdq: "فشل تسجيل الدخول عبر Google."
    },
    google_cancelled: {
        ar: "تم إلغاء عملية تسجيل الدخول عبر Google.",
        en: "Google Sign-In process was cancelled.",
        so: "Hawsha galitaanka Google waa la joojiyay.",
        fr: "La connexion Google a été annulée.",
        es: "Se canceló el inicio de sesión con Google.",
        de: "Google-Anmeldung wurde abgebrochen.",
        tr: "Google ile giriş iptal edildi.",
        zh: "Google 登录已取消。",
        ru: "Вход через Google был отменен.",
        ja: "Google ログインがキャンセルされました。",
        ko: "Google 로그인이 취소되었습니다.",
        am: "የGoogle መግባት ተሰርዟል።",
        gdq: "تم إلغاء تسجيل الدخول عبر Google."
    },
    generic_error: {
        ar: "حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى.",
        en: "An unexpected error occurred. Please try again.",
        so: "Khalad baa dhacay, fadlan mar kale isku day.",
        fr: "Une erreur inattendue s'est produite. Veuillez réessayer.",
        es: "Ocurrió un error inesperado. Inténtalo de nuevo.",
        de: "Ein unerwarteter Fehler ist aufgetreten. Bitte erneut versuchen.",
        tr: "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
        zh: "发生意外错误，请重试。",
        ru: "Произошла непредвиденная ошибка. Пожалуйста, повторите попытку.",
        ja: "予期しないエラーが発生しました。もう一度お試しください。",
        ko: "예기치 않은 오류가 발생했습니다. 다시 시도해 주세요.",
        am: "ያልተጠበቀ ስህተት ተከስቷል፣ እባክዎ እንደገና ይሞክሩ።",
        gdq: "حدث خطأ غير متوقع، عاود المحاولة."
    },
    otp_sent: {
        ar: "تم إرسال رمز التحقق إلى بريدك الإلكتروني.",
        en: "A verification code has been sent to your email.",
        so: "Koodka xaqiijinta waxaa loo diray iimaylkaaga.",
        fr: "Un code de vérification a été envoyé à votre adresse e-mail.",
        es: "Se ha enviado un código de verificación a tu correo electrónico.",
        de: "Ein Bestätigungscode wurde an Ihre E-Mail-Adresse gesendet.",
        tr: "Doğrulama kodu e-posta adresinize gönderildi.",
        zh: "验证码已发送至您的电子邮箱。",
        ru: "Код подтверждения отправлен на вашу электронную почту.",
        ja: "確認コードがメールに送信されました。",
        ko: "인증 코드가 이메일로 전송되었습니다.",
        am: "የማረጋገጫ ኮድ ወደ ኢሜይልዎ ተልኳል።",
        gdq: "تم إرسال رمز التحقق إلى بريدك الإلكتروني."
    },
    otp_confirmed: {
        ar: "تم تأكيد الرمز بنجاح!",
        en: "Verification code confirmed successfully!",
        so: "Koodka si guul leh ayaa loo xaqiijiyay!",
        fr: "Code de vérification confirmé avec succès !",
        es: "¡Código de verificación confirmado con éxito!",
        de: "Bestätigungscode erfolgreich bestätigt!",
        tr: "Doğrulama kodu başarıyla onaylandı!",
        zh: "验证码验证成功！",
        ru: "Код подтверждения успешно принят!",
        ja: "確認コードが正常に確認されました！",
        ko: "인증 코드가 성공적으로 확인되었습니다!",
        am: "የማረጋገጫ ኮድ በተሳካ ሁኔታ ተረጋግጧል!",
        gdq: "تم تأكيد الرمز بنجاح!"
    },
    resend_otp_countdown: {
        ar: "إعادة إرسال الرمز خلال",
        en: "Resend code in",
        so: "Dib u dir koodka",
        fr: "Renvoyer le code dans",
        es: "Reenviar código en",
        de: "Code erneut senden in",
        tr: "Kodu tekrar gönder:",
        zh: "重新发送验证码：",
        ru: "Повторно отправить код через",
        ja: "コードの再送信まで",
        ko: "코드 재전송까지",
        am: "ኮዱን እንደገና ለመላክ",
        gdq: "إعادة إرسال الرمز خلال"
    },
    resend_otp_btn: {
        ar: "إعادة إرسال رمز التحقق",
        en: "Resend Verification Code",
        so: "Dib u dir Koodka Xaqiijinta",
        fr: "Renvoyer le code de vérification",
        es: "Reenviar código de verificación",
        de: "Bestätigungscode erneut senden",
        tr: "Doğrulama Kodunu Tekrar Gönder",
        zh: "重新发送验证码",
        ru: "Отправить код подтверждения повторно",
        ja: "確認コードを再送信",
        ko: "인증 코드 재전송",
        am: "የማረጋገጫ ኮድ እንደገና ላክ",
        gdq: "إعادة إرسال رمز التحقق"
    },
    resend_otp_sending: {
        ar: "جاري الإرسال...",
        en: "Sending...",
        so: "Waa la dirayaa...",
        fr: "Envoi en cours...",
        es: "Enviando...",
        de: "Wird gesendet...",
        tr: "Gönderiliyor...",
        zh: "正在发送...",
        ru: "Отправка...",
        ja: "送信中...",
        ko: "전송 중...",
        am: "በመላክ ላይ...",
        gdq: "جاري الإرسال..."
    },
    username_min_length: {
        ar: "يجب أن يحتوي اسم المستخدم على 3 أحرف على الأقل.",
        en: "Username must be at least 3 characters.",
        so: "Magaca isticmaalaha waa inuu ka koobnaadaa ugu yaraan 3 xaraf.",
        fr: "Le nom d'utilisateur doit comporter au moins 3 caractères.",
        es: "El nombre de usuario debe tener al menos 3 caracteres.",
        de: "Der Benutzername muss mindestens 3 Zeichen lang sein.",
        tr: "Kullanıcı adı en az 3 karakterden oluşmalıdır.",
        zh: "用户名必须至少包含 3 个字符。",
        ru: "Имя пользователя должно содержать не менее 3 символов.",
        ja: "ユーザー名は3文字以上である必要があります。",
        ko: "사용자 이름은 3자 이상이어야 합니다.",
        am: "የተጠቃሚ ስም ቢያንስ 3 ቁምፊዎች መሆን አለበት።",
        gdq: "يجب أن يحتوي اسم المستخدم على 3 أحرف على الأقل."
    }
};

export const getAuthNotice = (key, forcedLang = null) => {
    const lang = forcedLang || getCurrentLanguage() || 'ar';
    const dict = ERROR_DICTIONARY[key];
    if (!dict) return '';
    return dict[lang] || dict['ar'] || dict['en'] || '';
};

export const translateError = (err, forcedLang = null) => {
    if (!err) return '';
    const lang = forcedLang || getCurrentLanguage() || 'ar';
    
    // Extract raw message string from Error object, Axios error, or string
    let raw = '';
    if (typeof err === 'string') {
        raw = err;
    } else if (err.response?.data?.message) {
        raw = err.response.data.message;
    } else if (err.message) {
        raw = err.message;
    } else {
        raw = String(err);
    }

    const lower = raw.toLowerCase();

    const pick = (key) => {
        const dict = ERROR_DICTIONARY[key];
        if (!dict) return raw;
        return dict[lang] || dict['ar'] || dict['en'] || raw;
    };

    // 1. Timeout / Request delay
    if (lower.includes('timeout') || lower.includes('exceeded') || lower.includes('timed out')) {
        return pick('timeout');
    }

    // 2. Network connectivity / Offline
    if (lower.includes('network error') || lower.includes('failed to fetch') || lower.includes('econnrefused') || lower.includes('enotfound')) {
        return pick('network');
    }

    // 3. Validation: Email
    if (lower.includes('valid email') || lower.includes('بريد إلكتروني صحيح') || lower.includes('email is required')) {
        return pick('invalid_email');
    }

    // 4. Validation: Password empty
    if (lower.includes('enter your password') || lower.includes('إدخال كلمة المرور')) {
        return pick('enter_password');
    }

    // 5. Validation: Password length
    if (lower.includes('8 characters') || lower.includes('8 أحرف') || lower.includes('password must be at least')) {
        return pick('password_length');
    }

    // 6. Validation: Name required
    if (lower.includes('first and last name') || lower.includes('الاسم الأول واسم العائلة')) {
        return pick('enter_name');
    }

    // 7. Validation: Choose username
    if (lower.includes('choose an available username') || lower.includes('اختيار اسم مستخدم')) {
        return pick('choose_username');
    }

    // 8. Google Login
    if (lower.includes('google sign-in') || lower.includes('google sign in') || lower.includes('تسجيل الدخول عبر google')) {
        return pick('google_failed');
    }
    if (lower.includes('cancelled') || lower.includes('إلغاء')) {
        return pick('google_cancelled');
    }

    // 9. Invalid credentials / Password wrong
    if (lower.includes('bad credentials') || lower.includes('invalid credentials') || lower.includes('incorrect password') || lower.includes('كلمة المرور غير صحيحة')) {
        return pick('invalid_credentials');
    }

    // 10. OTP invalid or expired
    if (lower.includes('otp') || lower.includes('رمز التحقق') || lower.includes('verification code') || lower.includes('expired')) {
        return pick('invalid_otp');
    }

    // 11. Account Banned / Disabled / Suspended
    if (lower.includes('disabled') || lower.includes('banned') || lower.includes('suspended') || lower.includes('حظر') || lower.includes('تجميد')) {
        return pick('banned_account');
    }

    // 12. User Not Found
    if (lower.includes('user not found') || lower.includes('account not found') || lower.includes('مستخدم غير موجود') || lower.includes('حساب غير موجود')) {
        return pick('user_not_found');
    }

    // 13. Email already registered
    if (lower.includes('email already') || lower.includes('البريد مسجل') || lower.includes('مسجل بالفعل')) {
        return pick('email_exists');
    }

    // 14. Username taken
    if (lower.includes('username') && (lower.includes('taken') || lower.includes('exists') || lower.includes('مستخدم بالفعل') || lower.includes('مأخوذ'))) {
        return pick('username_taken');
    }

    // If already localized custom message, preserve it
    if (raw && raw.length > 0 && !lower.includes('error') && !lower.includes('exception') && !lower.includes('failed')) {
        return raw;
    }

    return pick('generic_error');
};
